/* tslint:disable */
/* eslint-disable */
/**
 * Konnect Backend API
 * API for KonnectBetter mobile app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptFacilitatorInviteBody
 */
export interface AcceptFacilitatorInviteBody {
    /**
     * 
     * @type {number}
     * @memberof AcceptFacilitatorInviteBody
     */
    'relationshipId'?: number;
}
/**
 * 
 * @export
 * @interface ActiveSessionData
 */
export interface ActiveSessionData {
    /**
     * 
     * @type {boolean}
     * @memberof ActiveSessionData
     */
    'hasActiveSession': boolean;
    /**
     * 
     * @type {ActiveSessionDataSession}
     * @memberof ActiveSessionData
     */
    'session': ActiveSessionDataSession;
}
/**
 * 
 * @export
 * @interface ActiveSessionDataSession
 */
export interface ActiveSessionDataSession {
    /**
     * 
     * @type {number}
     * @memberof ActiveSessionDataSession
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ActiveSessionDataSession
     */
    'exerciseId': string | null;
    /**
     * 
     * @type {SessionStatus}
     * @memberof ActiveSessionDataSession
     */
    'status': SessionStatus;
    /**
     * 
     * @type {string}
     * @memberof ActiveSessionDataSession
     */
    'startedAt': string;
}


/**
 * 
 * @export
 * @interface ActiveSessionInfoData
 */
export interface ActiveSessionInfoData {
    /**
     * 
     * @type {number}
     * @memberof ActiveSessionInfoData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ActiveSessionInfoData
     */
    'exerciseId': string | null;
    /**
     * 
     * @type {SessionStatus}
     * @memberof ActiveSessionInfoData
     */
    'status': SessionStatus;
    /**
     * 
     * @type {string}
     * @memberof ActiveSessionInfoData
     */
    'startedAt': string;
}


/**
 * 
 * @export
 * @interface ActiveSessionResponse
 */
export interface ActiveSessionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ActiveSessionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {ActiveSessionData}
     * @memberof ActiveSessionResponse
     */
    'data': ActiveSessionData;
}
/**
 * 
 * @export
 * @interface ActivityData
 */
export interface ActivityData {
    /**
     * 
     * @type {number}
     * @memberof ActivityData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ActivityData
     */
    'resourceId': string;
    /**
     * 
     * @type {ActivityType}
     * @memberof ActivityData
     */
    'activityType': ActivityType;
    /**
     * 
     * @type {number}
     * @memberof ActivityData
     */
    'relationshipId': number | null;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof ActivityData
     */
    'payload': { [key: string]: any | null; } | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityData
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface ActivityListResponse
 */
export interface ActivityListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ActivityListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {Array<ActivityData>}
     * @memberof ActivityListResponse
     */
    'data': Array<ActivityData>;
}
/**
 * 
 * @export
 * @interface ActivitySummaryData
 */
export interface ActivitySummaryData {
    /**
     * 
     * @type {number}
     * @memberof ActivitySummaryData
     */
    'totalActivities': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ActivitySummaryData
     */
    'byType': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ActivitySummaryData
     */
    'byResource': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ActivitySummaryData
     */
    'streakDays': number;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryData
     */
    'lastActivityAt': string | null;
}
/**
 * 
 * @export
 * @interface ActivitySummaryResponse
 */
export interface ActivitySummaryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ActivitySummaryResponse
     */
    'success': boolean;
    /**
     * 
     * @type {ActivitySummaryData}
     * @memberof ActivitySummaryResponse
     */
    'data': ActivitySummaryData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ActivityType {
    ResourceStarted = 'resource_started',
    ResourceCompleted = 'resource_completed',
    ReflectionSubmitted = 'reflection_submitted',
    QuizScored = 'quiz_scored',
    ChapterAcknowledged = 'chapter_acknowledged',
    CardGameSessionEnded = 'card_game_session_ended',
    StepEngaged = 'step_engaged',
    ResultsReviewed = 'results_reviewed',
    GoDeeperUsed = 'go_deeper_used',
    CardReflectionSubmitted = 'card_reflection_submitted'
}


/**
 * 
 * @export
 * @interface AiChatRequestBody
 */
export interface AiChatRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AiChatRequestBody
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof AiChatRequestBody
     */
    'conversationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AiChatRequestBody
     */
    'initialAssistantMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AiChatRequestBody
     */
    'relationshipId'?: number;
}
/**
 * 
 * @export
 * @interface AiMessageBody
 */
export interface AiMessageBody {
    /**
     * 
     * @type {number}
     * @memberof AiMessageBody
     */
    'step': number;
    /**
     * 
     * @type {AiMessageBodyContext}
     * @memberof AiMessageBody
     */
    'context'?: AiMessageBodyContext;
}
/**
 * 
 * @export
 * @interface AiMessageBodyContext
 */
export interface AiMessageBodyContext {
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof AiMessageBodyContext
     */
    'previousAnswers'?: { [key: string]: any | null; };
}
/**
 * 
 * @export
 * @interface AiMessageData
 */
export interface AiMessageData {
    /**
     * 
     * @type {string}
     * @memberof AiMessageData
     */
    'personalizedQuestion': string | null;
    /**
     * 
     * @type {string}
     * @memberof AiMessageData
     */
    'subtitle': string | null;
    /**
     * 
     * @type {number}
     * @memberof AiMessageData
     */
    'step': number;
}
/**
 * 
 * @export
 * @interface AiMessageResponse
 */
export interface AiMessageResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AiMessageResponse
     */
    'success': boolean;
    /**
     * 
     * @type {AiMessageData}
     * @memberof AiMessageResponse
     */
    'data': AiMessageData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum AiResponseTone {
    Warm = 'warm',
    Thoughtful = 'thoughtful',
    Assertive = 'assertive',
    Real = 'real',
    Empathetic = 'empathetic',
    Nice = 'nice'
}


/**
 * 
 * @export
 * @interface AuthTokenResponseData
 */
export interface AuthTokenResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof AuthTokenResponseData
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponseData
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponseData
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponseData
     */
    'refreshToken': string;
    /**
     * 
     * @type {number}
     * @memberof AuthTokenResponseData
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponseData
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponseData
     */
    'expiresIn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponseData
     */
    'refreshExpiresIn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponseData
     */
    'deepLink'?: string;
}
/**
 * 
 * @export
 * @interface BookData
 */
export interface BookData {
    /**
     * 
     * @type {string}
     * @memberof BookData
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BookData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BookData
     */
    'author': string;
    /**
     * 
     * @type {string}
     * @memberof BookData
     */
    'coAuthor': string;
    /**
     * 
     * @type {string}
     * @memberof BookData
     */
    'type': BookDataType | null;
    /**
     * 
     * @type {string}
     * @memberof BookData
     */
    'purchaseUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof BookData
     */
    'coverUrl': string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum BookDataType {
    Sample = 'sample',
    Full = 'full'
}

/**
 * 
 * @export
 * @interface BookListResponse
 */
export interface BookListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BookListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {Array<BookData>}
     * @memberof BookListResponse
     */
    'data': Array<BookData>;
}
/**
 * 
 * @export
 * @interface BookProgressData
 */
export interface BookProgressData {
    /**
     * 
     * @type {number}
     * @memberof BookProgressData
     */
    'lastPage': number;
    /**
     * 
     * @type {number}
     * @memberof BookProgressData
     */
    'totalPages': number | null;
    /**
     * 
     * @type {string}
     * @memberof BookProgressData
     */
    'updatedAt': string | null;
}
/**
 * 
 * @export
 * @interface BookProgressResponse
 */
export interface BookProgressResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BookProgressResponse
     */
    'success': boolean;
    /**
     * 
     * @type {BookProgressData}
     * @memberof BookProgressResponse
     */
    'data': BookProgressData;
}
/**
 * 
 * @export
 * @interface CardData
 */
export interface CardData {
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'cardUid': string;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'insight': string | null;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'reflection': string | null;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'question1': string | null;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'question2': string | null;
    /**
     * 
     * @type {number}
     * @memberof CardData
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'titleFront': string;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'titleBack': string | null;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'quote': string | null;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    'quoteAuthor': string | null;
}
/**
 * 
 * @export
 * @interface CardGameTutorialData
 */
export interface CardGameTutorialData {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof CardGameTutorialData
     */
    'flags': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface CardGameTutorialResponse
 */
export interface CardGameTutorialResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CardGameTutorialResponse
     */
    'success': boolean;
    /**
     * 
     * @type {CardGameTutorialData}
     * @memberof CardGameTutorialResponse
     */
    'data': CardGameTutorialData;
}
/**
 * 
 * @export
 * @interface CardResponseData
 */
export interface CardResponseData {
    /**
     * 
     * @type {string}
     * @memberof CardResponseData
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof CardResponseData
     */
    'reflectionText': string | null;
    /**
     * 
     * @type {CardResponseDataDepthLevel}
     * @memberof CardResponseData
     */
    'depthLevel': CardResponseDataDepthLevel;
    /**
     * 
     * @type {ResponseStatus}
     * @memberof CardResponseData
     */
    'status': ResponseStatus;
    /**
     * 
     * @type {string}
     * @memberof CardResponseData
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface CardResponseDataDepthLevel
 */
export interface CardResponseDataDepthLevel {
}
/**
 * 
 * @export
 * @interface CheckReviewResponse
 */
export interface CheckReviewResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckReviewResponse
     */
    'success': boolean;
    /**
     * 
     * @type {CheckReviewResponseData}
     * @memberof CheckReviewResponse
     */
    'data': CheckReviewResponseData;
}
/**
 * 
 * @export
 * @interface CheckReviewResponseData
 */
export interface CheckReviewResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof CheckReviewResponseData
     */
    'reviewed': boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckReviewResponseData
     */
    'reason': string;
    /**
     * 
     * @type {number}
     * @memberof CheckReviewResponseData
     */
    'journeyId': number | null;
    /**
     * 
     * @type {number}
     * @memberof CheckReviewResponseData
     */
    'stepsCompleted': number;
    /**
     * 
     * @type {number}
     * @memberof CheckReviewResponseData
     */
    'hintsWritten': number;
    /**
     * 
     * @type {number}
     * @memberof CheckReviewResponseData
     */
    'modificationsProposed': number;
    /**
     * 
     * @type {Array<StepEvaluationData>}
     * @memberof CheckReviewResponseData
     */
    'stepEvaluations': Array<StepEvaluationData>;
}
/**
 * 
 * @export
 * @interface CommunitySignupBody
 */
export interface CommunitySignupBody {
    /**
     * 
     * @type {string}
     * @memberof CommunitySignupBody
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CommunitySignupBody
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CommunitySignupBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CommunitySignupBody
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunitySignupBody
     */
    'beta_tester'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunitySignupResponse
 */
export interface CommunitySignupResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommunitySignupResponse
     */
    'success': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunitySignupResponse
     */
    'existed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunitySignupResponse
     */
    'already_community_member'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunitySignupResponse
     */
    'already_beta_tester'?: boolean;
}
/**
 * 
 * @export
 * @interface CompleteOnboardingData
 */
export interface CompleteOnboardingData {
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof CompleteOnboardingData
     */
    'profile': { [key: string]: any | null; };
    /**
     * 
     * @type {Array<RecommendationData>}
     * @memberof CompleteOnboardingData
     */
    'recommendations': Array<RecommendationData>;
}
/**
 * 
 * @export
 * @interface CompleteOnboardingResponse
 */
export interface CompleteOnboardingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CompleteOnboardingResponse
     */
    'success': boolean;
    /**
     * 
     * @type {CompleteOnboardingData}
     * @memberof CompleteOnboardingResponse
     */
    'data': CompleteOnboardingData;
}
/**
 * 
 * @export
 * @interface CompleteQuizResponse
 */
export interface CompleteQuizResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CompleteQuizResponse
     */
    'success': boolean;
    /**
     * 
     * @type {CompleteQuizResponseData}
     * @memberof CompleteQuizResponse
     */
    'data': CompleteQuizResponseData;
}
/**
 * 
 * @export
 * @interface CompleteQuizResponseData
 */
export interface CompleteQuizResponseData {
    /**
     * 
     * @type {QuizResultData}
     * @memberof CompleteQuizResponseData
     */
    'result': QuizResultData;
    /**
     * 
     * @type {number}
     * @memberof CompleteQuizResponseData
     */
    'journalEntryId': number;
}
/**
 * 
 * @export
 * @interface ConfirmPhoneVerificationBody
 */
export interface ConfirmPhoneVerificationBody {
    /**
     * 
     * @type {string}
     * @memberof ConfirmPhoneVerificationBody
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ContactSubmissionBody
 */
export interface ContactSubmissionBody {
    /**
     * 
     * @type {string}
     * @memberof ContactSubmissionBody
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ContactSubmissionBody
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof ContactSubmissionBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactSubmissionBody
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ContactSubmissionResponse
 */
export interface ContactSubmissionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ContactSubmissionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactSubmissionResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ConversationData
 */
export interface ConversationData {
    /**
     * 
     * @type {string}
     * @memberof ConversationData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationData
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationData
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof ConversationData
     */
    'message_count'?: number;
}
/**
 * 
 * @export
 * @interface ConversationMessagesResponse
 */
export interface ConversationMessagesResponse {
    /**
     * 
     * @type {ConversationData}
     * @memberof ConversationMessagesResponse
     */
    'conversation': ConversationData;
    /**
     * 
     * @type {Array<MessageData>}
     * @memberof ConversationMessagesResponse
     */
    'messages': Array<MessageData>;
}
/**
 * 
 * @export
 * @interface ConversationStarter
 */
export interface ConversationStarter {
    /**
     * 
     * @type {string}
     * @memberof ConversationStarter
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationStarter
     */
    'response': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationStarter
     */
    'theme': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationStarter
     */
    'role'?: ConversationStarterRole;
}

/**
    * @export
    * @enum {string}
    */
export enum ConversationStarterRole {
    Assistant = 'assistant',
    User = 'user'
}

/**
 * 
 * @export
 * @interface CreateFacilitatorSessionBody
 */
export interface CreateFacilitatorSessionBody {
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'hostDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'inviteeName': string;
    /**
     * 
     * @type {FacilitatorRelationshipType}
     * @memberof CreateFacilitatorSessionBody
     */
    'relationshipType': FacilitatorRelationshipType;
    /**
     * 
     * @type {number}
     * @memberof CreateFacilitatorSessionBody
     */
    'relationshipId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'scheduledStart': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'timeZone': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFacilitatorSessionBody
     */
    'durationMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'musicTrackId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilitatorSessionBody
     */
    'personalNote': string;
}


/**
 * 
 * @export
 * @interface CrisisResourceData
 */
export interface CrisisResourceData {
    /**
     * 
     * @type {string}
     * @memberof CrisisResourceData
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CrisisResourceData
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrisisResourceData
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrisisResourceData
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface CrisisResourcesData
 */
export interface CrisisResourcesData {
    /**
     * 
     * @type {string}
     * @memberof CrisisResourcesData
     */
    'message': string;
    /**
     * 
     * @type {Array<CrisisResourceData>}
     * @memberof CrisisResourcesData
     */
    'resources': Array<CrisisResourceData>;
}
/**
 * 
 * @export
 * @interface DailyMessage
 */
export interface DailyMessage {
    /**
     * 
     * @type {string}
     * @memberof DailyMessage
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DailyMessage
     */
    'opening_message': string;
    /**
     * 
     * @type {string}
     * @memberof DailyMessage
     */
    'preview'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyMessage
     */
    'topic'?: string;
}
/**
 * 
 * @export
 * @interface DashboardResponse
 */
export interface DashboardResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DashboardResponse
     */
    'success': boolean;
    /**
     * 
     * @type {DashboardStatsData}
     * @memberof DashboardResponse
     */
    'data': DashboardStatsData;
}
/**
 * 
 * @export
 * @interface DashboardStatsData
 */
export interface DashboardStatsData {
    /**
     * 
     * @type {number}
     * @memberof DashboardStatsData
     */
    'totalRelationships': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardStatsData
     */
    'averageHealthScore': number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardStatsData
     */
    'needsAttentionCount': number;
    /**
     * 
     * @type {number}
     * @memberof DashboardStatsData
     */
    'checkInsThisMonth': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DashboardStatsData
     */
    'distributionByType': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface DeepenReflectionBody
 */
export interface DeepenReflectionBody {
    /**
     * 
     * @type {string}
     * @memberof DeepenReflectionBody
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DeepenReflectionBody
     */
    'insight': string;
    /**
     * 
     * @type {string}
     * @memberof DeepenReflectionBody
     */
    'reflection': string;
    /**
     * 
     * @type {string}
     * @memberof DeepenReflectionBody
     */
    'reflectionQuestion1': string;
    /**
     * 
     * @type {string}
     * @memberof DeepenReflectionBody
     */
    'reflectionQuestion2': string;
    /**
     * 
     * @type {string}
     * @memberof DeepenReflectionBody
     */
    'userReflection': string;
}
/**
 * 
 * @export
 * @interface DeleteResponse
 */
export interface DeleteResponse {
    /**
     * 
     * @type {string}
     * @memberof DeleteResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface DepthLevel
 */
export interface DepthLevel {
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EmotionalTone {
    Calm = 'calm',
    Anxious = 'anxious',
    Happy = 'happy',
    Stressed = 'stressed',
    Excited = 'excited',
    Sad = 'sad',
    Grateful = 'grateful',
    Frustrated = 'frustrated',
    Hopeful = 'hopeful',
    Overwhelmed = 'overwhelmed'
}


/**
 * 
 * @export
 * @interface EndSessionBody
 */
export interface EndSessionBody {
    /**
     * 
     * @type {boolean}
     * @memberof EndSessionBody
     */
    'abandoned'?: boolean;
}
/**
 * 
 * @export
 * @interface EndSessionResponse
 */
export interface EndSessionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EndSessionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {EndSessionResponseData}
     * @memberof EndSessionResponse
     */
    'data': EndSessionResponseData;
}
/**
 * 
 * @export
 * @interface EndSessionResponseData
 */
export interface EndSessionResponseData {
    /**
     * 
     * @type {number}
     * @memberof EndSessionResponseData
     */
    'id': number;
    /**
     * 
     * @type {SessionStatus}
     * @memberof EndSessionResponseData
     */
    'status': SessionStatus;
    /**
     * 
     * @type {string}
     * @memberof EndSessionResponseData
     */
    'completedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof EndSessionResponseData
     */
    'journalId': number | null;
    /**
     * 
     * @type {EndSessionSummaryData}
     * @memberof EndSessionResponseData
     */
    'summary': EndSessionSummaryData;
}


/**
 * 
 * @export
 * @interface EndSessionSummaryData
 */
export interface EndSessionSummaryData {
    /**
     * 
     * @type {number}
     * @memberof EndSessionSummaryData
     */
    'totalResponses': number;
    /**
     * 
     * @type {number}
     * @memberof EndSessionSummaryData
     */
    'completedResponses': number;
}
/**
 * 
 * @export
 * @interface EntityData
 */
export interface EntityData {
    /**
     * 
     * @type {string}
     * @memberof EntityData
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof EntityData
     */
    'user_id': number;
    /**
     * 
     * @type {EntityType}
     * @memberof EntityData
     */
    'entity_type': EntityType;
    /**
     * 
     * @type {string}
     * @memberof EntityData
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EntityData
     */
    'canonical_name': string;
    /**
     * 
     * @type {string}
     * @memberof EntityData
     */
    'relationship'?: string;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof EntityData
     */
    'metadata'?: { [key: string]: any | null; };
    /**
     * 
     * @type {number}
     * @memberof EntityData
     */
    'mention_count': number;
    /**
     * 
     * @type {string}
     * @memberof EntityData
     */
    'first_mentioned_at': string;
    /**
     * 
     * @type {string}
     * @memberof EntityData
     */
    'last_mentioned_at': string;
}


/**
 * 
 * @export
 * @interface EntityListResponse
 */
export interface EntityListResponse {
    /**
     * 
     * @type {Array<EntityData>}
     * @memberof EntityListResponse
     */
    'entities': Array<EntityData>;
    /**
     * 
     * @type {number}
     * @memberof EntityListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EntityType {
    Person = 'person',
    Place = 'place',
    Topic = 'topic',
    Organization = 'organization'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum EntryType {
    Exercise = 'exercise',
    Manual = 'manual',
    Facilitator = 'facilitator'
}


/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ErrorResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof ErrorResponse
     */
    'details'?: { [key: string]: any | null; };
}
/**
 * 
 * @export
 * @interface ExchangeAppleTokenBody
 */
export interface ExchangeAppleTokenBody {
    /**
     * 
     * @type {string}
     * @memberof ExchangeAppleTokenBody
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeAppleTokenBody
     */
    'email'?: string | null;
    /**
     * 
     * @type {ExchangeAppleTokenBodyFullName}
     * @memberof ExchangeAppleTokenBody
     */
    'fullName'?: ExchangeAppleTokenBodyFullName | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeAppleTokenBody
     */
    'identityToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeAppleTokenBody
     */
    'authorizationCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExchangeAppleTokenBody
     */
    'realUserStatus'?: number | null;
}
/**
 * 
 * @export
 * @interface ExchangeAppleTokenBodyFullName
 */
export interface ExchangeAppleTokenBodyFullName {
    /**
     * 
     * @type {string}
     * @memberof ExchangeAppleTokenBodyFullName
     */
    'givenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeAppleTokenBodyFullName
     */
    'familyName'?: string | null;
}
/**
 * 
 * @export
 * @interface ExchangeGoogleIdTokenBody
 */
export interface ExchangeGoogleIdTokenBody {
    /**
     * 
     * @type {string}
     * @memberof ExchangeGoogleIdTokenBody
     */
    'idToken': string;
}
/**
 * 
 * @export
 * @interface ExchangeGoogleTokenBody
 */
export interface ExchangeGoogleTokenBody {
    /**
     * 
     * @type {string}
     * @memberof ExchangeGoogleTokenBody
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface ExerciseDetailResponse
 */
export interface ExerciseDetailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ExerciseDetailResponse
     */
    'success': boolean;
    /**
     * 
     * @type {StrapiExerciseWithCardsData}
     * @memberof ExerciseDetailResponse
     */
    'data': StrapiExerciseWithCardsData;
}
/**
 * 
 * @export
 * @interface ExerciseListResponse
 */
export interface ExerciseListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ExerciseListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {Array<StrapiExerciseData>}
     * @memberof ExerciseListResponse
     */
    'data': Array<StrapiExerciseData>;
}
/**
 * 
 * @export
 * @interface ExerciseProgressData
 */
export interface ExerciseProgressData {
    /**
     * 
     * @type {StreakData}
     * @memberof ExerciseProgressData
     */
    'streak': StreakData;
    /**
     * 
     * @type {ReflectionsData}
     * @memberof ExerciseProgressData
     */
    'reflections': ReflectionsData;
    /**
     * 
     * @type {number}
     * @memberof ExerciseProgressData
     */
    'sessionsCompleted': number;
}
/**
 * 
 * @export
 * @interface ExerciseProgressResponse
 */
export interface ExerciseProgressResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ExerciseProgressResponse
     */
    'success': boolean;
    /**
     * 
     * @type {ExerciseProgressData}
     * @memberof ExerciseProgressResponse
     */
    'data': ExerciseProgressData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ExerciseType {
    CardGame = 'card_game',
    QuizSelfAssessment = 'quiz_self_assessment',
    QuizPsychNeeds = 'quiz_psych_needs',
    QuizRelationshipAssess = 'quiz_relationship_assess'
}


/**
 * 
 * @export
 * @interface ExtractedEntities
 */
export interface ExtractedEntities {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtractedEntities
     */
    'names'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtractedEntities
     */
    'relationships'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtractedEntities
     */
    'places'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtractedEntities
     */
    'topics'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FacilitatorAddNextStepBody
 */
export interface FacilitatorAddNextStepBody {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAddNextStepBody
     */
    'text': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorCheckInState {
    NotOpen = 'not_open',
    Pending = 'pending',
    Completed = 'completed',
    Skipped = 'skipped'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorDisplayStatus {
    NewInvitation = 'new_invitation',
    InvitationPending = 'invitation_pending',
    TimeProposed = 'time_proposed',
    InvitationAccepted = 'invitation_accepted',
    InvitationDeclined = 'invitation_declined',
    InvitationExpired = 'invitation_expired',
    Cancelled = 'cancelled',
    PreSessionCheckIn = 'pre_session_check_in',
    InProgress = 'in_progress',
    PostSessionCheckIn = 'post_session_check_in',
    Complete = 'complete'
}


/**
 * 
 * @export
 * @interface FacilitatorEndBody
 */
export interface FacilitatorEndBody {
    /**
     * 
     * @type {FacilitatorEndedBy}
     * @memberof FacilitatorEndBody
     */
    'endedBy': FacilitatorEndedBy;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorEndBody
     */
    'afterLongPause'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorEndReason {
    EndedByHost = 'ended_by_host',
    EndedByInvitee = 'ended_by_invitee',
    EndedTogether = 'ended_together',
    TimeElapsed = 'time_elapsed',
    WrappedUp = 'wrapped_up',
    Inactivity = 'inactivity',
    PauseTimeout = 'pause_timeout',
    Stale = 'stale'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorEndedBy {
    Host = 'host',
    Invitee = 'invitee',
    Both = 'both'
}


/**
 * 
 * @export
 * @interface FacilitatorExtendBody
 */
export interface FacilitatorExtendBody {
    /**
     * 
     * @type {number}
     * @memberof FacilitatorExtendBody
     */
    'minutes': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorGoalTag {
    ProcessEmotions = 'process_emotions',
    PrepareForResolution = 'prepare_for_resolution',
    GainClarity = 'gain_clarity',
    FeelHeard = 'feel_heard',
    UnderstandPerspective = 'understand_perspective',
    Other = 'other'
}


/**
 * 
 * @export
 * @interface FacilitatorInsightsData
 */
export interface FacilitatorInsightsData {
    /**
     * 
     * @type {Array<FacilitatorInsightsDataRecurringThemesInner>}
     * @memberof FacilitatorInsightsData
     */
    'recurringThemes': Array<FacilitatorInsightsDataRecurringThemesInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorInsightsData
     */
    'resolvedThemes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorInsightsData
     */
    'newThemes': Array<string>;
    /**
     * 
     * @type {Array<FacilitatorInsightsDataTimelineInner>}
     * @memberof FacilitatorInsightsData
     */
    'timeline': Array<FacilitatorInsightsDataTimelineInner>;
}
/**
 * 
 * @export
 * @interface FacilitatorInsightsDataRecurringThemesInner
 */
export interface FacilitatorInsightsDataRecurringThemesInner {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInsightsDataRecurringThemesInner
     */
    'theme': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorInsightsDataRecurringThemesInner
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface FacilitatorInsightsDataTimelineInner
 */
export interface FacilitatorInsightsDataTimelineInner {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInsightsDataTimelineInner
     */
    'sessionId': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInsightsDataTimelineInner
     */
    'date': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorInsightsDataTimelineInner
     */
    'themeTags': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorInsightsDataTimelineInner
     */
    'preRating': number | null;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorInsightsDataTimelineInner
     */
    'postRating': number | null;
}
/**
 * 
 * @export
 * @interface FacilitatorInsightsResponse
 */
export interface FacilitatorInsightsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorInsightsResponse
     */
    'success': boolean;
    /**
     * 
     * @type {FacilitatorInsightsResponseData}
     * @memberof FacilitatorInsightsResponse
     */
    'data': FacilitatorInsightsResponseData;
}
/**
 * 
 * @export
 * @interface FacilitatorInsightsResponseData
 */
export interface FacilitatorInsightsResponseData {
    /**
     * 
     * @type {Array<FacilitatorInsightsDataRecurringThemesInner>}
     * @memberof FacilitatorInsightsResponseData
     */
    'recurringThemes': Array<FacilitatorInsightsDataRecurringThemesInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorInsightsResponseData
     */
    'resolvedThemes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorInsightsResponseData
     */
    'newThemes': Array<string>;
    /**
     * 
     * @type {Array<FacilitatorInsightsDataTimelineInner>}
     * @memberof FacilitatorInsightsResponseData
     */
    'timeline': Array<FacilitatorInsightsDataTimelineInner>;
}
/**
 * 
 * @export
 * @interface FacilitatorInterruptedSession
 */
export interface FacilitatorInterruptedSession {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInterruptedSession
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInterruptedSession
     */
    'inviteeName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInterruptedSession
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInterruptedSession
     */
    'lastMessagePreview': string | null;
}
/**
 * 
 * @export
 * @interface FacilitatorInterruptedSessionsResponse
 */
export interface FacilitatorInterruptedSessionsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorInterruptedSessionsResponse
     */
    'success': boolean;
    /**
     * 
     * @type {Array<FacilitatorInterruptedSession>}
     * @memberof FacilitatorInterruptedSessionsResponse
     */
    'data': Array<FacilitatorInterruptedSession>;
}
/**
 * 
 * @export
 * @interface FacilitatorInvitePreviewData
 */
export interface FacilitatorInvitePreviewData {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInvitePreviewData
     */
    'hostFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInvitePreviewData
     */
    'scheduledStart': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorInvitePreviewData
     */
    'timeZone': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorInvitePreviewData
     */
    'durationMinutes': number;
    /**
     * 
     * @type {FacilitatorInvitePreviewState}
     * @memberof FacilitatorInvitePreviewData
     */
    'state': FacilitatorInvitePreviewState;
}


/**
 * 
 * @export
 * @interface FacilitatorInvitePreviewResponse
 */
export interface FacilitatorInvitePreviewResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorInvitePreviewResponse
     */
    'success': boolean;
    /**
     * 
     * @type {FacilitatorInvitePreviewData}
     * @memberof FacilitatorInvitePreviewResponse
     */
    'data': FacilitatorInvitePreviewData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorInvitePreviewState {
    Open = 'open',
    Accepted = 'accepted',
    Expired = 'expired',
    Closed = 'closed'
}


/**
 * 
 * @export
 * @interface FacilitatorJournalBody
 */
export interface FacilitatorJournalBody {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorJournalBody
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface FacilitatorJournalResponse
 */
export interface FacilitatorJournalResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorJournalResponse
     */
    'success': boolean;
    /**
     * 
     * @type {FacilitatorJournalResponseData}
     * @memberof FacilitatorJournalResponse
     */
    'data': FacilitatorJournalResponseData;
}
/**
 * 
 * @export
 * @interface FacilitatorJournalResponseData
 */
export interface FacilitatorJournalResponseData {
    /**
     * 
     * @type {number}
     * @memberof FacilitatorJournalResponseData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorJournalResponseData
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorJournalResponseData
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface FacilitatorLiveData
 */
export interface FacilitatorLiveData {
    /**
     * 
     * @type {FacilitatorLivePhase}
     * @memberof FacilitatorLiveData
     */
    'phase': FacilitatorLivePhase;
    /**
     * 
     * @type {FacilitatorParticipantRole}
     * @memberof FacilitatorLiveData
     */
    'currentSpeaker': FacilitatorParticipantRole;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveData
     */
    'currentSpeakerName': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorLiveData
     */
    'totalSeconds': number;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorLiveData
     */
    'elapsedSeconds': number;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorLiveData
     */
    'remainingSeconds': number;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveData
     */
    'windDown': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof FacilitatorLiveData
     */
    'extensionOptions': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveData
     */
    'wrapUpOfferExpiresAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveData
     */
    'graceEndsAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveData
     */
    'pausedAt': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveData
     */
    'longPause': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveData
     */
    'pauseSuggested': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveData
     */
    'inactivityPrompted': boolean;
    /**
     * 
     * @type {Array<FacilitatorLiveDataCrisisResourcesInner>}
     * @memberof FacilitatorLiveData
     */
    'crisisResources': Array<FacilitatorLiveDataCrisisResourcesInner> | null;
    /**
     * 
     * @type {FacilitatorLiveDataMusicTrack}
     * @memberof FacilitatorLiveData
     */
    'musicTrack': FacilitatorLiveDataMusicTrack;
    /**
     * 
     * @type {Array<FacilitatorLiveMessage>}
     * @memberof FacilitatorLiveData
     */
    'messages': Array<FacilitatorLiveMessage>;
}


/**
 * 
 * @export
 * @interface FacilitatorLiveDataCrisisResourcesInner
 */
export interface FacilitatorLiveDataCrisisResourcesInner {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveDataCrisisResourcesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveDataCrisisResourcesInner
     */
    'action': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveDataCrisisResourcesInner
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveDataCrisisResourcesInner
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface FacilitatorLiveDataMusicTrack
 */
export interface FacilitatorLiveDataMusicTrack {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveDataMusicTrack
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveDataMusicTrack
     */
    'title': string;
    /**
     * 
     * @type {FacilitatorMusicCategory}
     * @memberof FacilitatorLiveDataMusicTrack
     */
    'category': FacilitatorMusicCategory;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveDataMusicTrack
     */
    'url': string;
}


/**
 * 
 * @export
 * @interface FacilitatorLiveMessage
 */
export interface FacilitatorLiveMessage {
    /**
     * 
     * @type {number}
     * @memberof FacilitatorLiveMessage
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveMessage
     */
    'speaker': FacilitatorLiveMessageSpeaker;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveMessage
     */
    'speakerName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveMessage
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveMessage
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveMessage
     */
    'createdAt': string;
}

/**
    * @export
    * @enum {string}
    */
export enum FacilitatorLiveMessageSpeaker {
    Host = 'host',
    Invitee = 'invitee',
    Ai = 'ai'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorLivePhase {
    Turn = 'turn',
    AwaitingAi = 'awaiting_ai',
    Paused = 'paused',
    WrapUpOffer = 'wrap_up_offer',
    Crisis = 'crisis',
    Grace = 'grace',
    Ended = 'ended'
}


/**
 * 
 * @export
 * @interface FacilitatorLiveResultData
 */
export interface FacilitatorLiveResultData {
    /**
     * 
     * @type {FacilitatorSessionData}
     * @memberof FacilitatorLiveResultData
     */
    'session': FacilitatorSessionData;
    /**
     * 
     * @type {FacilitatorLiveResultDataLive}
     * @memberof FacilitatorLiveResultData
     */
    'live': FacilitatorLiveResultDataLive;
    /**
     * 
     * @type {Array<FacilitatorLiveMessage>}
     * @memberof FacilitatorLiveResultData
     */
    'closingMessages': Array<FacilitatorLiveMessage>;
}
/**
 * 
 * @export
 * @interface FacilitatorLiveResultDataLive
 */
export interface FacilitatorLiveResultDataLive {
    /**
     * 
     * @type {FacilitatorLivePhase}
     * @memberof FacilitatorLiveResultDataLive
     */
    'phase': FacilitatorLivePhase;
    /**
     * 
     * @type {FacilitatorParticipantRole}
     * @memberof FacilitatorLiveResultDataLive
     */
    'currentSpeaker': FacilitatorParticipantRole;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveResultDataLive
     */
    'currentSpeakerName': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorLiveResultDataLive
     */
    'totalSeconds': number;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorLiveResultDataLive
     */
    'elapsedSeconds': number;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorLiveResultDataLive
     */
    'remainingSeconds': number;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveResultDataLive
     */
    'windDown': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof FacilitatorLiveResultDataLive
     */
    'extensionOptions': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveResultDataLive
     */
    'wrapUpOfferExpiresAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveResultDataLive
     */
    'graceEndsAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorLiveResultDataLive
     */
    'pausedAt': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveResultDataLive
     */
    'longPause': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveResultDataLive
     */
    'pauseSuggested': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveResultDataLive
     */
    'inactivityPrompted': boolean;
    /**
     * 
     * @type {Array<FacilitatorLiveDataCrisisResourcesInner>}
     * @memberof FacilitatorLiveResultDataLive
     */
    'crisisResources': Array<FacilitatorLiveDataCrisisResourcesInner> | null;
    /**
     * 
     * @type {FacilitatorLiveDataMusicTrack}
     * @memberof FacilitatorLiveResultDataLive
     */
    'musicTrack': FacilitatorLiveDataMusicTrack;
    /**
     * 
     * @type {Array<FacilitatorLiveMessage>}
     * @memberof FacilitatorLiveResultDataLive
     */
    'messages': Array<FacilitatorLiveMessage>;
}


/**
 * 
 * @export
 * @interface FacilitatorLiveResultResponse
 */
export interface FacilitatorLiveResultResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorLiveResultResponse
     */
    'success': boolean;
    /**
     * 
     * @type {FacilitatorLiveResultData}
     * @memberof FacilitatorLiveResultResponse
     */
    'data': FacilitatorLiveResultData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorMood {
    Happy = 'happy',
    Calm = 'calm',
    Hopeful = 'hopeful',
    Curious = 'curious',
    Anxious = 'anxious',
    Frustrated = 'frustrated',
    Sad = 'sad',
    Angry = 'angry',
    Scared = 'scared',
    Numb = 'numb',
    Other = 'other'
}


/**
 * 
 * @export
 * @interface FacilitatorMusicCatalogData
 */
export interface FacilitatorMusicCatalogData {
    /**
     * 
     * @type {Array<FacilitatorMusicTrackData>}
     * @memberof FacilitatorMusicCatalogData
     */
    'tracks': Array<FacilitatorMusicTrackData>;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorMusicCatalogData
     */
    'defaultTrackId': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorMusicCatalogData
     */
    'noMusicId': FacilitatorMusicCatalogDataNoMusicId;
}

/**
    * @export
    * @enum {string}
    */
export enum FacilitatorMusicCatalogDataNoMusicId {
    None = 'none'
}

/**
 * 
 * @export
 * @interface FacilitatorMusicCatalogResponse
 */
export interface FacilitatorMusicCatalogResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorMusicCatalogResponse
     */
    'success': boolean;
    /**
     * 
     * @type {FacilitatorMusicCatalogData}
     * @memberof FacilitatorMusicCatalogResponse
     */
    'data': FacilitatorMusicCatalogData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorMusicCategory {
    Lofi = 'lofi',
    Classical = 'classical'
}


/**
 * 
 * @export
 * @interface FacilitatorMusicTrackData
 */
export interface FacilitatorMusicTrackData {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorMusicTrackData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorMusicTrackData
     */
    'title': string;
    /**
     * 
     * @type {FacilitatorMusicCategory}
     * @memberof FacilitatorMusicTrackData
     */
    'category': FacilitatorMusicCategory;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorMusicTrackData
     */
    'url': string;
}


/**
 * 
 * @export
 * @interface FacilitatorNextStepData
 */
export interface FacilitatorNextStepData {
    /**
     * 
     * @type {number}
     * @memberof FacilitatorNextStepData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorNextStepData
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorNextStepData
     */
    'resourceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorNextStepData
     */
    'resourceType': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorNextStepData
     */
    'resourceName': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorNextStepData
     */
    'source': FacilitatorNextStepDataSource;
    /**
     * 
     * @type {FacilitatorNextStepStatus}
     * @memberof FacilitatorNextStepData
     */
    'status': FacilitatorNextStepStatus;
}

/**
    * @export
    * @enum {string}
    */
export enum FacilitatorNextStepDataSource {
    Ai = 'ai',
    Custom = 'custom'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorNextStepStatus {
    NotStarted = 'not_started',
    InProgress = 'in_progress',
    Done = 'done'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorParticipantRole {
    Host = 'host',
    Invitee = 'invitee'
}


/**
 * 
 * @export
 * @interface FacilitatorPinBody
 */
export interface FacilitatorPinBody {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorPinBody
     */
    'pinned': boolean;
}
/**
 * 
 * @export
 * @interface FacilitatorPostCheckInBody
 */
export interface FacilitatorPostCheckInBody {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorPostCheckInBody
     */
    'skip'?: boolean;
    /**
     * 
     * @type {Array<FacilitatorMood>}
     * @memberof FacilitatorPostCheckInBody
     */
    'moods'?: Array<FacilitatorMood>;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPostCheckInBody
     */
    'moodOther'?: string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorPostCheckInBody
     */
    'relationshipRating'?: number;
    /**
     * 
     * @type {Array<FacilitatorReflectionTag>}
     * @memberof FacilitatorPostCheckInBody
     */
    'reflectionTags'?: Array<FacilitatorReflectionTag>;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPostCheckInBody
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorPostCheckInBody
     */
    'facilitatorRating'?: number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPostCheckInBody
     */
    'facilitatorFeedback'?: string;
}
/**
 * 
 * @export
 * @interface FacilitatorPreCheckInBody
 */
export interface FacilitatorPreCheckInBody {
    /**
     * 
     * @type {Array<FacilitatorMood>}
     * @memberof FacilitatorPreCheckInBody
     */
    'moods': Array<FacilitatorMood>;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPreCheckInBody
     */
    'moodOther'?: string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorPreCheckInBody
     */
    'relationshipRating'?: number;
    /**
     * 
     * @type {Array<FacilitatorGoalTag>}
     * @memberof FacilitatorPreCheckInBody
     */
    'goalTags': Array<FacilitatorGoalTag>;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPreCheckInBody
     */
    'goalOther'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPreCheckInBody
     */
    'context'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPreCheckInBody
     */
    'desiredOutcome'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorPreCheckInBody
     */
    'understandBetter'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorPreCheckInBody
     */
    'timedOut'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorReflectionTag {
    FeltHeard = 'felt_heard',
    GainedClarity = 'gained_clarity',
    BetterUnderstanding = 'better_understanding',
    FoundCommonGround = 'found_common_ground',
    ProcessedEmotions = 'processed_emotions',
    FeelMoreHopeful = 'feel_more_hopeful',
    NothingYet = 'nothing_yet',
    NeedMoreTime = 'need_more_time'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorRelationshipType {
    Partner = 'partner',
    Parent = 'parent',
    Child = 'child',
    Sibling = 'sibling',
    Friend = 'friend',
    Colleague = 'colleague',
    Other = 'other'
}


/**
 * 
 * @export
 * @interface FacilitatorReminderBody
 */
export interface FacilitatorReminderBody {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorReminderBody
     */
    'remindAt': string | null;
}
/**
 * 
 * @export
 * @interface FacilitatorSessionData
 */
export interface FacilitatorSessionData {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'id': string;
    /**
     * 
     * @type {FacilitatorParticipantRole}
     * @memberof FacilitatorSessionData
     */
    'myRole': FacilitatorParticipantRole;
    /**
     * 
     * @type {FacilitatorSessionStatus}
     * @memberof FacilitatorSessionData
     */
    'status': FacilitatorSessionStatus;
    /**
     * 
     * @type {FacilitatorDisplayStatus}
     * @memberof FacilitatorSessionData
     */
    'displayStatus': FacilitatorDisplayStatus;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'hostName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'inviteeName': string;
    /**
     * 
     * @type {FacilitatorRelationshipType}
     * @memberof FacilitatorSessionData
     */
    'relationshipType': FacilitatorRelationshipType;
    /**
     * 
     * @type {FacilitatorRelationshipType}
     * @memberof FacilitatorSessionData
     */
    'otherRelationshipType': FacilitatorRelationshipType;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionData
     */
    'inviteeJoined': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'inviteePhoneMasked': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'inviteUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'personalNote': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'scheduledStart': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'timeZone': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionData
     */
    'durationMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionData
     */
    'extendedMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'musicTrackId': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'inviteExpiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'inviteSmsStatus': string | null;
    /**
     * 
     * @type {FacilitatorSessionDataPendingProposal}
     * @memberof FacilitatorSessionData
     */
    'pendingProposal': FacilitatorSessionDataPendingProposal | null;
    /**
     * 
     * @type {FacilitatorCheckInState}
     * @memberof FacilitatorSessionData
     */
    'myPreCheckIn': FacilitatorCheckInState;
    /**
     * 
     * @type {FacilitatorCheckInState}
     * @memberof FacilitatorSessionData
     */
    'myPostCheckIn': FacilitatorCheckInState;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionData
     */
    'otherPreCheckInCompleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionData
     */
    'canStart': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'startWithoutAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'endedAt': string | null;
    /**
     * 
     * @type {FacilitatorEndReason}
     * @memberof FacilitatorSessionData
     */
    'endReason': FacilitatorEndReason;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'summaryStatus': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionData
     */
    'pinned': boolean;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionData
     */
    'myRelationshipId': number | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionData
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface FacilitatorSessionDataPendingProposal
 */
export interface FacilitatorSessionDataPendingProposal {
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionDataPendingProposal
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionDataPendingProposal
     */
    'scheduledStart': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionDataPendingProposal
     */
    'durationMinutes': number;
}
/**
 * 
 * @export
 * @interface FacilitatorSessionListItem
 */
export interface FacilitatorSessionListItem {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'id': string;
    /**
     * 
     * @type {FacilitatorParticipantRole}
     * @memberof FacilitatorSessionListItem
     */
    'myRole': FacilitatorParticipantRole;
    /**
     * 
     * @type {FacilitatorSessionStatus}
     * @memberof FacilitatorSessionListItem
     */
    'status': FacilitatorSessionStatus;
    /**
     * 
     * @type {FacilitatorDisplayStatus}
     * @memberof FacilitatorSessionListItem
     */
    'displayStatus': FacilitatorDisplayStatus;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'hostName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'inviteeName': string;
    /**
     * 
     * @type {FacilitatorRelationshipType}
     * @memberof FacilitatorSessionListItem
     */
    'relationshipType': FacilitatorRelationshipType;
    /**
     * 
     * @type {FacilitatorRelationshipType}
     * @memberof FacilitatorSessionListItem
     */
    'otherRelationshipType': FacilitatorRelationshipType;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionListItem
     */
    'inviteeJoined': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'inviteePhoneMasked': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'inviteUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'personalNote': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'scheduledStart': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'timeZone': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionListItem
     */
    'durationMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionListItem
     */
    'extendedMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'musicTrackId': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'inviteExpiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'inviteSmsStatus': string | null;
    /**
     * 
     * @type {FacilitatorSessionDataPendingProposal}
     * @memberof FacilitatorSessionListItem
     */
    'pendingProposal': FacilitatorSessionDataPendingProposal | null;
    /**
     * 
     * @type {FacilitatorCheckInState}
     * @memberof FacilitatorSessionListItem
     */
    'myPreCheckIn': FacilitatorCheckInState;
    /**
     * 
     * @type {FacilitatorCheckInState}
     * @memberof FacilitatorSessionListItem
     */
    'myPostCheckIn': FacilitatorCheckInState;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionListItem
     */
    'otherPreCheckInCompleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionListItem
     */
    'canStart': boolean;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'startWithoutAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'endedAt': string | null;
    /**
     * 
     * @type {FacilitatorEndReason & object}
     * @memberof FacilitatorSessionListItem
     */
    'endReason': FacilitatorEndReason & object;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'summaryStatus': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionListItem
     */
    'pinned': boolean;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSessionListItem
     */
    'myRelationshipId': number | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSessionListItem
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<FacilitatorGoalTag>}
     * @memberof FacilitatorSessionListItem
     */
    'myGoalTags': Array<FacilitatorGoalTag>;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionListItem
     */
    'nextStepsComplete': boolean;
}


/**
 * 
 * @export
 * @interface FacilitatorSessionListResponse
 */
export interface FacilitatorSessionListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {Array<FacilitatorSessionListItem>}
     * @memberof FacilitatorSessionListResponse
     */
    'data': Array<FacilitatorSessionListItem>;
}
/**
 * 
 * @export
 * @interface FacilitatorSessionResponse
 */
export interface FacilitatorSessionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSessionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {FacilitatorSessionData}
     * @memberof FacilitatorSessionResponse
     */
    'data': FacilitatorSessionData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FacilitatorSessionStatus {
    InvitationPending = 'invitation_pending',
    TimeProposed = 'time_proposed',
    InvitationAccepted = 'invitation_accepted',
    InvitationDeclined = 'invitation_declined',
    InvitationExpired = 'invitation_expired',
    Cancelled = 'cancelled',
    PreSessionCheckIn = 'pre_session_check_in',
    InProgress = 'in_progress',
    Paused = 'paused',
    Complete = 'complete'
}


/**
 * 
 * @export
 * @interface FacilitatorSharedSummaryData
 */
export interface FacilitatorSharedSummaryData {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryData
     */
    'hostName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryData
     */
    'inviteeName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryData
     */
    'hostThemes': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryData
     */
    'inviteeThemes': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryData
     */
    'commonGround': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryData
     */
    'areasToWorkThrough': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorSharedSummaryData
     */
    'themeTags': Array<string>;
    /**
     * 
     * @type {FacilitatorEndReason}
     * @memberof FacilitatorSharedSummaryData
     */
    'endReason': FacilitatorEndReason;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSharedSummaryData
     */
    'shortSession': boolean;
    /**
     * 
     * @type {FacilitatorSharedSummaryDataMeeting}
     * @memberof FacilitatorSharedSummaryData
     */
    'meeting': FacilitatorSharedSummaryDataMeeting;
}


/**
 * 
 * @export
 * @interface FacilitatorSharedSummaryDataMeeting
 */
export interface FacilitatorSharedSummaryDataMeeting {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryDataMeeting
     */
    'scheduledStart': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryDataMeeting
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSharedSummaryDataMeeting
     */
    'endedAt': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSharedSummaryDataMeeting
     */
    'durationMinutes': number;
}
/**
 * 
 * @export
 * @interface FacilitatorSummaryData
 */
export interface FacilitatorSummaryData {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryData
     */
    'status': FacilitatorSummaryDataStatus;
    /**
     * 
     * @type {FacilitatorSummaryDataShared}
     * @memberof FacilitatorSummaryData
     */
    'shared': FacilitatorSummaryDataShared;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryData
     */
    'privateReflection': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorSummaryData
     */
    'journalPrompts': Array<string>;
    /**
     * 
     * @type {Array<FacilitatorNextStepData>}
     * @memberof FacilitatorSummaryData
     */
    'nextSteps': Array<FacilitatorNextStepData>;
    /**
     * 
     * @type {FacilitatorSummaryDataJournal}
     * @memberof FacilitatorSummaryData
     */
    'journal': FacilitatorSummaryDataJournal | null;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryData
     */
    'remindAt': string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FacilitatorSummaryDataStatus {
    Pending = 'pending',
    Ready = 'ready',
    Failed = 'failed',
    Unavailable = 'unavailable'
}

/**
 * 
 * @export
 * @interface FacilitatorSummaryDataJournal
 */
export interface FacilitatorSummaryDataJournal {
    /**
     * 
     * @type {number}
     * @memberof FacilitatorSummaryDataJournal
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataJournal
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataJournal
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface FacilitatorSummaryDataShared
 */
export interface FacilitatorSummaryDataShared {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataShared
     */
    'hostName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataShared
     */
    'inviteeName': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataShared
     */
    'hostThemes': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataShared
     */
    'inviteeThemes': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataShared
     */
    'commonGround': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorSummaryDataShared
     */
    'areasToWorkThrough': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacilitatorSummaryDataShared
     */
    'themeTags': Array<string>;
    /**
     * 
     * @type {FacilitatorEndReason}
     * @memberof FacilitatorSummaryDataShared
     */
    'endReason': FacilitatorEndReason;
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSummaryDataShared
     */
    'shortSession': boolean;
    /**
     * 
     * @type {FacilitatorSharedSummaryDataMeeting}
     * @memberof FacilitatorSummaryDataShared
     */
    'meeting': FacilitatorSharedSummaryDataMeeting;
}


/**
 * 
 * @export
 * @interface FacilitatorSummaryResponse
 */
export interface FacilitatorSummaryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FacilitatorSummaryResponse
     */
    'success': boolean;
    /**
     * 
     * @type {FacilitatorSummaryData}
     * @memberof FacilitatorSummaryResponse
     */
    'data': FacilitatorSummaryData;
}
/**
 * 
 * @export
 * @interface FacilitatorTypedTurnBody
 */
export interface FacilitatorTypedTurnBody {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorTypedTurnBody
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface FacilitatorUpdateNextStepBody
 */
export interface FacilitatorUpdateNextStepBody {
    /**
     * 
     * @type {FacilitatorNextStepStatus}
     * @memberof FacilitatorUpdateNextStepBody
     */
    'status': FacilitatorNextStepStatus;
}


/**
 * 
 * @export
 * @interface FacilitatorWrapUpBody
 */
export interface FacilitatorWrapUpBody {
    /**
     * 
     * @type {string}
     * @memberof FacilitatorWrapUpBody
     */
    'decision': FacilitatorWrapUpBodyDecision;
}

/**
    * @export
    * @enum {string}
    */
export enum FacilitatorWrapUpBodyDecision {
    WrapUp = 'wrap_up',
    KeepGoing = 'keep_going',
    Timeout = 'timeout'
}

/**
 * 
 * @export
 * @interface GetContextSummary200Response
 */
export interface GetContextSummary200Response {
    /**
     * 
     * @type {string}
     * @memberof GetContextSummary200Response
     */
    'summary': string;
    /**
     * 
     * @type {number}
     * @memberof GetContextSummary200Response
     */
    'memory_count': number;
    /**
     * 
     * @type {number}
     * @memberof GetContextSummary200Response
     */
    'entity_count': number;
}
/**
 * Filter by relationship ID or \"general\" for unlinked
 * @export
 * @interface GetMemoriesRelationshipIdParameter
 */
export interface GetMemoriesRelationshipIdParameter {
}
/**
 * Filter by relationship ID or \"general\"
 * @export
 * @interface GetMemoryStatsRelationshipIdParameter
 */
export interface GetMemoryStatsRelationshipIdParameter {
}
/**
 * 
 * @export
 * @interface GetRelationshipGraph200Response
 */
export interface GetRelationshipGraph200Response {
    /**
     * 
     * @type {Array<EntityData>}
     * @memberof GetRelationshipGraph200Response
     */
    'nodes': Array<EntityData>;
    /**
     * 
     * @type {Array<GetRelationshipGraph200ResponseEdgesInner>}
     * @memberof GetRelationshipGraph200Response
     */
    'edges': Array<GetRelationshipGraph200ResponseEdgesInner>;
}
/**
 * 
 * @export
 * @interface GetRelationshipGraph200ResponseEdgesInner
 */
export interface GetRelationshipGraph200ResponseEdgesInner {
    /**
     * 
     * @type {string}
     * @memberof GetRelationshipGraph200ResponseEdgesInner
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelationshipGraph200ResponseEdgesInner
     */
    'target': string;
    /**
     * 
     * @type {string}
     * @memberof GetRelationshipGraph200ResponseEdgesInner
     */
    'relationship': string;
}
/**
 * 
 * @export
 * @interface IdParam
 */
export interface IdParam {
    /**
     * 
     * @type {number}
     * @memberof IdParam
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface JournalCreateBody
 */
export interface JournalCreateBody {
    /**
     * 
     * @type {string}
     * @memberof JournalCreateBody
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof JournalCreateBody
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof JournalCreateBody
     */
    'mood'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JournalCreateBody
     */
    'tags'?: Array<string>;
}
/**
 * 
 * @export
 * @interface JournalDeleteResponse
 */
export interface JournalDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof JournalDeleteResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof JournalDeleteResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface JournalEntryData
 */
export interface JournalEntryData {
    /**
     * 
     * @type {number}
     * @memberof JournalEntryData
     */
    'id': number;
    /**
     * 
     * @type {EntryType}
     * @memberof JournalEntryData
     */
    'entryType': EntryType;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryData
     */
    'exerciseType': string | null;
    /**
     * 
     * @type {number}
     * @memberof JournalEntryData
     */
    'sessionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryData
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryData
     */
    'content': string | null;
    /**
     * 
     * @type {Array<CardResponseData>}
     * @memberof JournalEntryData
     */
    'responses': Array<CardResponseData>;
    /**
     * 
     * @type {JournalEntryDataQuizResult}
     * @memberof JournalEntryData
     */
    'quizResult': JournalEntryDataQuizResult;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryData
     */
    'cardId'?: string | null;
    /**
     * 
     * @type {CardResponseDataDepthLevel}
     * @memberof JournalEntryData
     */
    'depthLevel'?: CardResponseDataDepthLevel;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryData
     */
    'mood': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JournalEntryData
     */
    'tags': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof JournalEntryData
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryData
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryData
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface JournalEntryDataQuizResult
 */
export interface JournalEntryDataQuizResult {
    /**
     * 
     * @type {number}
     * @memberof JournalEntryDataQuizResult
     */
    'totalScore': number;
    /**
     * 
     * @type {number}
     * @memberof JournalEntryDataQuizResult
     */
    'maxScore': number;
    /**
     * 
     * @type {number}
     * @memberof JournalEntryDataQuizResult
     */
    'percentage': number;
    /**
     * 
     * @type {{ [key: string]: QuizSubscaleResultData; }}
     * @memberof JournalEntryDataQuizResult
     */
    'subscales'?: { [key: string]: QuizSubscaleResultData; };
    /**
     * 
     * @type {Array<QuizInterpretationData>}
     * @memberof JournalEntryDataQuizResult
     */
    'interpretation': Array<QuizInterpretationData>;
    /**
     * 
     * @type {Array<QuizPerQuestionData>}
     * @memberof JournalEntryDataQuizResult
     */
    'perQuestion'?: Array<QuizPerQuestionData>;
}
/**
 * 
 * @export
 * @interface JournalEntryPreviewData
 */
export interface JournalEntryPreviewData {
    /**
     * 
     * @type {number}
     * @memberof JournalEntryPreviewData
     */
    'id': number;
    /**
     * 
     * @type {EntryType}
     * @memberof JournalEntryPreviewData
     */
    'entryType': EntryType;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryPreviewData
     */
    'exerciseType': string | null;
    /**
     * 
     * @type {number}
     * @memberof JournalEntryPreviewData
     */
    'sessionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryPreviewData
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryPreviewData
     */
    'content': string | null;
    /**
     * 
     * @type {Array<CardResponseData>}
     * @memberof JournalEntryPreviewData
     */
    'responses': Array<CardResponseData>;
    /**
     * 
     * @type {JournalEntryDataQuizResult}
     * @memberof JournalEntryPreviewData
     */
    'quizResult': JournalEntryDataQuizResult;
    /**
     * 
     * @type {Array<string>}
     * @memberof JournalEntryPreviewData
     */
    'tags': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof JournalEntryPreviewData
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof JournalEntryPreviewData
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface JournalEntryResponse
 */
export interface JournalEntryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof JournalEntryResponse
     */
    'success': boolean;
    /**
     * 
     * @type {JournalEntryData}
     * @memberof JournalEntryResponse
     */
    'data': JournalEntryData;
}
/**
 * 
 * @export
 * @interface JournalListResponse
 */
export interface JournalListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof JournalListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {JournalListResponseData}
     * @memberof JournalListResponse
     */
    'data': JournalListResponseData;
}
/**
 * 
 * @export
 * @interface JournalListResponseData
 */
export interface JournalListResponseData {
    /**
     * 
     * @type {Array<JournalEntryPreviewData>}
     * @memberof JournalListResponseData
     */
    'entries': Array<JournalEntryPreviewData>;
    /**
     * 
     * @type {PaginationData}
     * @memberof JournalListResponseData
     */
    'pagination': PaginationData;
}
/**
 * 
 * @export
 * @interface JournalUpdateBody
 */
export interface JournalUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof JournalUpdateBody
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof JournalUpdateBody
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof JournalUpdateBody
     */
    'mood'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JournalUpdateBody
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof JournalUpdateBody
     */
    'isFavorite'?: boolean;
}
/**
 * 
 * @export
 * @interface JourneyData
 */
export interface JourneyData {
    /**
     * 
     * @type {number}
     * @memberof JourneyData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof JourneyData
     */
    'relationshipId': number;
    /**
     * 
     * @type {JourneyStatus}
     * @memberof JourneyData
     */
    'status': JourneyStatus;
    /**
     * 
     * @type {string}
     * @memberof JourneyData
     */
    'aiRationale': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyData
     */
    'lastReviewedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyData
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof JourneyData
     */
    'completedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyData
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<JourneyStepData>}
     * @memberof JourneyData
     */
    'steps': Array<JourneyStepData>;
}


/**
 * 
 * @export
 * @interface JourneyResponse
 */
export interface JourneyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof JourneyResponse
     */
    'success': boolean;
    /**
     * 
     * @type {JourneyData}
     * @memberof JourneyResponse
     */
    'data': JourneyData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum JourneyStatus {
    Active = 'active',
    Paused = 'paused',
    Completed = 'completed',
    Abandoned = 'abandoned'
}


/**
 * 
 * @export
 * @interface JourneyStepData
 */
export interface JourneyStepData {
    /**
     * 
     * @type {number}
     * @memberof JourneyStepData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof JourneyStepData
     */
    'stepOrder': number;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'resourceType': string;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'resourceName': string;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'resourceParentName': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'resourceDescription': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'resourceCategory': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JourneyStepData
     */
    'resourceTags': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof JourneyStepData
     */
    'resourceDurationMinutes': number | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'resourceDifficulty': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JourneyStepData
     */
    'resourceUseCases': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JourneyStepData
     */
    'resourceLearningOutcomes': Array<string>;
    /**
     * 
     * @type {Array<any | null>}
     * @memberof JourneyStepData
     */
    'completenessChecklist': Array<any | null>;
    /**
     * 
     * @type {StepStatus}
     * @memberof JourneyStepData
     */
    'status': StepStatus;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'purposeStatement': string;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'titleOverride': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'skipReason': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'reviewReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'completionEvidence'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'userFeedback'?: string | null;
    /**
     * 
     * @type {Array<any | null>}
     * @memberof JourneyStepData
     */
    'partialCompletions': Array<any | null>;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'completedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'skippedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof JourneyStepData
     */
    'latestActivityType': string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum LearningPreference {
    Reading = 'reading',
    Interactive = 'interactive',
    AiConversations = 'ai_conversations',
    CardGames = 'card_games',
    Mix = 'mix'
}


/**
 * 
 * @export
 * @interface MagicLinkRequestResponseData
 */
export interface MagicLinkRequestResponseData {
    /**
     * 
     * @type {string}
     * @memberof MagicLinkRequestResponseData
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface MarkAllNotificationsReadResponse
 */
export interface MarkAllNotificationsReadResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MarkAllNotificationsReadResponse
     */
    'success': boolean;
    /**
     * 
     * @type {MarkAllNotificationsReadResponseData}
     * @memberof MarkAllNotificationsReadResponse
     */
    'data': MarkAllNotificationsReadResponseData;
}
/**
 * 
 * @export
 * @interface MarkAllNotificationsReadResponseData
 */
export interface MarkAllNotificationsReadResponseData {
    /**
     * 
     * @type {number}
     * @memberof MarkAllNotificationsReadResponseData
     */
    'updated': number;
}
/**
 * 
 * @export
 * @interface MemoryData
 */
export interface MemoryData {
    /**
     * 
     * @type {string}
     * @memberof MemoryData
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof MemoryData
     */
    'user_id': number;
    /**
     * 
     * @type {MemoryType}
     * @memberof MemoryData
     */
    'memory_type': MemoryType;
    /**
     * 
     * @type {string}
     * @memberof MemoryData
     */
    'content': string;
    /**
     * 
     * @type {number}
     * @memberof MemoryData
     */
    'importance_score': number;
    /**
     * 
     * @type {number}
     * @memberof MemoryData
     */
    'access_count': number;
    /**
     * 
     * @type {string}
     * @memberof MemoryData
     */
    'last_accessed_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof MemoryData
     */
    'conversation_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof MemoryData
     */
    'message_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof MemoryData
     */
    'relationship_id': number | null;
    /**
     * 
     * @type {MemoryDataTemporalData}
     * @memberof MemoryData
     */
    'temporal_data': MemoryDataTemporalData;
    /**
     * 
     * @type {MemoryDataEntities}
     * @memberof MemoryData
     */
    'entities': MemoryDataEntities;
    /**
     * 
     * @type {EmotionalTone}
     * @memberof MemoryData
     */
    'emotional_tone': EmotionalTone;
    /**
     * 
     * @type {Array<string>}
     * @memberof MemoryData
     */
    'tags': Array<string>;
    /**
     * 
     * @type {MemoryStatus}
     * @memberof MemoryData
     */
    'status': MemoryStatus;
    /**
     * 
     * @type {string}
     * @memberof MemoryData
     */
    'superseded_by': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoryData
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof MemoryData
     */
    'updated_at': string | null;
}


/**
 * 
 * @export
 * @interface MemoryDataEntities
 */
export interface MemoryDataEntities {
    /**
     * 
     * @type {Array<string>}
     * @memberof MemoryDataEntities
     */
    'names'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MemoryDataEntities
     */
    'relationships'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MemoryDataEntities
     */
    'places'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MemoryDataEntities
     */
    'topics'?: Array<string>;
}
/**
 * 
 * @export
 * @interface MemoryDataTemporalData
 */
export interface MemoryDataTemporalData {
    /**
     * 
     * @type {string}
     * @memberof MemoryDataTemporalData
     */
    'event_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemoryDataTemporalData
     */
    'event_type'?: MemoryDataTemporalDataEventType;
    /**
     * 
     * @type {string}
     * @memberof MemoryDataTemporalData
     */
    'event_time'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MemoryDataTemporalDataEventType {
    Past = 'past',
    Future = 'future',
    Recurring = 'recurring'
}

/**
 * 
 * @export
 * @interface MemoryListResponse
 */
export interface MemoryListResponse {
    /**
     * 
     * @type {Array<MemoryData>}
     * @memberof MemoryListResponse
     */
    'memories': Array<MemoryData>;
    /**
     * 
     * @type {number}
     * @memberof MemoryListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface MemoryStatsData
 */
export interface MemoryStatsData {
    /**
     * 
     * @type {number}
     * @memberof MemoryStatsData
     */
    'total': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MemoryStatsData
     */
    'byType': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MemoryStatsData
     */
    'byStatus': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof MemoryStatsData
     */
    'avgImportance': number;
}
/**
 * 
 * @export
 * @interface MemoryStatsResponse
 */
export interface MemoryStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof MemoryStatsResponse
     */
    'total': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MemoryStatsResponse
     */
    'byType': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MemoryStatsResponse
     */
    'byStatus': { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof MemoryStatsResponse
     */
    'avgImportance': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum MemoryStatus {
    Active = 'active',
    Archived = 'archived',
    Superseded = 'superseded'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum MemoryType {
    PersonalIdentity = 'personal_identity',
    Relationship = 'relationship',
    FamilyDynamic = 'family_dynamic',
    LifeEvent = 'life_event',
    EmotionalPattern = 'emotional_pattern',
    Preference = 'preference',
    GoalAspiration = 'goal_aspiration'
}


/**
 * 
 * @export
 * @interface MessageData
 */
export interface MessageData {
    /**
     * 
     * @type {string}
     * @memberof MessageData
     */
    'id'?: string;
    /**
     * 
     * @type {MessageRole}
     * @memberof MessageData
     */
    'role': MessageRole;
    /**
     * 
     * @type {string}
     * @memberof MessageData
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof MessageData
     */
    'created_at'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum MessageRole {
    User = 'user',
    Assistant = 'assistant',
    System = 'system'
}


/**
 * 
 * @export
 * @interface NorthStarRelationshipData
 */
export interface NorthStarRelationshipData {
    /**
     * 
     * @type {NorthStarType}
     * @memberof NorthStarRelationshipData
     */
    'type': NorthStarType;
    /**
     * 
     * @type {string}
     * @memberof NorthStarRelationshipData
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof NorthStarRelationshipData
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof NorthStarRelationshipData
     */
    'addedAt'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NorthStarType {
    Partner = 'partner',
    Spouse = 'spouse',
    Parent = 'parent',
    Child = 'child',
    Friend = 'friend',
    Sibling = 'sibling',
    Other = 'other'
}


/**
 * 
 * @export
 * @interface NotificationData
 */
export interface NotificationData {
    /**
     * 
     * @type {string}
     * @memberof NotificationData
     */
    'id': string;
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationData
     */
    'type': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof NotificationData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationData
     */
    'body': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof NotificationData
     */
    'data': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof NotificationData
     */
    'readAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationData
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface NotificationPageData
 */
export interface NotificationPageData {
    /**
     * 
     * @type {Array<NotificationData>}
     * @memberof NotificationPageData
     */
    'items': Array<NotificationData>;
    /**
     * 
     * @type {number}
     * @memberof NotificationPageData
     */
    'unreadCount': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationPageData
     */
    'nextCursor': string | null;
}
/**
 * 
 * @export
 * @interface NotificationPageResponse
 */
export interface NotificationPageResponse {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationPageResponse
     */
    'success': boolean;
    /**
     * 
     * @type {NotificationPageData}
     * @memberof NotificationPageResponse
     */
    'data': NotificationPageData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationType {
    FacilitatorInvite = 'facilitator.invite',
    FacilitatorInviteUndelivered = 'facilitator.invite_undelivered',
    FacilitatorUpdated = 'facilitator.updated',
    FacilitatorCancelled = 'facilitator.cancelled',
    FacilitatorAccepted = 'facilitator.accepted',
    FacilitatorDeclined = 'facilitator.declined',
    FacilitatorTimeProposed = 'facilitator.time_proposed',
    FacilitatorProposalRejected = 'facilitator.proposal_rejected',
    FacilitatorConfirmed = 'facilitator.confirmed',
    FacilitatorPreCheckIn = 'facilitator.pre_check_in',
    FacilitatorInviteeReady = 'facilitator.invitee_ready',
    FacilitatorPostCheckIn = 'facilitator.post_check_in',
    FacilitatorFollowUp = 'facilitator.follow_up'
}


/**
 * 
 * @export
 * @interface OnboardingDraftData
 */
export interface OnboardingDraftData {
    /**
     * 
     * @type {OnboardingDraftDataStep1}
     * @memberof OnboardingDraftData
     */
    'step_1'?: OnboardingDraftDataStep1 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep2}
     * @memberof OnboardingDraftData
     */
    'step_2'?: OnboardingDraftDataStep2 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep3}
     * @memberof OnboardingDraftData
     */
    'step_3'?: OnboardingDraftDataStep3 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep4}
     * @memberof OnboardingDraftData
     */
    'step_4'?: OnboardingDraftDataStep4 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep5}
     * @memberof OnboardingDraftData
     */
    'step_5'?: OnboardingDraftDataStep5 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep6}
     * @memberof OnboardingDraftData
     */
    'step_6'?: OnboardingDraftDataStep6 | null;
}
/**
 * 
 * @export
 * @interface OnboardingDraftDataStep1
 */
export interface OnboardingDraftDataStep1 {
    /**
     * 
     * @type {Array<NorthStarRelationshipData>}
     * @memberof OnboardingDraftDataStep1
     */
    'northStarRelationships': Array<NorthStarRelationshipData>;
}
/**
 * 
 * @export
 * @interface OnboardingDraftDataStep2
 */
export interface OnboardingDraftDataStep2 {
    /**
     * 
     * @type {number}
     * @memberof OnboardingDraftDataStep2
     */
    'relationshipSatisfaction': number;
}
/**
 * 
 * @export
 * @interface OnboardingDraftDataStep3
 */
export interface OnboardingDraftDataStep3 {
    /**
     * 
     * @type {Array<RelationshipGoal>}
     * @memberof OnboardingDraftDataStep3
     */
    'relationshipGoals': Array<RelationshipGoal>;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDraftDataStep3
     */
    'relationshipGoalsOther'?: string;
}
/**
 * 
 * @export
 * @interface OnboardingDraftDataStep4
 */
export interface OnboardingDraftDataStep4 {
    /**
     * 
     * @type {Array<PainPoint>}
     * @memberof OnboardingDraftDataStep4
     */
    'painPoints': Array<PainPoint>;
    /**
     * 
     * @type {string}
     * @memberof OnboardingDraftDataStep4
     */
    'painPointsOther'?: string;
}
/**
 * 
 * @export
 * @interface OnboardingDraftDataStep5
 */
export interface OnboardingDraftDataStep5 {
    /**
     * 
     * @type {UrgencyLevel}
     * @memberof OnboardingDraftDataStep5
     */
    'urgencyLevel': UrgencyLevel;
}


/**
 * 
 * @export
 * @interface OnboardingDraftDataStep6
 */
export interface OnboardingDraftDataStep6 {
    /**
     * 
     * @type {LearningPreference}
     * @memberof OnboardingDraftDataStep6
     */
    'learningPreference': LearningPreference;
}


/**
 * 
 * @export
 * @interface OnboardingProfileSummaryData
 */
export interface OnboardingProfileSummaryData {
    /**
     * 
     * @type {Array<NorthStarRelationshipData>}
     * @memberof OnboardingProfileSummaryData
     */
    'northStarRelationships': Array<NorthStarRelationshipData> | null;
    /**
     * 
     * @type {number}
     * @memberof OnboardingProfileSummaryData
     */
    'relationshipSatisfaction': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingProfileSummaryData
     */
    'relationshipGoalsSelected': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingProfileSummaryData
     */
    'painPoints': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OnboardingProfileSummaryData
     */
    'urgencyLevel': string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingProfileSummaryData
     */
    'learningPreference': string | null;
}
/**
 * 
 * @export
 * @interface OnboardingStatusData
 */
export interface OnboardingStatusData {
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStatusData
     */
    'needsOnboarding': boolean;
    /**
     * 
     * @type {number}
     * @memberof OnboardingStatusData
     */
    'currentStep': number;
    /**
     * 
     * @type {OnboardingStatusDataDraft}
     * @memberof OnboardingStatusData
     */
    'draft': OnboardingStatusDataDraft;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStatusData
     */
    'skippedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStatusData
     */
    'completedAt': string | null;
    /**
     * 
     * @type {OnboardingStatusDataProfile}
     * @memberof OnboardingStatusData
     */
    'profile': OnboardingStatusDataProfile;
}
/**
 * 
 * @export
 * @interface OnboardingStatusDataDraft
 */
export interface OnboardingStatusDataDraft {
    /**
     * 
     * @type {OnboardingDraftDataStep1}
     * @memberof OnboardingStatusDataDraft
     */
    'step_1'?: OnboardingDraftDataStep1 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep2}
     * @memberof OnboardingStatusDataDraft
     */
    'step_2'?: OnboardingDraftDataStep2 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep3}
     * @memberof OnboardingStatusDataDraft
     */
    'step_3'?: OnboardingDraftDataStep3 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep4}
     * @memberof OnboardingStatusDataDraft
     */
    'step_4'?: OnboardingDraftDataStep4 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep5}
     * @memberof OnboardingStatusDataDraft
     */
    'step_5'?: OnboardingDraftDataStep5 | null;
    /**
     * 
     * @type {OnboardingDraftDataStep6}
     * @memberof OnboardingStatusDataDraft
     */
    'step_6'?: OnboardingDraftDataStep6 | null;
}
/**
 * 
 * @export
 * @interface OnboardingStatusDataProfile
 */
export interface OnboardingStatusDataProfile {
    /**
     * 
     * @type {Array<NorthStarRelationshipData>}
     * @memberof OnboardingStatusDataProfile
     */
    'northStarRelationships': Array<NorthStarRelationshipData> | null;
    /**
     * 
     * @type {number}
     * @memberof OnboardingStatusDataProfile
     */
    'relationshipSatisfaction': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingStatusDataProfile
     */
    'relationshipGoalsSelected': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingStatusDataProfile
     */
    'painPoints': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStatusDataProfile
     */
    'urgencyLevel': string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStatusDataProfile
     */
    'learningPreference': string | null;
}
/**
 * 
 * @export
 * @interface OnboardingStatusResponse
 */
export interface OnboardingStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStatusResponse
     */
    'success': boolean;
    /**
     * 
     * @type {OnboardingStatusData}
     * @memberof OnboardingStatusResponse
     */
    'data': OnboardingStatusData;
}
/**
 * 
 * @export
 * @interface PaginationData
 */
export interface PaginationData {
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    'offset': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PainPoint {
    CommunicationBreakdowns = 'communication_breakdowns',
    TrustIssues = 'trust_issues',
    FrequentConflicts = 'frequent_conflicts',
    EmotionalDistance = 'emotional_distance',
    LackQualityTime = 'lack_quality_time',
    UnmetExpectations = 'unmet_expectations',
    Other = 'other'
}


/**
 * 
 * @export
 * @interface PhoneStatusData
 */
export interface PhoneStatusData {
    /**
     * 
     * @type {string}
     * @memberof PhoneStatusData
     */
    'phoneE164': string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneStatusData
     */
    'phoneMasked': string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneStatusData
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {PhoneStatusDataPending}
     * @memberof PhoneStatusData
     */
    'pending': PhoneStatusDataPending | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PhoneStatusData
     */
    'allowedCountries': Array<string>;
}
/**
 * 
 * @export
 * @interface PhoneStatusDataPending
 */
export interface PhoneStatusDataPending {
    /**
     * 
     * @type {string}
     * @memberof PhoneStatusDataPending
     */
    'phoneMasked': string;
    /**
     * 
     * @type {string}
     * @memberof PhoneStatusDataPending
     */
    'expiresAt': string;
}
/**
 * 
 * @export
 * @interface PhoneStatusResponse
 */
export interface PhoneStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PhoneStatusResponse
     */
    'success': boolean;
    /**
     * 
     * @type {PhoneStatusData}
     * @memberof PhoneStatusResponse
     */
    'data': PhoneStatusData;
}
/**
 * 
 * @export
 * @interface PhoneVerificationStartedData
 */
export interface PhoneVerificationStartedData {
    /**
     * 
     * @type {string}
     * @memberof PhoneVerificationStartedData
     */
    'phoneMasked': string;
    /**
     * 
     * @type {string}
     * @memberof PhoneVerificationStartedData
     */
    'expiresAt': string;
    /**
     * 
     * @type {number}
     * @memberof PhoneVerificationStartedData
     */
    'resendsRemaining': number;
}
/**
 * 
 * @export
 * @interface PhoneVerificationStartedResponse
 */
export interface PhoneVerificationStartedResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PhoneVerificationStartedResponse
     */
    'success': boolean;
    /**
     * 
     * @type {PhoneVerificationStartedData}
     * @memberof PhoneVerificationStartedResponse
     */
    'data': PhoneVerificationStartedData;
}
/**
 * 
 * @export
 * @interface PhoneVerifiedData
 */
export interface PhoneVerifiedData {
    /**
     * 
     * @type {string}
     * @memberof PhoneVerifiedData
     */
    'phoneE164': string;
    /**
     * 
     * @type {string}
     * @memberof PhoneVerifiedData
     */
    'phoneMasked': string;
    /**
     * 
     * @type {string}
     * @memberof PhoneVerifiedData
     */
    'verifiedAt': string;
}
/**
 * 
 * @export
 * @interface PhoneVerifiedResponse
 */
export interface PhoneVerifiedResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PhoneVerifiedResponse
     */
    'success': boolean;
    /**
     * 
     * @type {PhoneVerifiedData}
     * @memberof PhoneVerifiedResponse
     */
    'data': PhoneVerifiedData;
}
/**
 * 
 * @export
 * @interface ProfileData
 */
export interface ProfileData {
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'preferred_name': string | null;
    /**
     * 
     * @type {AiResponseTone}
     * @memberof ProfileData
     */
    'ai_response_tone': AiResponseTone;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileData
     */
    'memories_enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileData
     */
    'email'?: string | null;
}


/**
 * 
 * @export
 * @interface ProfileResponse
 */
export interface ProfileResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileResponse
     */
    'success': boolean;
    /**
     * 
     * @type {ProfileData}
     * @memberof ProfileResponse
     */
    'data': ProfileData;
}
/**
 * 
 * @export
 * @interface ProposeFacilitatorTimeBody
 */
export interface ProposeFacilitatorTimeBody {
    /**
     * 
     * @type {string}
     * @memberof ProposeFacilitatorTimeBody
     */
    'scheduledStart': string;
    /**
     * 
     * @type {number}
     * @memberof ProposeFacilitatorTimeBody
     */
    'durationMinutes': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PushPlatform {
    Ios = 'ios',
    Android = 'android'
}


/**
 * 
 * @export
 * @interface QuizActiveSessionData
 */
export interface QuizActiveSessionData {
    /**
     * 
     * @type {number}
     * @memberof QuizActiveSessionData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof QuizActiveSessionData
     */
    'currentIndex': number;
    /**
     * 
     * @type {number}
     * @memberof QuizActiveSessionData
     */
    'answersCount': number;
}
/**
 * 
 * @export
 * @interface QuizAnswerData
 */
export interface QuizAnswerData {
    /**
     * 
     * @type {string}
     * @memberof QuizAnswerData
     */
    'questionId': string;
    /**
     * 
     * @type {number}
     * @memberof QuizAnswerData
     */
    'answerValue': number | null;
    /**
     * 
     * @type {string}
     * @memberof QuizAnswerData
     */
    'answerLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuizAnswerData
     */
    'subscale'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuizAnswerData
     */
    'isReverseScored'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum QuizExerciseType {
    QuizSelfAssessment = 'quiz_self_assessment',
    QuizPsychNeeds = 'quiz_psych_needs',
    QuizRelationshipAssess = 'quiz_relationship_assess'
}


/**
 * 
 * @export
 * @interface QuizHistoryResponse
 */
export interface QuizHistoryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QuizHistoryResponse
     */
    'success': boolean;
    /**
     * 
     * @type {QuizHistoryResponseData}
     * @memberof QuizHistoryResponse
     */
    'data': QuizHistoryResponseData;
}
/**
 * 
 * @export
 * @interface QuizHistoryResponseData
 */
export interface QuizHistoryResponseData {
    /**
     * 
     * @type {Array<QuizSessionListItemData>}
     * @memberof QuizHistoryResponseData
     */
    'sessions': Array<QuizSessionListItemData>;
    /**
     * 
     * @type {QuizSessionListPaginationData}
     * @memberof QuizHistoryResponseData
     */
    'pagination': QuizSessionListPaginationData;
}
/**
 * 
 * @export
 * @interface QuizInterpretationData
 */
export interface QuizInterpretationData {
    /**
     * 
     * @type {string}
     * @memberof QuizInterpretationData
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof QuizInterpretationData
     */
    'description': string;
    /**
     * 
     * @type {QuizInterpretationDataRange}
     * @memberof QuizInterpretationData
     */
    'range'?: QuizInterpretationDataRange;
}
/**
 * 
 * @export
 * @interface QuizInterpretationDataRange
 */
export interface QuizInterpretationDataRange {
    /**
     * 
     * @type {number}
     * @memberof QuizInterpretationDataRange
     */
    'min': number;
    /**
     * 
     * @type {number}
     * @memberof QuizInterpretationDataRange
     */
    'max': number;
}
/**
 * 
 * @export
 * @interface QuizLatestData
 */
export interface QuizLatestData {
    /**
     * 
     * @type {number}
     * @memberof QuizLatestData
     */
    'sessionId': number;
    /**
     * 
     * @type {QuizExerciseType}
     * @memberof QuizLatestData
     */
    'exerciseType': QuizExerciseType;
    /**
     * 
     * @type {QuizResultData}
     * @memberof QuizLatestData
     */
    'result': QuizResultData;
    /**
     * 
     * @type {string}
     * @memberof QuizLatestData
     */
    'completedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof QuizLatestData
     */
    'relationshipId'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuizLatestData
     */
    'journalEntryId': number | null;
}


/**
 * 
 * @export
 * @interface QuizLatestResponse
 */
export interface QuizLatestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QuizLatestResponse
     */
    'success': boolean;
    /**
     * 
     * @type {QuizLatestResponseData}
     * @memberof QuizLatestResponse
     */
    'data': QuizLatestResponseData;
}
/**
 * 
 * @export
 * @interface QuizLatestResponseData
 */
export interface QuizLatestResponseData {
    /**
     * 
     * @type {number}
     * @memberof QuizLatestResponseData
     */
    'sessionId': number;
    /**
     * 
     * @type {QuizExerciseType}
     * @memberof QuizLatestResponseData
     */
    'exerciseType': QuizExerciseType;
    /**
     * 
     * @type {QuizResultData}
     * @memberof QuizLatestResponseData
     */
    'result': QuizResultData;
    /**
     * 
     * @type {string}
     * @memberof QuizLatestResponseData
     */
    'completedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof QuizLatestResponseData
     */
    'relationshipId'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuizLatestResponseData
     */
    'journalEntryId': number | null;
}


/**
 * 
 * @export
 * @interface QuizLatestResultData
 */
export interface QuizLatestResultData {
    /**
     * 
     * @type {number}
     * @memberof QuizLatestResultData
     */
    'sessionId': number;
    /**
     * 
     * @type {QuizResultData}
     * @memberof QuizLatestResultData
     */
    'result': QuizResultData;
    /**
     * 
     * @type {string}
     * @memberof QuizLatestResultData
     */
    'completedAt': string | null;
}
/**
 * 
 * @export
 * @interface QuizPerQuestionData
 */
export interface QuizPerQuestionData {
    /**
     * 
     * @type {string}
     * @memberof QuizPerQuestionData
     */
    'questionId': string;
    /**
     * 
     * @type {number}
     * @memberof QuizPerQuestionData
     */
    'score': number;
    /**
     * 
     * @type {number}
     * @memberof QuizPerQuestionData
     */
    'maxScore': number;
    /**
     * 
     * @type {string}
     * @memberof QuizPerQuestionData
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface QuizResultData
 */
export interface QuizResultData {
    /**
     * 
     * @type {number}
     * @memberof QuizResultData
     */
    'totalScore': number;
    /**
     * 
     * @type {number}
     * @memberof QuizResultData
     */
    'maxScore': number;
    /**
     * 
     * @type {number}
     * @memberof QuizResultData
     */
    'percentage': number;
    /**
     * 
     * @type {{ [key: string]: QuizSubscaleResultData; }}
     * @memberof QuizResultData
     */
    'subscales'?: { [key: string]: QuizSubscaleResultData; };
    /**
     * 
     * @type {Array<QuizInterpretationData>}
     * @memberof QuizResultData
     */
    'interpretation': Array<QuizInterpretationData>;
    /**
     * 
     * @type {Array<QuizPerQuestionData>}
     * @memberof QuizResultData
     */
    'perQuestion'?: Array<QuizPerQuestionData>;
}
/**
 * 
 * @export
 * @interface QuizSessionData
 */
export interface QuizSessionData {
    /**
     * 
     * @type {number}
     * @memberof QuizSessionData
     */
    'id': number;
    /**
     * 
     * @type {QuizExerciseType}
     * @memberof QuizSessionData
     */
    'exerciseType': QuizExerciseType;
    /**
     * 
     * @type {SessionStatus}
     * @memberof QuizSessionData
     */
    'status': SessionStatus;
    /**
     * 
     * @type {number}
     * @memberof QuizSessionData
     */
    'currentIndex': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof QuizSessionData
     */
    'answers': { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof QuizSessionData
     */
    'isResume': boolean;
    /**
     * 
     * @type {number}
     * @memberof QuizSessionData
     */
    'relationshipId'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuizSessionData
     */
    'journeyStepId'?: number;
    /**
     * 
     * @type {QuizResultData}
     * @memberof QuizSessionData
     */
    'result'?: QuizResultData;
    /**
     * 
     * @type {string}
     * @memberof QuizSessionData
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuizSessionData
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {Array<QuizAnswerData>}
     * @memberof QuizSessionData
     */
    'responses'?: Array<QuizAnswerData>;
}


/**
 * 
 * @export
 * @interface QuizSessionListItemData
 */
export interface QuizSessionListItemData {
    /**
     * 
     * @type {number}
     * @memberof QuizSessionListItemData
     */
    'id': number;
    /**
     * 
     * @type {QuizExerciseType}
     * @memberof QuizSessionListItemData
     */
    'exerciseType': QuizExerciseType;
    /**
     * 
     * @type {SessionStatus}
     * @memberof QuizSessionListItemData
     */
    'status': SessionStatus;
    /**
     * 
     * @type {number}
     * @memberof QuizSessionListItemData
     */
    'relationshipId'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuizSessionListItemData
     */
    'relationshipName'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuizSessionListItemData
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuizSessionListItemData
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {QuizResultData}
     * @memberof QuizSessionListItemData
     */
    'result'?: QuizResultData;
}


/**
 * 
 * @export
 * @interface QuizSessionListPaginationData
 */
export interface QuizSessionListPaginationData {
    /**
     * 
     * @type {number}
     * @memberof QuizSessionListPaginationData
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof QuizSessionListPaginationData
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof QuizSessionListPaginationData
     */
    'offset': number;
}
/**
 * 
 * @export
 * @interface QuizSessionResponse
 */
export interface QuizSessionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QuizSessionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {QuizSessionData}
     * @memberof QuizSessionResponse
     */
    'data': QuizSessionData;
}
/**
 * 
 * @export
 * @interface QuizStatusData
 */
export interface QuizStatusData {
    /**
     * 
     * @type {boolean}
     * @memberof QuizStatusData
     */
    'hasActiveSession': boolean;
    /**
     * 
     * @type {QuizStatusDataActiveSession}
     * @memberof QuizStatusData
     */
    'activeSession': QuizStatusDataActiveSession;
    /**
     * 
     * @type {number}
     * @memberof QuizStatusData
     */
    'completedCount': number;
    /**
     * 
     * @type {QuizStatusDataLatestResult}
     * @memberof QuizStatusData
     */
    'latestResult': QuizStatusDataLatestResult;
}
/**
 * 
 * @export
 * @interface QuizStatusDataActiveSession
 */
export interface QuizStatusDataActiveSession {
    /**
     * 
     * @type {number}
     * @memberof QuizStatusDataActiveSession
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof QuizStatusDataActiveSession
     */
    'currentIndex': number;
    /**
     * 
     * @type {number}
     * @memberof QuizStatusDataActiveSession
     */
    'answersCount': number;
}
/**
 * 
 * @export
 * @interface QuizStatusDataLatestResult
 */
export interface QuizStatusDataLatestResult {
    /**
     * 
     * @type {number}
     * @memberof QuizStatusDataLatestResult
     */
    'sessionId': number;
    /**
     * 
     * @type {QuizResultData}
     * @memberof QuizStatusDataLatestResult
     */
    'result': QuizResultData;
    /**
     * 
     * @type {string}
     * @memberof QuizStatusDataLatestResult
     */
    'completedAt': string | null;
}
/**
 * 
 * @export
 * @interface QuizStatusResponse
 */
export interface QuizStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QuizStatusResponse
     */
    'success': boolean;
    /**
     * 
     * @type {QuizStatusData}
     * @memberof QuizStatusResponse
     */
    'data': QuizStatusData;
}
/**
 * 
 * @export
 * @interface QuizSubscaleResultData
 */
export interface QuizSubscaleResultData {
    /**
     * 
     * @type {string}
     * @memberof QuizSubscaleResultData
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof QuizSubscaleResultData
     */
    'satisfaction'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuizSubscaleResultData
     */
    'frustration'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuizSubscaleResultData
     */
    'average'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuizSubscaleResultData
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface RateRelationshipBody
 */
export interface RateRelationshipBody {
    /**
     * 
     * @type {number}
     * @memberof RateRelationshipBody
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipBody
     */
    'note'?: string;
    /**
     * 
     * @type {RateRelationshipBodyJourneyMap}
     * @memberof RateRelationshipBody
     */
    'journeyMap'?: RateRelationshipBodyJourneyMap;
}
/**
 * 
 * @export
 * @interface RateRelationshipBodyJourneyMap
 */
export interface RateRelationshipBodyJourneyMap {
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipBodyJourneyMap
     */
    'friction_point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipBodyJourneyMap
     */
    'pattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipBodyJourneyMap
     */
    'trigger'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipBodyJourneyMap
     */
    'desired_shift'?: string | null;
}
/**
 * 
 * @export
 * @interface RateRelationshipResponse
 */
export interface RateRelationshipResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RateRelationshipResponse
     */
    'success': boolean;
    /**
     * 
     * @type {RateRelationshipResponseData}
     * @memberof RateRelationshipResponse
     */
    'data': RateRelationshipResponseData;
}
/**
 * 
 * @export
 * @interface RateRelationshipResponseData
 */
export interface RateRelationshipResponseData {
    /**
     * 
     * @type {number}
     * @memberof RateRelationshipResponseData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof RateRelationshipResponseData
     */
    'relationshipId': number;
    /**
     * 
     * @type {number}
     * @memberof RateRelationshipResponseData
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipResponseData
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipResponseData
     */
    'insight': string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRelationshipResponseData
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface RatingData
 */
export interface RatingData {
    /**
     * 
     * @type {number}
     * @memberof RatingData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof RatingData
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof RatingData
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof RatingData
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface RatingListResponse
 */
export interface RatingListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RatingListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {Array<RatingData>}
     * @memberof RatingListResponse
     */
    'data': Array<RatingData>;
}
/**
 * 
 * @export
 * @interface RecommendationData
 */
export interface RecommendationData {
    /**
     * 
     * @type {RecommendationType}
     * @memberof RecommendationData
     */
    'type': RecommendationType;
    /**
     * 
     * @type {string}
     * @memberof RecommendationData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationData
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationData
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationData
     */
    'actionId'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum RecommendationType {
    Exercise = 'exercise',
    Knowledge = 'knowledge',
    Book = 'book',
    JournalPrompt = 'journal_prompt'
}


/**
 * 
 * @export
 * @interface RecordActivityBody
 */
export interface RecordActivityBody {
    /**
     * 
     * @type {string}
     * @memberof RecordActivityBody
     */
    'resourceId': string;
    /**
     * 
     * @type {ActivityType}
     * @memberof RecordActivityBody
     */
    'activityType': ActivityType;
    /**
     * 
     * @type {number}
     * @memberof RecordActivityBody
     */
    'relationshipId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecordActivityBody
     */
    'stepId'?: number;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof RecordActivityBody
     */
    'payload'?: { [key: string]: any | null; };
}


/**
 * 
 * @export
 * @interface RecordActivityResponse
 */
export interface RecordActivityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RecordActivityResponse
     */
    'success': boolean;
    /**
     * 
     * @type {ActivityData}
     * @memberof RecordActivityResponse
     */
    'data': ActivityData;
}
/**
 * 
 * @export
 * @interface ReflectionsByDepthData
 */
export interface ReflectionsByDepthData {
    /**
     * 
     * @type {number}
     * @memberof ReflectionsByDepthData
     */
    'sand': number;
    /**
     * 
     * @type {number}
     * @memberof ReflectionsByDepthData
     */
    'shore': number;
    /**
     * 
     * @type {number}
     * @memberof ReflectionsByDepthData
     */
    'sea': number;
}
/**
 * 
 * @export
 * @interface ReflectionsData
 */
export interface ReflectionsData {
    /**
     * 
     * @type {number}
     * @memberof ReflectionsData
     */
    'total': number;
    /**
     * 
     * @type {ReflectionsByDepthData}
     * @memberof ReflectionsData
     */
    'byDepth': ReflectionsByDepthData;
}
/**
 * 
 * @export
 * @interface RefreshTokenBody
 */
export interface RefreshTokenBody {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenBody
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface RefreshTokenResponseData
 */
export interface RefreshTokenResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof RefreshTokenResponseData
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponseData
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponseData
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponseData
     */
    'expiresIn': string;
    /**
     * 
     * @type {boolean}
     * @memberof RefreshTokenResponseData
     */
    'sessionWasActive': boolean;
}
/**
 * 
 * @export
 * @interface RegisterPushTokenBody
 */
export interface RegisterPushTokenBody {
    /**
     * 
     * @type {string}
     * @memberof RegisterPushTokenBody
     */
    'token': string;
    /**
     * 
     * @type {PushPlatform}
     * @memberof RegisterPushTokenBody
     */
    'platform': PushPlatform;
}


/**
 * 
 * @export
 * @interface RelationshipCreateBody
 */
export interface RelationshipCreateBody {
    /**
     * 
     * @type {string}
     * @memberof RelationshipCreateBody
     */
    'name': string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof RelationshipCreateBody
     */
    'relationshipType': RelationshipType;
    /**
     * 
     * @type {string}
     * @memberof RelationshipCreateBody
     */
    'customRelationshipType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RelationshipCreateBody
     */
    'initialScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelationshipCreateBody
     */
    'initialNote'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipCreateBody
     */
    'goals'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipCreateBody
     */
    'painPoints'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RelationshipCreateBody
     */
    'satisfaction'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelationshipCreateBody
     */
    'urgencyLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipCreateBody
     */
    'contextNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipCreateBody
     */
    'avatarEmoji'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipCreateBody
     */
    'isNorthStar'?: boolean;
}


/**
 * 
 * @export
 * @interface RelationshipData
 */
export interface RelationshipData {
    /**
     * 
     * @type {number}
     * @memberof RelationshipData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RelationshipData
     */
    'name': string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof RelationshipData
     */
    'relationshipType': RelationshipType;
    /**
     * 
     * @type {string}
     * @memberof RelationshipData
     */
    'customRelationshipType': string | null;
    /**
     * 
     * @type {number}
     * @memberof RelationshipData
     */
    'currentHealthScore': number | null;
    /**
     * 
     * @type {number}
     * @memberof RelationshipData
     */
    'checkInCount': number;
    /**
     * 
     * @type {TrendDirection}
     * @memberof RelationshipData
     */
    'trend': TrendDirection;
    /**
     * 
     * @type {number}
     * @memberof RelationshipData
     */
    'previousScore': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipData
     */
    'isNorthStar': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipData
     */
    'isActiveFocus': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipData
     */
    'goals': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipData
     */
    'painPoints': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RelationshipData
     */
    'satisfaction': number | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipData
     */
    'urgencyLevel': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipData
     */
    'avatarEmoji': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipData
     */
    'lastSessionAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipData
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipData
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface RelationshipDeleteResponse
 */
export interface RelationshipDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipDeleteResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDeleteResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface RelationshipDetailData
 */
export interface RelationshipDetailData {
    /**
     * 
     * @type {number}
     * @memberof RelationshipDetailData
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'name': string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof RelationshipDetailData
     */
    'relationshipType': RelationshipType;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'customRelationshipType': string | null;
    /**
     * 
     * @type {number}
     * @memberof RelationshipDetailData
     */
    'currentHealthScore': number | null;
    /**
     * 
     * @type {number}
     * @memberof RelationshipDetailData
     */
    'checkInCount': number;
    /**
     * 
     * @type {TrendDirection}
     * @memberof RelationshipDetailData
     */
    'trend': TrendDirection;
    /**
     * 
     * @type {number}
     * @memberof RelationshipDetailData
     */
    'previousScore': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipDetailData
     */
    'isNorthStar': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipDetailData
     */
    'isActiveFocus': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipDetailData
     */
    'goals': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipDetailData
     */
    'painPoints': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RelationshipDetailData
     */
    'satisfaction': number | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'urgencyLevel': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'avatarEmoji': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'lastSessionAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipDetailData
     */
    'contextNotes': string | null;
}


/**
 * 
 * @export
 * @interface RelationshipDetailResponse
 */
export interface RelationshipDetailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipDetailResponse
     */
    'success': boolean;
    /**
     * 
     * @type {RelationshipDetailData}
     * @memberof RelationshipDetailResponse
     */
    'data': RelationshipDetailData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RelationshipGoal {
    BetterCommunication = 'better_communication',
    DeeperTrust = 'deeper_trust',
    ResolveConflicts = 'resolve_conflicts',
    MoreIntimacy = 'more_intimacy',
    StrengthenConnection = 'strengthen_connection',
    Other = 'other'
}


/**
 * 
 * @export
 * @interface RelationshipListResponse
 */
export interface RelationshipListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {Array<RelationshipData>}
     * @memberof RelationshipListResponse
     */
    'data': Array<RelationshipData>;
}
/**
 * 
 * @export
 * @interface RelationshipSummary
 */
export interface RelationshipSummary {
    /**
     * 
     * @type {number}
     * @memberof RelationshipSummary
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RelationshipSummary
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipSummary
     */
    'relationship_type': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RelationshipType {
    Partner = 'partner',
    Friend = 'friend',
    Parent = 'parent',
    Sibling = 'sibling',
    Child = 'child',
    Colleague = 'colleague',
    Other = 'other'
}


/**
 * 
 * @export
 * @interface RelationshipUpdateBody
 */
export interface RelationshipUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof RelationshipUpdateBody
     */
    'name'?: string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof RelationshipUpdateBody
     */
    'relationshipType'?: RelationshipType;
    /**
     * 
     * @type {string}
     * @memberof RelationshipUpdateBody
     */
    'customRelationshipType'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipUpdateBody
     */
    'goals'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelationshipUpdateBody
     */
    'painPoints'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RelationshipUpdateBody
     */
    'satisfaction'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelationshipUpdateBody
     */
    'urgencyLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipUpdateBody
     */
    'contextNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipUpdateBody
     */
    'avatarEmoji'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipUpdateBody
     */
    'isNorthStar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipUpdateBody
     */
    'isActiveFocus'?: boolean;
}


/**
 * 
 * @export
 * @interface RequestMagicLinkBody
 */
export interface RequestMagicLinkBody {
    /**
     * 
     * @type {string}
     * @memberof RequestMagicLinkBody
     */
    'email': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ResponseStatus {
    Pending = 'pending',
    Completed = 'completed',
    Skipped = 'skipped'
}


/**
 * 
 * @export
 * @interface SaveBookProgressBody
 */
export interface SaveBookProgressBody {
    /**
     * 
     * @type {number}
     * @memberof SaveBookProgressBody
     */
    'lastPage': number;
    /**
     * 
     * @type {number}
     * @memberof SaveBookProgressBody
     */
    'totalPages'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveBookProgressBody
     */
    'bookKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveBookProgressBody
     */
    'chapterId'?: string;
}
/**
 * 
 * @export
 * @interface SaveQuizAnswersBody
 */
export interface SaveQuizAnswersBody {
    /**
     * 
     * @type {{ [key: string]: SaveQuizAnswersBodyAnswersValue; }}
     * @memberof SaveQuizAnswersBody
     */
    'answers': { [key: string]: SaveQuizAnswersBodyAnswersValue; };
}
/**
 * 
 * @export
 * @interface SaveQuizAnswersBodyAnswersValue
 */
export interface SaveQuizAnswersBodyAnswersValue {
}
/**
 * 
 * @export
 * @interface SaveQuizAnswersResponse
 */
export interface SaveQuizAnswersResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SaveQuizAnswersResponse
     */
    'success': boolean;
    /**
     * 
     * @type {SaveQuizAnswersResponseData}
     * @memberof SaveQuizAnswersResponse
     */
    'data': SaveQuizAnswersResponseData;
}
/**
 * 
 * @export
 * @interface SaveQuizAnswersResponseData
 */
export interface SaveQuizAnswersResponseData {
    /**
     * 
     * @type {number}
     * @memberof SaveQuizAnswersResponseData
     */
    'savedCount': number;
}
/**
 * 
 * @export
 * @interface SaveStepBody
 */
export interface SaveStepBody {
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof SaveStepBody
     */
    'data': { [key: string]: any | null; } | null;
}
/**
 * 
 * @export
 * @interface SaveStepResponse
 */
export interface SaveStepResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SaveStepResponse
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof SaveStepResponse
     */
    'step'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveStepResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveStepResponse
     */
    'showCrisisResources'?: boolean;
    /**
     * 
     * @type {CrisisResourcesData}
     * @memberof SaveStepResponse
     */
    'crisisResources'?: CrisisResourcesData;
}
/**
 * 
 * @export
 * @interface SessionData
 */
export interface SessionData {
    /**
     * 
     * @type {number}
     * @memberof SessionData
     */
    'id': number;
    /**
     * 
     * @type {ExerciseType}
     * @memberof SessionData
     */
    'exerciseType': ExerciseType;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'exerciseId': string | null;
    /**
     * 
     * @type {SessionStatus}
     * @memberof SessionData
     */
    'status': SessionStatus;
    /**
     * 
     * @type {TutorialStatus}
     * @memberof SessionData
     */
    'tutorialStatus': TutorialStatus;
    /**
     * 
     * @type {number}
     * @memberof SessionData
     */
    'currentCardIndex': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SessionData
     */
    'deckOrder': Array<string>;
    /**
     * 
     * @type {Array<CardData>}
     * @memberof SessionData
     */
    'cards': Array<CardData>;
    /**
     * 
     * @type {Array<SessionResponseData>}
     * @memberof SessionData
     */
    'responses': Array<SessionResponseData>;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'completedAt': string | null;
}


/**
 * 
 * @export
 * @interface SessionListItemData
 */
export interface SessionListItemData {
    /**
     * 
     * @type {number}
     * @memberof SessionListItemData
     */
    'id': number;
    /**
     * 
     * @type {ExerciseType}
     * @memberof SessionListItemData
     */
    'exerciseType': ExerciseType;
    /**
     * 
     * @type {SessionStatus}
     * @memberof SessionListItemData
     */
    'status': SessionStatus;
    /**
     * 
     * @type {TutorialStatus}
     * @memberof SessionListItemData
     */
    'tutorialStatus': TutorialStatus;
    /**
     * 
     * @type {string}
     * @memberof SessionListItemData
     */
    'exerciseId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionListItemData
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SessionListItemData
     */
    'completedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof SessionListItemData
     */
    'responsesCount': number;
}


/**
 * 
 * @export
 * @interface SessionListPaginationData
 */
export interface SessionListPaginationData {
    /**
     * 
     * @type {number}
     * @memberof SessionListPaginationData
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SessionListPaginationData
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof SessionListPaginationData
     */
    'offset': number;
}
/**
 * 
 * @export
 * @interface SessionListResponse
 */
export interface SessionListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SessionListResponse
     */
    'success': boolean;
    /**
     * 
     * @type {SessionListResponseData}
     * @memberof SessionListResponse
     */
    'data': SessionListResponseData;
}
/**
 * 
 * @export
 * @interface SessionListResponseData
 */
export interface SessionListResponseData {
    /**
     * 
     * @type {Array<SessionListItemData>}
     * @memberof SessionListResponseData
     */
    'sessions': Array<SessionListItemData>;
    /**
     * 
     * @type {SessionListPaginationData}
     * @memberof SessionListResponseData
     */
    'pagination': SessionListPaginationData;
}
/**
 * 
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SessionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {SessionData}
     * @memberof SessionResponse
     */
    'data': SessionData;
}
/**
 * 
 * @export
 * @interface SessionResponseData
 */
export interface SessionResponseData {
    /**
     * 
     * @type {string}
     * @memberof SessionResponseData
     */
    'cardId': string;
    /**
     * 
     * @type {ResponseStatus}
     * @memberof SessionResponseData
     */
    'status': ResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SessionResponseData
     */
    'insightViewed': boolean;
    /**
     * 
     * @type {number}
     * @memberof SessionResponseData
     */
    'depthLevel': number | null;
    /**
     * 
     * @type {string}
     * @memberof SessionResponseData
     */
    'reflectionText': string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum SessionStatus {
    Active = 'active',
    Completed = 'completed',
    Abandoned = 'abandoned'
}


/**
 * 
 * @export
 * @interface SkipOnboardingResponse
 */
export interface SkipOnboardingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SkipOnboardingResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof SkipOnboardingResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SkipStepBody
 */
export interface SkipStepBody {
    /**
     * 
     * @type {string}
     * @memberof SkipStepBody
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface SkipStepResponse
 */
export interface SkipStepResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SkipStepResponse
     */
    'success': boolean;
    /**
     * 
     * @type {SkipStepResponseData}
     * @memberof SkipStepResponse
     */
    'data': SkipStepResponseData;
}
/**
 * 
 * @export
 * @interface SkipStepResponseData
 */
export interface SkipStepResponseData {
    /**
     * 
     * @type {number}
     * @memberof SkipStepResponseData
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SkipStepResponseData
     */
    'stepOrder': number;
    /**
     * 
     * @type {StepStatus}
     * @memberof SkipStepResponseData
     */
    'status': StepStatus;
    /**
     * 
     * @type {string}
     * @memberof SkipStepResponseData
     */
    'skipReason': string | null;
    /**
     * 
     * @type {string}
     * @memberof SkipStepResponseData
     */
    'skippedAt': string | null;
}


/**
 * 
 * @export
 * @interface StartPhoneVerificationBody
 */
export interface StartPhoneVerificationBody {
    /**
     * 
     * @type {string}
     * @memberof StartPhoneVerificationBody
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof StartPhoneVerificationBody
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface StartQuizSessionBody
 */
export interface StartQuizSessionBody {
    /**
     * 
     * @type {QuizExerciseType}
     * @memberof StartQuizSessionBody
     */
    'exerciseType': QuizExerciseType;
    /**
     * 
     * @type {number}
     * @memberof StartQuizSessionBody
     */
    'relationshipId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StartQuizSessionBody
     */
    'journeyStepId'?: number;
}


/**
 * 
 * @export
 * @interface StartQuizSessionResponse
 */
export interface StartQuizSessionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StartQuizSessionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {QuizSessionData}
     * @memberof StartQuizSessionResponse
     */
    'data': QuizSessionData;
}
/**
 * 
 * @export
 * @interface StartSessionBody
 */
export interface StartSessionBody {
    /**
     * 
     * @type {ExerciseType}
     * @memberof StartSessionBody
     */
    'exerciseType': ExerciseType;
    /**
     * 
     * @type {string}
     * @memberof StartSessionBody
     */
    'exerciseId': string;
}


/**
 * 
 * @export
 * @interface StartSessionResponse
 */
export interface StartSessionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StartSessionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {StartSessionResponseData}
     * @memberof StartSessionResponse
     */
    'data': StartSessionResponseData;
}
/**
 * 
 * @export
 * @interface StartSessionResponseData
 */
export interface StartSessionResponseData {
    /**
     * 
     * @type {number}
     * @memberof StartSessionResponseData
     */
    'id': number;
    /**
     * 
     * @type {ExerciseType}
     * @memberof StartSessionResponseData
     */
    'exerciseType': ExerciseType;
    /**
     * 
     * @type {string}
     * @memberof StartSessionResponseData
     */
    'exerciseId': string;
    /**
     * 
     * @type {SessionStatus}
     * @memberof StartSessionResponseData
     */
    'status': SessionStatus;
    /**
     * 
     * @type {TutorialStatus}
     * @memberof StartSessionResponseData
     */
    'tutorialStatus': TutorialStatus;
    /**
     * 
     * @type {number}
     * @memberof StartSessionResponseData
     */
    'currentCardIndex': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof StartSessionResponseData
     */
    'deckOrder': Array<string>;
    /**
     * 
     * @type {Array<CardData>}
     * @memberof StartSessionResponseData
     */
    'cards': Array<CardData>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum StarterTheme {
    Wellness = 'wellness',
    Relationships = 'relationships',
    Support = 'support',
    Productivity = 'productivity',
    Learning = 'learning',
    Reflection = 'reflection',
    Communication = 'communication',
    Growth = 'growth'
}


/**
 * 
 * @export
 * @interface StepEvaluationData
 */
export interface StepEvaluationData {
    /**
     * 
     * @type {number}
     * @memberof StepEvaluationData
     */
    'stepId': number;
    /**
     * 
     * @type {string}
     * @memberof StepEvaluationData
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof StepEvaluationData
     */
    'reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StepEvaluationData
     */
    'completionEvidence'?: string | null;
    /**
     * 
     * @type {Array<any | null>}
     * @memberof StepEvaluationData
     */
    'partialCompletions'?: Array<any | null>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum StepStatus {
    Available = 'available',
    InProgress = 'in_progress',
    Completed = 'completed',
    Locked = 'locked',
    Skipped = 'skipped'
}


/**
 * 
 * @export
 * @interface StrapiExerciseData
 */
export interface StrapiExerciseData {
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseData
     */
    'exerciseId': string;
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseData
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseData
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof StrapiExerciseData
     */
    'duration': number | null;
}
/**
 * 
 * @export
 * @interface StrapiExerciseWithCardsData
 */
export interface StrapiExerciseWithCardsData {
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseWithCardsData
     */
    'exerciseId': string;
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseWithCardsData
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseWithCardsData
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof StrapiExerciseWithCardsData
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof StrapiExerciseWithCardsData
     */
    'duration': number | null;
    /**
     * 
     * @type {Array<CardData>}
     * @memberof StrapiExerciseWithCardsData
     */
    'cards': Array<CardData>;
}
/**
 * 
 * @export
 * @interface StreakData
 */
export interface StreakData {
    /**
     * 
     * @type {number}
     * @memberof StreakData
     */
    'current': number;
    /**
     * 
     * @type {number}
     * @memberof StreakData
     */
    'longest': number;
}
/**
 * 
 * @export
 * @interface SubmitResponseBody
 */
export interface SubmitResponseBody {
    /**
     * 
     * @type {string}
     * @memberof SubmitResponseBody
     */
    'itemId': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitResponseBody
     */
    'responseText'?: string;
    /**
     * 
     * @type {ResponseStatus}
     * @memberof SubmitResponseBody
     */
    'status'?: ResponseStatus;
    /**
     * 
     * @type {SubmitResponseBodyDepthLevel}
     * @memberof SubmitResponseBody
     */
    'depthLevel': SubmitResponseBodyDepthLevel;
}


/**
 * 
 * @export
 * @interface SubmitResponseBodyDepthLevel
 */
export interface SubmitResponseBodyDepthLevel {
}
/**
 * 
 * @export
 * @interface SubmitResponseResponse
 */
export interface SubmitResponseResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SubmitResponseResponse
     */
    'success': boolean;
    /**
     * 
     * @type {SubmitResponseResponseData}
     * @memberof SubmitResponseResponse
     */
    'data': SubmitResponseResponseData;
}
/**
 * 
 * @export
 * @interface SubmitResponseResponseData
 */
export interface SubmitResponseResponseData {
    /**
     * 
     * @type {number}
     * @memberof SubmitResponseResponseData
     */
    'responseId': number;
    /**
     * 
     * @type {ResponseStatus}
     * @memberof SubmitResponseResponseData
     */
    'status': ResponseStatus;
    /**
     * 
     * @type {SubmitResponseResponseDataProgress}
     * @memberof SubmitResponseResponseData
     */
    'progress': SubmitResponseResponseDataProgress;
}


/**
 * 
 * @export
 * @interface SubmitResponseResponseDataProgress
 */
export interface SubmitResponseResponseDataProgress {
    /**
     * 
     * @type {number}
     * @memberof SubmitResponseResponseDataProgress
     */
    'current': number;
}
/**
 * 
 * @export
 * @interface TemporalData
 */
export interface TemporalData {
    /**
     * 
     * @type {string}
     * @memberof TemporalData
     */
    'event_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TemporalData
     */
    'event_type'?: TemporalDataEventType;
    /**
     * 
     * @type {string}
     * @memberof TemporalData
     */
    'event_time'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum TemporalDataEventType {
    Past = 'past',
    Future = 'future',
    Recurring = 'recurring'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum TimeOfDay {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Night = 'night'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum TrendDirection {
    Improving = 'improving',
    Declining = 'declining',
    Stable = 'stable',
    New = 'new'
}


/**
 * 
 * @export
 * @interface TutorialFlagsData
 */
export interface TutorialFlagsData {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof TutorialFlagsData
     */
    'flags': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface TutorialFlagsResponse
 */
export interface TutorialFlagsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TutorialFlagsResponse
     */
    'success': boolean;
    /**
     * 
     * @type {TutorialFlagsData}
     * @memberof TutorialFlagsResponse
     */
    'data': TutorialFlagsData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TutorialStatus {
    NotStarted = 'not_started',
    InProgress = 'in_progress',
    Completed = 'completed',
    Skipped = 'skipped'
}


/**
 * 
 * @export
 * @interface UnregisterPushTokenBody
 */
export interface UnregisterPushTokenBody {
    /**
     * 
     * @type {string}
     * @memberof UnregisterPushTokenBody
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface UpdateCardGameTutorialBody
 */
export interface UpdateCardGameTutorialBody {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof UpdateCardGameTutorialBody
     */
    'flags': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface UpdateDeckOrderBody
 */
export interface UpdateDeckOrderBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDeckOrderBody
     */
    'deckOrder': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateDeckOrderResponse
 */
export interface UpdateDeckOrderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDeckOrderResponse
     */
    'success': boolean;
    /**
     * 
     * @type {UpdateDeckOrderResponseData}
     * @memberof UpdateDeckOrderResponse
     */
    'data': UpdateDeckOrderResponseData;
}
/**
 * 
 * @export
 * @interface UpdateDeckOrderResponseData
 */
export interface UpdateDeckOrderResponseData {
    /**
     * 
     * @type {number}
     * @memberof UpdateDeckOrderResponseData
     */
    'id': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDeckOrderResponseData
     */
    'deckOrder': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateFacilitatorSessionBody
 */
export interface UpdateFacilitatorSessionBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilitatorSessionBody
     */
    'scheduledStart'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateFacilitatorSessionBody
     */
    'durationMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilitatorSessionBody
     */
    'musicTrackId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProfileBody
 */
export interface UpdateProfileBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'preferred_name'?: string | null;
    /**
     * 
     * @type {AiResponseTone}
     * @memberof UpdateProfileBody
     */
    'ai_response_tone'?: AiResponseTone;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileBody
     */
    'memories_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'email'?: string | null;
}


/**
 * 
 * @export
 * @interface UpdateTutorialFlagsBody
 */
export interface UpdateTutorialFlagsBody {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof UpdateTutorialFlagsBody
     */
    'flags': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface UpdateTutorialStatusBody
 */
export interface UpdateTutorialStatusBody {
    /**
     * 
     * @type {TutorialStatus}
     * @memberof UpdateTutorialStatusBody
     */
    'tutorialStatus': TutorialStatus;
}


/**
 * 
 * @export
 * @interface UpdateTutorialStatusResponse
 */
export interface UpdateTutorialStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTutorialStatusResponse
     */
    'success': boolean;
    /**
     * 
     * @type {UpdateTutorialStatusResponseData}
     * @memberof UpdateTutorialStatusResponse
     */
    'data': UpdateTutorialStatusResponseData;
}
/**
 * 
 * @export
 * @interface UpdateTutorialStatusResponseData
 */
export interface UpdateTutorialStatusResponseData {
    /**
     * 
     * @type {number}
     * @memberof UpdateTutorialStatusResponseData
     */
    'id': number;
    /**
     * 
     * @type {TutorialStatus}
     * @memberof UpdateTutorialStatusResponseData
     */
    'tutorialStatus': TutorialStatus;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum UrgencyLevel {
    NotUrgent = 'not_urgent',
    SomewhatUrgent = 'somewhat_urgent',
    VeryUrgent = 'very_urgent',
    Crisis = 'crisis'
}


/**
 * 
 * @export
 * @interface WelcomePromptData
 */
export interface WelcomePromptData {
    /**
     * 
     * @type {string}
     * @memberof WelcomePromptData
     */
    'greeting': string;
    /**
     * 
     * @type {string}
     * @memberof WelcomePromptData
     */
    'greeting_subtext'?: string;
    /**
     * 
     * @type {string}
     * @memberof WelcomePromptData
     */
    'about_konnect'?: string;
    /**
     * 
     * @type {TimeOfDay}
     * @memberof WelcomePromptData
     */
    'time_of_day'?: TimeOfDay;
    /**
     * 
     * @type {Array<ConversationStarter>}
     * @memberof WelcomePromptData
     */
    'conversation_starters': Array<ConversationStarter>;
    /**
     * 
     * @type {boolean}
     * @memberof WelcomePromptData
     */
    'are_starters_personalized': boolean;
    /**
     * 
     * @type {DailyMessage}
     * @memberof WelcomePromptData
     */
    'daily_message'?: DailyMessage;
    /**
     * 
     * @type {Array<RelationshipSummary>}
     * @memberof WelcomePromptData
     */
    'relationships': Array<RelationshipSummary>;
    /**
     * 
     * @type {boolean}
     * @memberof WelcomePromptData
     */
    'is_first_session': boolean;
    /**
     * 
     * @type {string}
     * @memberof WelcomePromptData
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WelcomePromptData
     */
    'name_missing': boolean;
    /**
     * 
     * @type {string}
     * @memberof WelcomePromptData
     */
    'generated_at': string;
    /**
     * 
     * @type {string}
     * @memberof WelcomePromptData
     */
    'expires_at': string;
}



/**
 * AIApi - axios parameter creator
 * @export
 */
export const AIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Streams a response via SSE. Handles both onboarding and coaching conversations.
         * @summary Send a chat message to the AI coach
         * @param {AiChatRequestBody} [aiChatRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiChat: async (aiChatRequestBody?: AiChatRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiChatRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streams feedback via SSE to help users deepen their card game reflections.
         * @summary Get AI feedback to deepen a reflection
         * @param {DeepenReflectionBody} [deepenReflectionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepenReflection: async (deepenReflectionBody?: DeepenReflectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/exercise-coach/deepen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deepenReflectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a conversation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversation: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteConversation', 'id', id)
            const localVarPath = `/ai/conversations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a memory
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMemory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMemory', 'id', id)
            const localVarPath = `/ai/memories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the formatted context summary used for AI prompts. For debugging/admin.
         * @summary Get user context summary (debug)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContextSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/context-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a conversation by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getConversationById', 'id', id)
            const localVarPath = `/ai/conversations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get messages for a conversation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMessages: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getConversationMessages', 'id', id)
            const localVarPath = `/ai/conversations/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all conversations for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user entities (people, places, topics)
         * @param {EntityType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntities: async (type?: EntityType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                for (const [key, value] of Object.entries(type)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns memories with optional filters for type, status, importance, and relationship.
         * @summary Get all memories for the user
         * @param {MemoryType} [type] 
         * @param {MemoryStatus} [status] 
         * @param {number} [minImportance] 
         * @param {GetMemoriesRelationshipIdParameter} [relationshipId] 
         * @param {GetMemoriesSort} [sort] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemories: async (type?: MemoryType, status?: MemoryStatus, minImportance?: number, relationshipId?: GetMemoriesRelationshipIdParameter, sort?: GetMemoriesSort, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/memories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                for (const [key, value] of Object.entries(type)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (status !== undefined) {
                for (const [key, value] of Object.entries(status)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (minImportance !== undefined) {
                localVarQueryParameter['minImportance'] = minImportance;
            }

            if (relationshipId !== undefined) {
                for (const [key, value] of Object.entries(relationshipId)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a memory by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMemoryById', 'id', id)
            const localVarPath = `/ai/memories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get memory statistics
         * @param {GetMemoryStatsRelationshipIdParameter} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryStats: async (relationshipId?: GetMemoryStatsRelationshipIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/memories/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (relationshipId !== undefined) {
                for (const [key, value] of Object.entries(relationshipId)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns people entities and their relationships as a graph structure.
         * @summary Get relationship graph
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipGraph: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/entities/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns greeting, conversation starters, daily message, and relationship list.
         * @summary Get personalized welcome screen data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWelcomePrompt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/welcome-prompt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears cache and regenerates welcome screen data.
         * @summary Force refresh welcome prompt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWelcomePrompt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/welcome-prompt/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search memories semantically
         * @param {string} query 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMemories: async (query: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchMemories', 'query', query)
            const localVarPath = `/ai/memories/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIApi - functional programming interface
 * @export
 */
export const AIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIApiAxiosParamCreator(configuration)
    return {
        /**
         * Streams a response via SSE. Handles both onboarding and coaching conversations.
         * @summary Send a chat message to the AI coach
         * @param {AiChatRequestBody} [aiChatRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiChat(aiChatRequestBody?: AiChatRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiChat(aiChatRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.aiChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Streams feedback via SSE to help users deepen their card game reflections.
         * @summary Get AI feedback to deepen a reflection
         * @param {DeepenReflectionBody} [deepenReflectionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deepenReflection(deepenReflectionBody?: DeepenReflectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deepenReflection(deepenReflectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.deepenReflection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a conversation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConversation(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConversation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.deleteConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a memory
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMemory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMemory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.deleteMemory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the formatted context summary used for AI prompts. For debugging/admin.
         * @summary Get user context summary (debug)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContextSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetContextSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContextSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getContextSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a conversation by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getConversationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get messages for a conversation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationMessages(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationMessages(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getConversationMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all conversations for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user entities (people, places, topics)
         * @param {EntityType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntities(type?: EntityType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntities(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns memories with optional filters for type, status, importance, and relationship.
         * @summary Get all memories for the user
         * @param {MemoryType} [type] 
         * @param {MemoryStatus} [status] 
         * @param {number} [minImportance] 
         * @param {GetMemoriesRelationshipIdParameter} [relationshipId] 
         * @param {GetMemoriesSort} [sort] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemories(type?: MemoryType, status?: MemoryStatus, minImportance?: number, relationshipId?: GetMemoriesRelationshipIdParameter, sort?: GetMemoriesSort, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemories(type, status, minImportance, relationshipId, sort, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getMemories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a memory by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemoryById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemoryById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getMemoryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get memory statistics
         * @param {GetMemoryStatsRelationshipIdParameter} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemoryStats(relationshipId?: GetMemoryStatsRelationshipIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemoryStats(relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getMemoryStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns people entities and their relationships as a graph structure.
         * @summary Get relationship graph
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipGraph(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRelationshipGraph200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipGraph(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getRelationshipGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns greeting, conversation starters, daily message, and relationship list.
         * @summary Get personalized welcome screen data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWelcomePrompt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomePromptData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWelcomePrompt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.getWelcomePrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clears cache and regenerates welcome screen data.
         * @summary Force refresh welcome prompt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshWelcomePrompt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomePromptData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshWelcomePrompt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.refreshWelcomePrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search memories semantically
         * @param {string} query 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMemories(query: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMemories(query, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.searchMemories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIApi - factory interface
 * @export
 */
export const AIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIApiFp(configuration)
    return {
        /**
         * Streams a response via SSE. Handles both onboarding and coaching conversations.
         * @summary Send a chat message to the AI coach
         * @param {AiChatRequestBody} [aiChatRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiChat(aiChatRequestBody?: AiChatRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.aiChat(aiChatRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Streams feedback via SSE to help users deepen their card game reflections.
         * @summary Get AI feedback to deepen a reflection
         * @param {DeepenReflectionBody} [deepenReflectionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deepenReflection(deepenReflectionBody?: DeepenReflectionBody, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deepenReflection(deepenReflectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a conversation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversation(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponse> {
            return localVarFp.deleteConversation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a memory
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMemory(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponse> {
            return localVarFp.deleteMemory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the formatted context summary used for AI prompts. For debugging/admin.
         * @summary Get user context summary (debug)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContextSummary(options?: RawAxiosRequestConfig): AxiosPromise<GetContextSummary200Response> {
            return localVarFp.getContextSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a conversation by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ConversationData> {
            return localVarFp.getConversationById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get messages for a conversation
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMessages(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ConversationMessagesResponse> {
            return localVarFp.getConversationMessages(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all conversations for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversations(options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationData>> {
            return localVarFp.getConversations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user entities (people, places, topics)
         * @param {EntityType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntities(type?: EntityType, options?: RawAxiosRequestConfig): AxiosPromise<EntityListResponse> {
            return localVarFp.getEntities(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns memories with optional filters for type, status, importance, and relationship.
         * @summary Get all memories for the user
         * @param {MemoryType} [type] 
         * @param {MemoryStatus} [status] 
         * @param {number} [minImportance] 
         * @param {GetMemoriesRelationshipIdParameter} [relationshipId] 
         * @param {GetMemoriesSort} [sort] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemories(type?: MemoryType, status?: MemoryStatus, minImportance?: number, relationshipId?: GetMemoriesRelationshipIdParameter, sort?: GetMemoriesSort, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<MemoryListResponse> {
            return localVarFp.getMemories(type, status, minImportance, relationshipId, sort, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a memory by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MemoryData> {
            return localVarFp.getMemoryById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get memory statistics
         * @param {GetMemoryStatsRelationshipIdParameter} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryStats(relationshipId?: GetMemoryStatsRelationshipIdParameter, options?: RawAxiosRequestConfig): AxiosPromise<MemoryStatsResponse> {
            return localVarFp.getMemoryStats(relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns people entities and their relationships as a graph structure.
         * @summary Get relationship graph
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipGraph(options?: RawAxiosRequestConfig): AxiosPromise<GetRelationshipGraph200Response> {
            return localVarFp.getRelationshipGraph(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns greeting, conversation starters, daily message, and relationship list.
         * @summary Get personalized welcome screen data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWelcomePrompt(options?: RawAxiosRequestConfig): AxiosPromise<WelcomePromptData> {
            return localVarFp.getWelcomePrompt(options).then((request) => request(axios, basePath));
        },
        /**
         * Clears cache and regenerates welcome screen data.
         * @summary Force refresh welcome prompt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWelcomePrompt(options?: RawAxiosRequestConfig): AxiosPromise<WelcomePromptData> {
            return localVarFp.refreshWelcomePrompt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search memories semantically
         * @param {string} query 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMemories(query: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<MemoryListResponse> {
            return localVarFp.searchMemories(query, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AIApi - object-oriented interface
 * @export
 * @class AIApi
 * @extends {BaseAPI}
 */
export class AIApi extends BaseAPI {
    /**
     * Streams a response via SSE. Handles both onboarding and coaching conversations.
     * @summary Send a chat message to the AI coach
     * @param {AiChatRequestBody} [aiChatRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public aiChat(aiChatRequestBody?: AiChatRequestBody, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).aiChat(aiChatRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Streams feedback via SSE to help users deepen their card game reflections.
     * @summary Get AI feedback to deepen a reflection
     * @param {DeepenReflectionBody} [deepenReflectionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public deepenReflection(deepenReflectionBody?: DeepenReflectionBody, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).deepenReflection(deepenReflectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a conversation
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public deleteConversation(id: number, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).deleteConversation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a memory
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public deleteMemory(id: string, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).deleteMemory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the formatted context summary used for AI prompts. For debugging/admin.
     * @summary Get user context summary (debug)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getContextSummary(options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getContextSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a conversation by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getConversationById(id: number, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getConversationById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get messages for a conversation
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getConversationMessages(id: number, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getConversationMessages(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all conversations for the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getConversations(options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getConversations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user entities (people, places, topics)
     * @param {EntityType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getEntities(type?: EntityType, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getEntities(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns memories with optional filters for type, status, importance, and relationship.
     * @summary Get all memories for the user
     * @param {MemoryType} [type] 
     * @param {MemoryStatus} [status] 
     * @param {number} [minImportance] 
     * @param {GetMemoriesRelationshipIdParameter} [relationshipId] 
     * @param {GetMemoriesSort} [sort] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getMemories(type?: MemoryType, status?: MemoryStatus, minImportance?: number, relationshipId?: GetMemoriesRelationshipIdParameter, sort?: GetMemoriesSort, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getMemories(type, status, minImportance, relationshipId, sort, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a memory by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getMemoryById(id: string, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getMemoryById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get memory statistics
     * @param {GetMemoryStatsRelationshipIdParameter} [relationshipId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getMemoryStats(relationshipId?: GetMemoryStatsRelationshipIdParameter, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getMemoryStats(relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns people entities and their relationships as a graph structure.
     * @summary Get relationship graph
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getRelationshipGraph(options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getRelationshipGraph(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns greeting, conversation starters, daily message, and relationship list.
     * @summary Get personalized welcome screen data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public getWelcomePrompt(options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).getWelcomePrompt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clears cache and regenerates welcome screen data.
     * @summary Force refresh welcome prompt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public refreshWelcomePrompt(options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).refreshWelcomePrompt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search memories semantically
     * @param {string} query 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    public searchMemories(query: string, limit?: number, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).searchMemories(query, limit, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetMemoriesSort {
    CreatedAt = 'created_at',
    Importance = 'importance'
}


/**
 * ActivitiesApi - axios parameter creator
 * @export
 */
export const ActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns activities for the authenticated user with optional filters.
         * @summary Get user activities
         * @param {string} [resourceId] 
         * @param {number} [relationshipId] 
         * @param {ActivityType} [activityType] 
         * @param {number} [limit] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivities: async (resourceId?: string, relationshipId?: number, activityType?: ActivityType, limit?: number, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }

            if (relationshipId !== undefined) {
                localVarQueryParameter['relationshipId'] = relationshipId;
            }

            if (activityType !== undefined) {
                for (const [key, value] of Object.entries(activityType)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns activities for a specific relationship.
         * @summary Get activities for a relationship
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByRelationship: async (relationshipId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationshipId' is not null or undefined
            assertParamExists('getActivitiesByRelationship', 'relationshipId', relationshipId)
            const localVarPath = `/activities/relationship/{relationshipId}`
                .replace(`{${"relationshipId"}}`, encodeURIComponent(String(relationshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an activity summary for the authenticated user.
         * @summary Get activity summary
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitySummary: async (days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/activities/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records a new user activity (e.g., quiz completion, resource started).
         * @summary Record a user activity
         * @param {RecordActivityBody} [recordActivityBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordActivity: async (recordActivityBody?: RecordActivityBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordActivityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitiesApi - functional programming interface
 * @export
 */
export const ActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns activities for the authenticated user with optional filters.
         * @summary Get user activities
         * @param {string} [resourceId] 
         * @param {number} [relationshipId] 
         * @param {ActivityType} [activityType] 
         * @param {number} [limit] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivities(resourceId?: string, relationshipId?: number, activityType?: ActivityType, limit?: number, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivities(resourceId, relationshipId, activityType, limit, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns activities for a specific relationship.
         * @summary Get activities for a relationship
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitiesByRelationship(relationshipId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitiesByRelationship(relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivitiesByRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an activity summary for the authenticated user.
         * @summary Get activity summary
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitySummary(days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivitySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitySummary(days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getActivitySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Records a new user activity (e.g., quiz completion, resource started).
         * @summary Record a user activity
         * @param {RecordActivityBody} [recordActivityBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordActivity(recordActivityBody?: RecordActivityBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecordActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordActivity(recordActivityBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.recordActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivitiesApi - factory interface
 * @export
 */
export const ActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitiesApiFp(configuration)
    return {
        /**
         * Returns activities for the authenticated user with optional filters.
         * @summary Get user activities
         * @param {string} [resourceId] 
         * @param {number} [relationshipId] 
         * @param {ActivityType} [activityType] 
         * @param {number} [limit] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivities(resourceId?: string, relationshipId?: number, activityType?: ActivityType, limit?: number, days?: number, options?: RawAxiosRequestConfig): AxiosPromise<ActivityListResponse> {
            return localVarFp.getActivities(resourceId, relationshipId, activityType, limit, days, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns activities for a specific relationship.
         * @summary Get activities for a relationship
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesByRelationship(relationshipId: number, options?: RawAxiosRequestConfig): AxiosPromise<ActivityListResponse> {
            return localVarFp.getActivitiesByRelationship(relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an activity summary for the authenticated user.
         * @summary Get activity summary
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitySummary(days?: number, options?: RawAxiosRequestConfig): AxiosPromise<ActivitySummaryResponse> {
            return localVarFp.getActivitySummary(days, options).then((request) => request(axios, basePath));
        },
        /**
         * Records a new user activity (e.g., quiz completion, resource started).
         * @summary Record a user activity
         * @param {RecordActivityBody} [recordActivityBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordActivity(recordActivityBody?: RecordActivityBody, options?: RawAxiosRequestConfig): AxiosPromise<RecordActivityResponse> {
            return localVarFp.recordActivity(recordActivityBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivitiesApi - object-oriented interface
 * @export
 * @class ActivitiesApi
 * @extends {BaseAPI}
 */
export class ActivitiesApi extends BaseAPI {
    /**
     * Returns activities for the authenticated user with optional filters.
     * @summary Get user activities
     * @param {string} [resourceId] 
     * @param {number} [relationshipId] 
     * @param {ActivityType} [activityType] 
     * @param {number} [limit] 
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivities(resourceId?: string, relationshipId?: number, activityType?: ActivityType, limit?: number, days?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivities(resourceId, relationshipId, activityType, limit, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns activities for a specific relationship.
     * @summary Get activities for a relationship
     * @param {number} relationshipId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivitiesByRelationship(relationshipId: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivitiesByRelationship(relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an activity summary for the authenticated user.
     * @summary Get activity summary
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public getActivitySummary(days?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getActivitySummary(days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records a new user activity (e.g., quiz completion, resource started).
     * @summary Record a user activity
     * @param {RecordActivityBody} [recordActivityBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesApi
     */
    public recordActivity(recordActivityBody?: RecordActivityBody, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).recordActivity(recordActivityBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exchanges Apple authentication data for access and refresh tokens. Handles both visible and hidden email cases using Apple\'s stable user ID.
         * @summary Exchange Apple auth data
         * @param {ExchangeAppleTokenBody} [exchangeAppleTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeAppleToken: async (exchangeAppleTokenBody?: ExchangeAppleTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/exchange-apple-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeAppleTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates a Google ID token and returns authentication tokens. Creates or updates user as needed.
         * @summary Exchange Google ID token
         * @param {ExchangeGoogleIdTokenBody} [exchangeGoogleIdTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleIdToken: async (exchangeGoogleIdTokenBody?: ExchangeGoogleIdTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeGoogleIdTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchanges a temporary token from Google OAuth callback for access and refresh tokens.
         * @summary Exchange Google temp token
         * @param {ExchangeGoogleTokenBody} [exchangeGoogleTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleToken: async (exchangeGoogleTokenBody?: ExchangeGoogleTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/exchange-google-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeGoogleTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchanges a refresh token for a new access token and extends the session.
         * @summary Refresh access token
         * @param {RefreshTokenBody} [refreshTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenBody?: RefreshTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a magic link to the provided email address for passwordless authentication.
         * @summary Request magic link
         * @param {RequestMagicLinkBody} [requestMagicLinkBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMagicLink: async (requestMagicLinkBody?: RequestMagicLinkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/request-magic-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestMagicLinkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies a magic link token from the URL path and returns authentication tokens.
         * @summary Verify magic link
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyMagicLink: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('verifyMagicLink', 'token', token)
            const localVarPath = `/auth/api-verify-magic-link/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Exchanges Apple authentication data for access and refresh tokens. Handles both visible and hidden email cases using Apple\'s stable user ID.
         * @summary Exchange Apple auth data
         * @param {ExchangeAppleTokenBody} [exchangeAppleTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeAppleToken(exchangeAppleTokenBody?: ExchangeAppleTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenResponseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeAppleToken(exchangeAppleTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.exchangeAppleToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates a Google ID token and returns authentication tokens. Creates or updates user as needed.
         * @summary Exchange Google ID token
         * @param {ExchangeGoogleIdTokenBody} [exchangeGoogleIdTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeGoogleIdToken(exchangeGoogleIdTokenBody?: ExchangeGoogleIdTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenResponseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeGoogleIdToken(exchangeGoogleIdTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.exchangeGoogleIdToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchanges a temporary token from Google OAuth callback for access and refresh tokens.
         * @summary Exchange Google temp token
         * @param {ExchangeGoogleTokenBody} [exchangeGoogleTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeGoogleToken(exchangeGoogleTokenBody?: ExchangeGoogleTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenResponseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeGoogleToken(exchangeGoogleTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.exchangeGoogleToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchanges a refresh token for a new access token and extends the session.
         * @summary Refresh access token
         * @param {RefreshTokenBody} [refreshTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenBody?: RefreshTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshTokenResponseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a magic link to the provided email address for passwordless authentication.
         * @summary Request magic link
         * @param {RequestMagicLinkBody} [requestMagicLinkBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestMagicLink(requestMagicLinkBody?: RequestMagicLinkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MagicLinkRequestResponseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestMagicLink(requestMagicLinkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.requestMagicLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies a magic link token from the URL path and returns authentication tokens.
         * @summary Verify magic link
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyMagicLink(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenResponseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyMagicLink(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verifyMagicLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Exchanges Apple authentication data for access and refresh tokens. Handles both visible and hidden email cases using Apple\'s stable user ID.
         * @summary Exchange Apple auth data
         * @param {ExchangeAppleTokenBody} [exchangeAppleTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeAppleToken(exchangeAppleTokenBody?: ExchangeAppleTokenBody, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokenResponseData> {
            return localVarFp.exchangeAppleToken(exchangeAppleTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates a Google ID token and returns authentication tokens. Creates or updates user as needed.
         * @summary Exchange Google ID token
         * @param {ExchangeGoogleIdTokenBody} [exchangeGoogleIdTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleIdToken(exchangeGoogleIdTokenBody?: ExchangeGoogleIdTokenBody, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokenResponseData> {
            return localVarFp.exchangeGoogleIdToken(exchangeGoogleIdTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchanges a temporary token from Google OAuth callback for access and refresh tokens.
         * @summary Exchange Google temp token
         * @param {ExchangeGoogleTokenBody} [exchangeGoogleTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeGoogleToken(exchangeGoogleTokenBody?: ExchangeGoogleTokenBody, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokenResponseData> {
            return localVarFp.exchangeGoogleToken(exchangeGoogleTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchanges a refresh token for a new access token and extends the session.
         * @summary Refresh access token
         * @param {RefreshTokenBody} [refreshTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenBody?: RefreshTokenBody, options?: RawAxiosRequestConfig): AxiosPromise<RefreshTokenResponseData> {
            return localVarFp.refreshToken(refreshTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a magic link to the provided email address for passwordless authentication.
         * @summary Request magic link
         * @param {RequestMagicLinkBody} [requestMagicLinkBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMagicLink(requestMagicLinkBody?: RequestMagicLinkBody, options?: RawAxiosRequestConfig): AxiosPromise<MagicLinkRequestResponseData> {
            return localVarFp.requestMagicLink(requestMagicLinkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies a magic link token from the URL path and returns authentication tokens.
         * @summary Verify magic link
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyMagicLink(token: string, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokenResponseData> {
            return localVarFp.verifyMagicLink(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Exchanges Apple authentication data for access and refresh tokens. Handles both visible and hidden email cases using Apple\'s stable user ID.
     * @summary Exchange Apple auth data
     * @param {ExchangeAppleTokenBody} [exchangeAppleTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public exchangeAppleToken(exchangeAppleTokenBody?: ExchangeAppleTokenBody, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).exchangeAppleToken(exchangeAppleTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates a Google ID token and returns authentication tokens. Creates or updates user as needed.
     * @summary Exchange Google ID token
     * @param {ExchangeGoogleIdTokenBody} [exchangeGoogleIdTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public exchangeGoogleIdToken(exchangeGoogleIdTokenBody?: ExchangeGoogleIdTokenBody, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).exchangeGoogleIdToken(exchangeGoogleIdTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchanges a temporary token from Google OAuth callback for access and refresh tokens.
     * @summary Exchange Google temp token
     * @param {ExchangeGoogleTokenBody} [exchangeGoogleTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public exchangeGoogleToken(exchangeGoogleTokenBody?: ExchangeGoogleTokenBody, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).exchangeGoogleToken(exchangeGoogleTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchanges a refresh token for a new access token and extends the session.
     * @summary Refresh access token
     * @param {RefreshTokenBody} [refreshTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshToken(refreshTokenBody?: RefreshTokenBody, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refreshToken(refreshTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a magic link to the provided email address for passwordless authentication.
     * @summary Request magic link
     * @param {RequestMagicLinkBody} [requestMagicLinkBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public requestMagicLink(requestMagicLinkBody?: RequestMagicLinkBody, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).requestMagicLink(requestMagicLinkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies a magic link token from the URL path and returns authentication tokens.
     * @summary Verify magic link
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyMagicLink(token: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifyMagicLink(token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BookApi - axios parameter creator
 * @export
 */
export const BookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the user\'s reading progress for a book.
         * @summary Get reading progress
         * @param {string} [bookKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookProgress: async (bookKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/book/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bookKey !== undefined) {
                localVarQueryParameter['bookKey'] = bookKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the catalog of available books with cover URLs.
         * @summary List available books
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBooks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/book/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves the user\'s reading progress and records chapter activities.
         * @summary Save reading progress
         * @param {SaveBookProgressBody} [saveBookProgressBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBookProgress: async (saveBookProgressBody?: SaveBookProgressBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/book/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveBookProgressBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streams the book PDF from private storage. Landscape pages are cropped to portrait.
         * @summary Stream book PDF
         * @param {string} [bookKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamBook: async (bookKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/book/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bookKey !== undefined) {
                localVarQueryParameter['bookKey'] = bookKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookApi - functional programming interface
 * @export
 */
export const BookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the user\'s reading progress for a book.
         * @summary Get reading progress
         * @param {string} [bookKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookProgress(bookKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookProgress(bookKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookApi.getBookProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the catalog of available books with cover URLs.
         * @summary List available books
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBooks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBooks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookApi.listBooks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves the user\'s reading progress and records chapter activities.
         * @summary Save reading progress
         * @param {SaveBookProgressBody} [saveBookProgressBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBookProgress(saveBookProgressBody?: SaveBookProgressBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBookProgress(saveBookProgressBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookApi.saveBookProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Streams the book PDF from private storage. Landscape pages are cropped to portrait.
         * @summary Stream book PDF
         * @param {string} [bookKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async streamBook(bookKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamBook(bookKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookApi.streamBook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookApi - factory interface
 * @export
 */
export const BookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookApiFp(configuration)
    return {
        /**
         * Returns the user\'s reading progress for a book.
         * @summary Get reading progress
         * @param {string} [bookKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookProgress(bookKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookProgressResponse> {
            return localVarFp.getBookProgress(bookKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the catalog of available books with cover URLs.
         * @summary List available books
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBooks(options?: RawAxiosRequestConfig): AxiosPromise<BookListResponse> {
            return localVarFp.listBooks(options).then((request) => request(axios, basePath));
        },
        /**
         * Saves the user\'s reading progress and records chapter activities.
         * @summary Save reading progress
         * @param {SaveBookProgressBody} [saveBookProgressBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBookProgress(saveBookProgressBody?: SaveBookProgressBody, options?: RawAxiosRequestConfig): AxiosPromise<BookProgressResponse> {
            return localVarFp.saveBookProgress(saveBookProgressBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Streams the book PDF from private storage. Landscape pages are cropped to portrait.
         * @summary Stream book PDF
         * @param {string} [bookKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamBook(bookKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.streamBook(bookKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookApi - object-oriented interface
 * @export
 * @class BookApi
 * @extends {BaseAPI}
 */
export class BookApi extends BaseAPI {
    /**
     * Returns the user\'s reading progress for a book.
     * @summary Get reading progress
     * @param {string} [bookKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookApi
     */
    public getBookProgress(bookKey?: string, options?: RawAxiosRequestConfig) {
        return BookApiFp(this.configuration).getBookProgress(bookKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the catalog of available books with cover URLs.
     * @summary List available books
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookApi
     */
    public listBooks(options?: RawAxiosRequestConfig) {
        return BookApiFp(this.configuration).listBooks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves the user\'s reading progress and records chapter activities.
     * @summary Save reading progress
     * @param {SaveBookProgressBody} [saveBookProgressBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookApi
     */
    public saveBookProgress(saveBookProgressBody?: SaveBookProgressBody, options?: RawAxiosRequestConfig) {
        return BookApiFp(this.configuration).saveBookProgress(saveBookProgressBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Streams the book PDF from private storage. Landscape pages are cropped to portrait.
     * @summary Stream book PDF
     * @param {string} [bookKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookApi
     */
    public streamBook(bookKey?: string, options?: RawAxiosRequestConfig) {
        return BookApiFp(this.configuration).streamBook(bookKey, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommunityApi - axios parameter creator
 * @export
 */
export const CommunityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upserts a user by email with optional beta_tester meta. Returns whether the user already existed and was already a beta tester.
         * @summary Register a community member
         * @param {CommunitySignupBody} [communitySignupBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitySignup: async (communitySignupBody?: CommunitySignupBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/community/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communitySignupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates the contact form and sends an email to the configured recipient.
         * @summary Send a contact form message
         * @param {ContactSubmissionBody} [contactSubmissionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactSubmission: async (contactSubmissionBody?: ContactSubmissionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/community/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactSubmissionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunityApi - functional programming interface
 * @export
 */
export const CommunityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunityApiAxiosParamCreator(configuration)
    return {
        /**
         * Upserts a user by email with optional beta_tester meta. Returns whether the user already existed and was already a beta tester.
         * @summary Register a community member
         * @param {CommunitySignupBody} [communitySignupBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitySignup(communitySignupBody?: CommunitySignupBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunitySignupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitySignup(communitySignupBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.communitySignup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates the contact form and sends an email to the configured recipient.
         * @summary Send a contact form message
         * @param {ContactSubmissionBody} [contactSubmissionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactSubmission(contactSubmissionBody?: ContactSubmissionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactSubmission(contactSubmissionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.contactSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommunityApi - factory interface
 * @export
 */
export const CommunityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunityApiFp(configuration)
    return {
        /**
         * Upserts a user by email with optional beta_tester meta. Returns whether the user already existed and was already a beta tester.
         * @summary Register a community member
         * @param {CommunitySignupBody} [communitySignupBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitySignup(communitySignupBody?: CommunitySignupBody, options?: RawAxiosRequestConfig): AxiosPromise<CommunitySignupResponse> {
            return localVarFp.communitySignup(communitySignupBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates the contact form and sends an email to the configured recipient.
         * @summary Send a contact form message
         * @param {ContactSubmissionBody} [contactSubmissionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactSubmission(contactSubmissionBody?: ContactSubmissionBody, options?: RawAxiosRequestConfig): AxiosPromise<ContactSubmissionResponse> {
            return localVarFp.contactSubmission(contactSubmissionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommunityApi - object-oriented interface
 * @export
 * @class CommunityApi
 * @extends {BaseAPI}
 */
export class CommunityApi extends BaseAPI {
    /**
     * Upserts a user by email with optional beta_tester meta. Returns whether the user already existed and was already a beta tester.
     * @summary Register a community member
     * @param {CommunitySignupBody} [communitySignupBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public communitySignup(communitySignupBody?: CommunitySignupBody, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).communitySignup(communitySignupBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates the contact form and sends an email to the configured recipient.
     * @summary Send a contact form message
     * @param {ContactSubmissionBody} [contactSubmissionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public contactSubmission(contactSubmissionBody?: ContactSubmissionBody, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).contactSubmission(contactSubmissionBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExerciseApi - axios parameter creator
 * @export
 */
export const ExerciseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ends an active exercise session.
         * @summary End session
         * @param {number} id 
         * @param {EndSessionBody} [endSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endSession: async (id: number, endSessionBody?: EndSessionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('endSession', 'id', id)
            const localVarPath = `/exercises/sessions/{id}/end`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if the user has an active session for a specific exercise.
         * @summary Get active session
         * @param {string} exerciseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSession: async (exerciseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exerciseId' is not null or undefined
            assertParamExists('getActiveSession', 'exerciseId', exerciseId)
            const localVarPath = `/exercises/sessions/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (exerciseId !== undefined) {
                localVarQueryParameter['exerciseId'] = exerciseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the authenticated user\'s card-game tutorial completion flags from user metadata (users.meta.mobile_app.card_game_tutorial).
         * @summary Get card-game tutorial flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardGameTutorial: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises/card-game-tutorial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a single exercise by UID including its cards.
         * @summary Get exercise by UID
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExercise: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uid' is not null or undefined
            assertParamExists('getExercise', 'uid', uid)
            const localVarPath = `/exercises/{uid}`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves exercise progress statistics for the authenticated user.
         * @summary Get exercise progress
         * @param {ExerciseType} [exerciseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseProgress: async (exerciseType?: ExerciseType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (exerciseType !== undefined) {
                localVarQueryParameter['exerciseType'] = exerciseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific exercise session by ID.
         * @summary Get session by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSession', 'id', id)
            const localVarPath = `/exercises/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the authenticated user\'s card-game tutorial flags from user metadata.
         * @summary Get tutorial flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorialFlags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises/tutorial-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all published exercises from Strapi.
         * @summary List exercises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExercises: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a paginated list of exercise sessions for the authenticated user.
         * @summary List sessions
         * @param {ExerciseType} [exerciseType] 
         * @param {SessionStatus} [status] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessions: async (exerciseType?: ExerciseType, status?: SessionStatus, limit?: number, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (exerciseType !== undefined) {
                localVarQueryParameter['exerciseType'] = exerciseType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a new exercise session for the authenticated user.
         * @summary Start exercise session
         * @param {StartSessionBody} [startSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSession: async (startSessionBody?: StartSessionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submits a response to a card in an active session.
         * @summary Submit response
         * @param {number} id 
         * @param {SubmitResponseBody} [submitResponseBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitResponse: async (id: number, submitResponseBody?: SubmitResponseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitResponse', 'id', id)
            const localVarPath = `/exercises/sessions/{id}/respond`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Merges the provided card-game tutorial flags into the user\'s metadata (users.meta.mobile_app.card_game_tutorial). Only the supplied keys are updated — existing flags are preserved.
         * @summary Update card-game tutorial flags
         * @param {UpdateCardGameTutorialBody} [updateCardGameTutorialBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardGameTutorial: async (updateCardGameTutorialBody?: UpdateCardGameTutorialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises/card-game-tutorial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardGameTutorialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the deck order for an active session (e.g., after skipping a card).
         * @summary Update deck order
         * @param {number} id 
         * @param {UpdateDeckOrderBody} [updateDeckOrderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeckOrder: async (id: number, updateDeckOrderBody?: UpdateDeckOrderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDeckOrder', 'id', id)
            const localVarPath = `/exercises/sessions/{id}/deck-order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeckOrderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Merges the provided tutorial flags into the user\'s metadata. Only the supplied keys are updated — existing flags are preserved.
         * @summary Update tutorial flags
         * @param {UpdateTutorialFlagsBody} [updateTutorialFlagsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTutorialFlags: async (updateTutorialFlagsBody?: UpdateTutorialFlagsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exercises/tutorial-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTutorialFlagsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the tutorial status for an active session.
         * @summary Update tutorial status
         * @param {number} id 
         * @param {UpdateTutorialStatusBody} [updateTutorialStatusBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTutorialStatus: async (id: number, updateTutorialStatusBody?: UpdateTutorialStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTutorialStatus', 'id', id)
            const localVarPath = `/exercises/sessions/{id}/tutorial-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTutorialStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExerciseApi - functional programming interface
 * @export
 */
export const ExerciseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExerciseApiAxiosParamCreator(configuration)
    return {
        /**
         * Ends an active exercise session.
         * @summary End session
         * @param {number} id 
         * @param {EndSessionBody} [endSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endSession(id: number, endSessionBody?: EndSessionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EndSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endSession(id, endSessionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.endSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks if the user has an active session for a specific exercise.
         * @summary Get active session
         * @param {string} exerciseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveSession(exerciseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveSession(exerciseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.getActiveSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the authenticated user\'s card-game tutorial completion flags from user metadata (users.meta.mobile_app.card_game_tutorial).
         * @summary Get card-game tutorial flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardGameTutorial(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardGameTutorialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardGameTutorial(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.getCardGameTutorial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a single exercise by UID including its cards.
         * @summary Get exercise by UID
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExercise(uid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExercise(uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.getExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves exercise progress statistics for the authenticated user.
         * @summary Get exercise progress
         * @param {ExerciseType} [exerciseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExerciseProgress(exerciseType?: ExerciseType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExerciseProgress(exerciseType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.getExerciseProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a specific exercise session by ID.
         * @summary Get session by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSession(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.getSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the authenticated user\'s card-game tutorial flags from user metadata.
         * @summary Get tutorial flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTutorialFlags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TutorialFlagsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTutorialFlags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.getTutorialFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all published exercises from Strapi.
         * @summary List exercises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listExercises(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExerciseListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listExercises(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.listExercises']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a paginated list of exercise sessions for the authenticated user.
         * @summary List sessions
         * @param {ExerciseType} [exerciseType] 
         * @param {SessionStatus} [status] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSessions(exerciseType?: ExerciseType, status?: SessionStatus, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSessions(exerciseType, status, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.listSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a new exercise session for the authenticated user.
         * @summary Start exercise session
         * @param {StartSessionBody} [startSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSession(startSessionBody?: StartSessionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSession(startSessionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.startSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submits a response to a card in an active session.
         * @summary Submit response
         * @param {number} id 
         * @param {SubmitResponseBody} [submitResponseBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitResponse(id: number, submitResponseBody?: SubmitResponseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitResponse(id, submitResponseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.submitResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Merges the provided card-game tutorial flags into the user\'s metadata (users.meta.mobile_app.card_game_tutorial). Only the supplied keys are updated — existing flags are preserved.
         * @summary Update card-game tutorial flags
         * @param {UpdateCardGameTutorialBody} [updateCardGameTutorialBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardGameTutorial(updateCardGameTutorialBody?: UpdateCardGameTutorialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardGameTutorialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardGameTutorial(updateCardGameTutorialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.updateCardGameTutorial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the deck order for an active session (e.g., after skipping a card).
         * @summary Update deck order
         * @param {number} id 
         * @param {UpdateDeckOrderBody} [updateDeckOrderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeckOrder(id: number, updateDeckOrderBody?: UpdateDeckOrderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDeckOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeckOrder(id, updateDeckOrderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.updateDeckOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Merges the provided tutorial flags into the user\'s metadata. Only the supplied keys are updated — existing flags are preserved.
         * @summary Update tutorial flags
         * @param {UpdateTutorialFlagsBody} [updateTutorialFlagsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTutorialFlags(updateTutorialFlagsBody?: UpdateTutorialFlagsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TutorialFlagsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTutorialFlags(updateTutorialFlagsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.updateTutorialFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the tutorial status for an active session.
         * @summary Update tutorial status
         * @param {number} id 
         * @param {UpdateTutorialStatusBody} [updateTutorialStatusBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTutorialStatus(id: number, updateTutorialStatusBody?: UpdateTutorialStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTutorialStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTutorialStatus(id, updateTutorialStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExerciseApi.updateTutorialStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExerciseApi - factory interface
 * @export
 */
export const ExerciseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExerciseApiFp(configuration)
    return {
        /**
         * Ends an active exercise session.
         * @summary End session
         * @param {number} id 
         * @param {EndSessionBody} [endSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endSession(id: number, endSessionBody?: EndSessionBody, options?: RawAxiosRequestConfig): AxiosPromise<EndSessionResponse> {
            return localVarFp.endSession(id, endSessionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if the user has an active session for a specific exercise.
         * @summary Get active session
         * @param {string} exerciseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSession(exerciseId: string, options?: RawAxiosRequestConfig): AxiosPromise<ActiveSessionResponse> {
            return localVarFp.getActiveSession(exerciseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the authenticated user\'s card-game tutorial completion flags from user metadata (users.meta.mobile_app.card_game_tutorial).
         * @summary Get card-game tutorial flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardGameTutorial(options?: RawAxiosRequestConfig): AxiosPromise<CardGameTutorialResponse> {
            return localVarFp.getCardGameTutorial(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a single exercise by UID including its cards.
         * @summary Get exercise by UID
         * @param {string} uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExercise(uid: string, options?: RawAxiosRequestConfig): AxiosPromise<ExerciseDetailResponse> {
            return localVarFp.getExercise(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves exercise progress statistics for the authenticated user.
         * @summary Get exercise progress
         * @param {ExerciseType} [exerciseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExerciseProgress(exerciseType?: ExerciseType, options?: RawAxiosRequestConfig): AxiosPromise<ExerciseProgressResponse> {
            return localVarFp.getExerciseProgress(exerciseType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific exercise session by ID.
         * @summary Get session by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(id: number, options?: RawAxiosRequestConfig): AxiosPromise<SessionResponse> {
            return localVarFp.getSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the authenticated user\'s card-game tutorial flags from user metadata.
         * @summary Get tutorial flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorialFlags(options?: RawAxiosRequestConfig): AxiosPromise<TutorialFlagsResponse> {
            return localVarFp.getTutorialFlags(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all published exercises from Strapi.
         * @summary List exercises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExercises(options?: RawAxiosRequestConfig): AxiosPromise<ExerciseListResponse> {
            return localVarFp.listExercises(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a paginated list of exercise sessions for the authenticated user.
         * @summary List sessions
         * @param {ExerciseType} [exerciseType] 
         * @param {SessionStatus} [status] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSessions(exerciseType?: ExerciseType, status?: SessionStatus, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<SessionListResponse> {
            return localVarFp.listSessions(exerciseType, status, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a new exercise session for the authenticated user.
         * @summary Start exercise session
         * @param {StartSessionBody} [startSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSession(startSessionBody?: StartSessionBody, options?: RawAxiosRequestConfig): AxiosPromise<StartSessionResponse> {
            return localVarFp.startSession(startSessionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits a response to a card in an active session.
         * @summary Submit response
         * @param {number} id 
         * @param {SubmitResponseBody} [submitResponseBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitResponse(id: number, submitResponseBody?: SubmitResponseBody, options?: RawAxiosRequestConfig): AxiosPromise<SubmitResponseResponse> {
            return localVarFp.submitResponse(id, submitResponseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Merges the provided card-game tutorial flags into the user\'s metadata (users.meta.mobile_app.card_game_tutorial). Only the supplied keys are updated — existing flags are preserved.
         * @summary Update card-game tutorial flags
         * @param {UpdateCardGameTutorialBody} [updateCardGameTutorialBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardGameTutorial(updateCardGameTutorialBody?: UpdateCardGameTutorialBody, options?: RawAxiosRequestConfig): AxiosPromise<CardGameTutorialResponse> {
            return localVarFp.updateCardGameTutorial(updateCardGameTutorialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the deck order for an active session (e.g., after skipping a card).
         * @summary Update deck order
         * @param {number} id 
         * @param {UpdateDeckOrderBody} [updateDeckOrderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeckOrder(id: number, updateDeckOrderBody?: UpdateDeckOrderBody, options?: RawAxiosRequestConfig): AxiosPromise<UpdateDeckOrderResponse> {
            return localVarFp.updateDeckOrder(id, updateDeckOrderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Merges the provided tutorial flags into the user\'s metadata. Only the supplied keys are updated — existing flags are preserved.
         * @summary Update tutorial flags
         * @param {UpdateTutorialFlagsBody} [updateTutorialFlagsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTutorialFlags(updateTutorialFlagsBody?: UpdateTutorialFlagsBody, options?: RawAxiosRequestConfig): AxiosPromise<TutorialFlagsResponse> {
            return localVarFp.updateTutorialFlags(updateTutorialFlagsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the tutorial status for an active session.
         * @summary Update tutorial status
         * @param {number} id 
         * @param {UpdateTutorialStatusBody} [updateTutorialStatusBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTutorialStatus(id: number, updateTutorialStatusBody?: UpdateTutorialStatusBody, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTutorialStatusResponse> {
            return localVarFp.updateTutorialStatus(id, updateTutorialStatusBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExerciseApi - object-oriented interface
 * @export
 * @class ExerciseApi
 * @extends {BaseAPI}
 */
export class ExerciseApi extends BaseAPI {
    /**
     * Ends an active exercise session.
     * @summary End session
     * @param {number} id 
     * @param {EndSessionBody} [endSessionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public endSession(id: number, endSessionBody?: EndSessionBody, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).endSession(id, endSessionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if the user has an active session for a specific exercise.
     * @summary Get active session
     * @param {string} exerciseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public getActiveSession(exerciseId: string, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).getActiveSession(exerciseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the authenticated user\'s card-game tutorial completion flags from user metadata (users.meta.mobile_app.card_game_tutorial).
     * @summary Get card-game tutorial flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public getCardGameTutorial(options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).getCardGameTutorial(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a single exercise by UID including its cards.
     * @summary Get exercise by UID
     * @param {string} uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public getExercise(uid: string, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).getExercise(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves exercise progress statistics for the authenticated user.
     * @summary Get exercise progress
     * @param {ExerciseType} [exerciseType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public getExerciseProgress(exerciseType?: ExerciseType, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).getExerciseProgress(exerciseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific exercise session by ID.
     * @summary Get session by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public getSession(id: number, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).getSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the authenticated user\'s card-game tutorial flags from user metadata.
     * @summary Get tutorial flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public getTutorialFlags(options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).getTutorialFlags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all published exercises from Strapi.
     * @summary List exercises
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public listExercises(options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).listExercises(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a paginated list of exercise sessions for the authenticated user.
     * @summary List sessions
     * @param {ExerciseType} [exerciseType] 
     * @param {SessionStatus} [status] 
     * @param {number} [limit] 
     * @param {number | null} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public listSessions(exerciseType?: ExerciseType, status?: SessionStatus, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).listSessions(exerciseType, status, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a new exercise session for the authenticated user.
     * @summary Start exercise session
     * @param {StartSessionBody} [startSessionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public startSession(startSessionBody?: StartSessionBody, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).startSession(startSessionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submits a response to a card in an active session.
     * @summary Submit response
     * @param {number} id 
     * @param {SubmitResponseBody} [submitResponseBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public submitResponse(id: number, submitResponseBody?: SubmitResponseBody, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).submitResponse(id, submitResponseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Merges the provided card-game tutorial flags into the user\'s metadata (users.meta.mobile_app.card_game_tutorial). Only the supplied keys are updated — existing flags are preserved.
     * @summary Update card-game tutorial flags
     * @param {UpdateCardGameTutorialBody} [updateCardGameTutorialBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public updateCardGameTutorial(updateCardGameTutorialBody?: UpdateCardGameTutorialBody, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).updateCardGameTutorial(updateCardGameTutorialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the deck order for an active session (e.g., after skipping a card).
     * @summary Update deck order
     * @param {number} id 
     * @param {UpdateDeckOrderBody} [updateDeckOrderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public updateDeckOrder(id: number, updateDeckOrderBody?: UpdateDeckOrderBody, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).updateDeckOrder(id, updateDeckOrderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Merges the provided tutorial flags into the user\'s metadata. Only the supplied keys are updated — existing flags are preserved.
     * @summary Update tutorial flags
     * @param {UpdateTutorialFlagsBody} [updateTutorialFlagsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public updateTutorialFlags(updateTutorialFlagsBody?: UpdateTutorialFlagsBody, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).updateTutorialFlags(updateTutorialFlagsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the tutorial status for an active session.
     * @summary Update tutorial status
     * @param {number} id 
     * @param {UpdateTutorialStatusBody} [updateTutorialStatusBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseApi
     */
    public updateTutorialStatus(id: number, updateTutorialStatusBody?: UpdateTutorialStatusBody, options?: RawAxiosRequestConfig) {
        return ExerciseApiFp(this.configuration).updateTutorialStatus(id, updateTutorialStatusBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FacilitatorApi - axios parameter creator
 * @export
 */
export const FacilitatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Links the session to one of your relationships (or creates one) and confirms it for both of you.
         * @summary Accept the invite (invitee)
         * @param {string} id 
         * @param {AcceptFacilitatorInviteBody} [acceptFacilitatorInviteBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptFacilitatorInvite: async (id: string, acceptFacilitatorInviteBody?: AcceptFacilitatorInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acceptFacilitatorInvite', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptFacilitatorInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept the invitee\'s proposed time (host)
         * @summary Accept the invitee\'s proposed time (host)
         * @param {string} id 
         * @param {number} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptFacilitatorProposal: async (id: string, proposalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acceptFacilitatorProposal', 'id', id)
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('acceptFacilitatorProposal', 'proposalId', proposalId)
            const localVarPath = `/facilitator/sessions/{id}/proposals/{proposalId}/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel the session (host)
         * @summary Cancel the session (host)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFacilitatorSession: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelFacilitatorSession', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Binds the caller as the invitee (idempotent for the same user).
         * @summary Open an invite as the signed-in user
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimFacilitatorInvite: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('claimFacilitatorInvite', 'code', code)
            const localVarPath = `/facilitator/invites/{code}/claim`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires a verified phone number. Sends the invite SMS (and push if the invitee already uses konnect better).
         * @summary Create a session and send the SMS invite
         * @param {CreateFacilitatorSessionBody} [createFacilitatorSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilitatorSession: async (createFacilitatorSessionBody?: CreateFacilitatorSessionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facilitator/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFacilitatorSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline the invite (invitee)
         * @summary Decline the invite (invitee)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineFacilitatorInvite: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('declineFacilitatorInvite', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Session as seen by the caller (host or invitee).
         * @summary Get a session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorSession: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFacilitatorSession', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Licensed tracks (Calming Lofi, Classical) with short-lived URLs, plus the pre-selected option.
         * @summary List wind-down music
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitatorMusic: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facilitator/music`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by the web landing page: host first name and time only.
         * @summary Preview an invite (public)
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFacilitatorInvite: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('previewFacilitatorInvite', 'code', code)
            const localVarPath = `/facilitator/invites/{code}/preview`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Asks the host to confirm an alternative date, time and duration.
         * @summary Propose a new time (invitee)
         * @param {string} id 
         * @param {ProposeFacilitatorTimeBody} [proposeFacilitatorTimeBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proposeFacilitatorTime: async (id: string, proposeFacilitatorTimeBody?: ProposeFacilitatorTimeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('proposeFacilitatorTime', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/propose-time`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proposeFacilitatorTimeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline the invitee\'s proposed time (host)
         * @summary Decline the invitee\'s proposed time (host)
         * @param {string} id 
         * @param {number} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectFacilitatorProposal: async (id: string, proposalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectFacilitatorProposal', 'id', id)
            // verify required parameter 'proposalId' is not null or undefined
            assertParamExists('rejectFacilitatorProposal', 'proposalId', proposalId)
            const localVarPath = `/facilitator/sessions/{id}/proposals/{proposalId}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"proposalId"}}`, encodeURIComponent(String(proposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend the SMS invite (host)
         * @summary Resend the SMS invite (host)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendFacilitatorInvite: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resendFacilitatorInvite', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/resend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Private. The rating is also saved as a relationship check-in.
         * @summary Submit or skip the post-session check-in
         * @param {string} id 
         * @param {FacilitatorPostCheckInBody} [facilitatorPostCheckInBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorPostCheckIn: async (id: string, facilitatorPostCheckInBody?: FacilitatorPostCheckInBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitFacilitatorPostCheckIn', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/check-ins/post`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorPostCheckInBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Private to the AI. Mood(s), rating and 1-3 goals are required unless the 10-minute timer ran out.
         * @summary Submit the pre-session check-in
         * @param {string} id 
         * @param {FacilitatorPreCheckInBody} [facilitatorPreCheckInBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorPreCheckIn: async (id: string, facilitatorPreCheckInBody?: FacilitatorPreCheckInBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitFacilitatorPreCheckIn', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/check-ins/pre`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorPreCheckInBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changing the date, time or duration sends a new invite and needs a fresh answer.
         * @summary Edit a session (host)
         * @param {string} id 
         * @param {UpdateFacilitatorSessionBody} [updateFacilitatorSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilitatorSession: async (id: string, updateFacilitatorSessionBody?: UpdateFacilitatorSessionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFacilitatorSession', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFacilitatorSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacilitatorApi - functional programming interface
 * @export
 */
export const FacilitatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacilitatorApiAxiosParamCreator(configuration)
    return {
        /**
         * Links the session to one of your relationships (or creates one) and confirms it for both of you.
         * @summary Accept the invite (invitee)
         * @param {string} id 
         * @param {AcceptFacilitatorInviteBody} [acceptFacilitatorInviteBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptFacilitatorInvite(id: string, acceptFacilitatorInviteBody?: AcceptFacilitatorInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptFacilitatorInvite(id, acceptFacilitatorInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.acceptFacilitatorInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept the invitee\'s proposed time (host)
         * @summary Accept the invitee\'s proposed time (host)
         * @param {string} id 
         * @param {number} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptFacilitatorProposal(id: string, proposalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptFacilitatorProposal(id, proposalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.acceptFacilitatorProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel the session (host)
         * @summary Cancel the session (host)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelFacilitatorSession(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelFacilitatorSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.cancelFacilitatorSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Binds the caller as the invitee (idempotent for the same user).
         * @summary Open an invite as the signed-in user
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimFacilitatorInvite(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimFacilitatorInvite(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.claimFacilitatorInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires a verified phone number. Sends the invite SMS (and push if the invitee already uses konnect better).
         * @summary Create a session and send the SMS invite
         * @param {CreateFacilitatorSessionBody} [createFacilitatorSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFacilitatorSession(createFacilitatorSessionBody?: CreateFacilitatorSessionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFacilitatorSession(createFacilitatorSessionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.createFacilitatorSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline the invite (invitee)
         * @summary Decline the invite (invitee)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineFacilitatorInvite(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineFacilitatorInvite(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.declineFacilitatorInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Session as seen by the caller (host or invitee).
         * @summary Get a session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilitatorSession(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilitatorSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.getFacilitatorSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Licensed tracks (Calming Lofi, Classical) with short-lived URLs, plus the pre-selected option.
         * @summary List wind-down music
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFacilitatorMusic(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorMusicCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFacilitatorMusic(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.listFacilitatorMusic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used by the web landing page: host first name and time only.
         * @summary Preview an invite (public)
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewFacilitatorInvite(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorInvitePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewFacilitatorInvite(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.previewFacilitatorInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Asks the host to confirm an alternative date, time and duration.
         * @summary Propose a new time (invitee)
         * @param {string} id 
         * @param {ProposeFacilitatorTimeBody} [proposeFacilitatorTimeBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proposeFacilitatorTime(id: string, proposeFacilitatorTimeBody?: ProposeFacilitatorTimeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proposeFacilitatorTime(id, proposeFacilitatorTimeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.proposeFacilitatorTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline the invitee\'s proposed time (host)
         * @summary Decline the invitee\'s proposed time (host)
         * @param {string} id 
         * @param {number} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectFacilitatorProposal(id: string, proposalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectFacilitatorProposal(id, proposalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.rejectFacilitatorProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend the SMS invite (host)
         * @summary Resend the SMS invite (host)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendFacilitatorInvite(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendFacilitatorInvite(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.resendFacilitatorInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Private. The rating is also saved as a relationship check-in.
         * @summary Submit or skip the post-session check-in
         * @param {string} id 
         * @param {FacilitatorPostCheckInBody} [facilitatorPostCheckInBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFacilitatorPostCheckIn(id: string, facilitatorPostCheckInBody?: FacilitatorPostCheckInBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFacilitatorPostCheckIn(id, facilitatorPostCheckInBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.submitFacilitatorPostCheckIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Private to the AI. Mood(s), rating and 1-3 goals are required unless the 10-minute timer ran out.
         * @summary Submit the pre-session check-in
         * @param {string} id 
         * @param {FacilitatorPreCheckInBody} [facilitatorPreCheckInBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFacilitatorPreCheckIn(id: string, facilitatorPreCheckInBody?: FacilitatorPreCheckInBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFacilitatorPreCheckIn(id, facilitatorPreCheckInBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.submitFacilitatorPreCheckIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changing the date, time or duration sends a new invite and needs a fresh answer.
         * @summary Edit a session (host)
         * @param {string} id 
         * @param {UpdateFacilitatorSessionBody} [updateFacilitatorSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFacilitatorSession(id: string, updateFacilitatorSessionBody?: UpdateFacilitatorSessionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFacilitatorSession(id, updateFacilitatorSessionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorApi.updateFacilitatorSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacilitatorApi - factory interface
 * @export
 */
export const FacilitatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacilitatorApiFp(configuration)
    return {
        /**
         * Links the session to one of your relationships (or creates one) and confirms it for both of you.
         * @summary Accept the invite (invitee)
         * @param {string} id 
         * @param {AcceptFacilitatorInviteBody} [acceptFacilitatorInviteBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptFacilitatorInvite(id: string, acceptFacilitatorInviteBody?: AcceptFacilitatorInviteBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.acceptFacilitatorInvite(id, acceptFacilitatorInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept the invitee\'s proposed time (host)
         * @summary Accept the invitee\'s proposed time (host)
         * @param {string} id 
         * @param {number} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptFacilitatorProposal(id: string, proposalId: number, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.acceptFacilitatorProposal(id, proposalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel the session (host)
         * @summary Cancel the session (host)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFacilitatorSession(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.cancelFacilitatorSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Binds the caller as the invitee (idempotent for the same user).
         * @summary Open an invite as the signed-in user
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimFacilitatorInvite(code: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.claimFacilitatorInvite(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires a verified phone number. Sends the invite SMS (and push if the invitee already uses konnect better).
         * @summary Create a session and send the SMS invite
         * @param {CreateFacilitatorSessionBody} [createFacilitatorSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFacilitatorSession(createFacilitatorSessionBody?: CreateFacilitatorSessionBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.createFacilitatorSession(createFacilitatorSessionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline the invite (invitee)
         * @summary Decline the invite (invitee)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineFacilitatorInvite(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.declineFacilitatorInvite(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Session as seen by the caller (host or invitee).
         * @summary Get a session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorSession(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.getFacilitatorSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Licensed tracks (Calming Lofi, Classical) with short-lived URLs, plus the pre-selected option.
         * @summary List wind-down music
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitatorMusic(options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorMusicCatalogResponse> {
            return localVarFp.listFacilitatorMusic(options).then((request) => request(axios, basePath));
        },
        /**
         * Used by the web landing page: host first name and time only.
         * @summary Preview an invite (public)
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFacilitatorInvite(code: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorInvitePreviewResponse> {
            return localVarFp.previewFacilitatorInvite(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Asks the host to confirm an alternative date, time and duration.
         * @summary Propose a new time (invitee)
         * @param {string} id 
         * @param {ProposeFacilitatorTimeBody} [proposeFacilitatorTimeBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proposeFacilitatorTime(id: string, proposeFacilitatorTimeBody?: ProposeFacilitatorTimeBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.proposeFacilitatorTime(id, proposeFacilitatorTimeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline the invitee\'s proposed time (host)
         * @summary Decline the invitee\'s proposed time (host)
         * @param {string} id 
         * @param {number} proposalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectFacilitatorProposal(id: string, proposalId: number, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.rejectFacilitatorProposal(id, proposalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend the SMS invite (host)
         * @summary Resend the SMS invite (host)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendFacilitatorInvite(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.resendFacilitatorInvite(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Private. The rating is also saved as a relationship check-in.
         * @summary Submit or skip the post-session check-in
         * @param {string} id 
         * @param {FacilitatorPostCheckInBody} [facilitatorPostCheckInBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorPostCheckIn(id: string, facilitatorPostCheckInBody?: FacilitatorPostCheckInBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.submitFacilitatorPostCheckIn(id, facilitatorPostCheckInBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Private to the AI. Mood(s), rating and 1-3 goals are required unless the 10-minute timer ran out.
         * @summary Submit the pre-session check-in
         * @param {string} id 
         * @param {FacilitatorPreCheckInBody} [facilitatorPreCheckInBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorPreCheckIn(id: string, facilitatorPreCheckInBody?: FacilitatorPreCheckInBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.submitFacilitatorPreCheckIn(id, facilitatorPreCheckInBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Changing the date, time or duration sends a new invite and needs a fresh answer.
         * @summary Edit a session (host)
         * @param {string} id 
         * @param {UpdateFacilitatorSessionBody} [updateFacilitatorSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilitatorSession(id: string, updateFacilitatorSessionBody?: UpdateFacilitatorSessionBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionResponse> {
            return localVarFp.updateFacilitatorSession(id, updateFacilitatorSessionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FacilitatorApi - object-oriented interface
 * @export
 * @class FacilitatorApi
 * @extends {BaseAPI}
 */
export class FacilitatorApi extends BaseAPI {
    /**
     * Links the session to one of your relationships (or creates one) and confirms it for both of you.
     * @summary Accept the invite (invitee)
     * @param {string} id 
     * @param {AcceptFacilitatorInviteBody} [acceptFacilitatorInviteBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public acceptFacilitatorInvite(id: string, acceptFacilitatorInviteBody?: AcceptFacilitatorInviteBody, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).acceptFacilitatorInvite(id, acceptFacilitatorInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept the invitee\'s proposed time (host)
     * @summary Accept the invitee\'s proposed time (host)
     * @param {string} id 
     * @param {number} proposalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public acceptFacilitatorProposal(id: string, proposalId: number, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).acceptFacilitatorProposal(id, proposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel the session (host)
     * @summary Cancel the session (host)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public cancelFacilitatorSession(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).cancelFacilitatorSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Binds the caller as the invitee (idempotent for the same user).
     * @summary Open an invite as the signed-in user
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public claimFacilitatorInvite(code: string, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).claimFacilitatorInvite(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires a verified phone number. Sends the invite SMS (and push if the invitee already uses konnect better).
     * @summary Create a session and send the SMS invite
     * @param {CreateFacilitatorSessionBody} [createFacilitatorSessionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public createFacilitatorSession(createFacilitatorSessionBody?: CreateFacilitatorSessionBody, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).createFacilitatorSession(createFacilitatorSessionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline the invite (invitee)
     * @summary Decline the invite (invitee)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public declineFacilitatorInvite(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).declineFacilitatorInvite(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Session as seen by the caller (host or invitee).
     * @summary Get a session
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public getFacilitatorSession(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).getFacilitatorSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Licensed tracks (Calming Lofi, Classical) with short-lived URLs, plus the pre-selected option.
     * @summary List wind-down music
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public listFacilitatorMusic(options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).listFacilitatorMusic(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by the web landing page: host first name and time only.
     * @summary Preview an invite (public)
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public previewFacilitatorInvite(code: string, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).previewFacilitatorInvite(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Asks the host to confirm an alternative date, time and duration.
     * @summary Propose a new time (invitee)
     * @param {string} id 
     * @param {ProposeFacilitatorTimeBody} [proposeFacilitatorTimeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public proposeFacilitatorTime(id: string, proposeFacilitatorTimeBody?: ProposeFacilitatorTimeBody, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).proposeFacilitatorTime(id, proposeFacilitatorTimeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline the invitee\'s proposed time (host)
     * @summary Decline the invitee\'s proposed time (host)
     * @param {string} id 
     * @param {number} proposalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public rejectFacilitatorProposal(id: string, proposalId: number, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).rejectFacilitatorProposal(id, proposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend the SMS invite (host)
     * @summary Resend the SMS invite (host)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public resendFacilitatorInvite(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).resendFacilitatorInvite(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Private. The rating is also saved as a relationship check-in.
     * @summary Submit or skip the post-session check-in
     * @param {string} id 
     * @param {FacilitatorPostCheckInBody} [facilitatorPostCheckInBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public submitFacilitatorPostCheckIn(id: string, facilitatorPostCheckInBody?: FacilitatorPostCheckInBody, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).submitFacilitatorPostCheckIn(id, facilitatorPostCheckInBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Private to the AI. Mood(s), rating and 1-3 goals are required unless the 10-minute timer ran out.
     * @summary Submit the pre-session check-in
     * @param {string} id 
     * @param {FacilitatorPreCheckInBody} [facilitatorPreCheckInBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public submitFacilitatorPreCheckIn(id: string, facilitatorPreCheckInBody?: FacilitatorPreCheckInBody, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).submitFacilitatorPreCheckIn(id, facilitatorPreCheckInBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changing the date, time or duration sends a new invite and needs a fresh answer.
     * @summary Edit a session (host)
     * @param {string} id 
     * @param {UpdateFacilitatorSessionBody} [updateFacilitatorSessionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public updateFacilitatorSession(id: string, updateFacilitatorSessionBody?: UpdateFacilitatorSessionBody, options?: RawAxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).updateFacilitatorSession(id, updateFacilitatorSessionBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FacilitatorHistoryApi - axios parameter creator
 * @export
 */
export const FacilitatorHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Up to 5 custom steps, 200 characters each.
         * @summary Add a custom next step
         * @param {string} id 
         * @param {FacilitatorAddNextStepBody} [facilitatorAddNextStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacilitatorNextStep: async (id: string, facilitatorAddNextStepBody?: FacilitatorAddNextStepBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addFacilitatorNextStep', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/next-steps`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorAddNextStepBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the private journal entry for this session.
         * @summary Delete the session journal entry
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilitatorJournal: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFacilitatorJournal', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/journal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only custom steps can be removed.
         * @summary Remove a custom next step
         * @param {string} id 
         * @param {number} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilitatorNextStep: async (id: string, stepId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFacilitatorNextStep', 'id', id)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('deleteFacilitatorNextStep', 'stepId', stepId)
            const localVarPath = `/facilitator/sessions/{id}/next-steps/{stepId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently removes the caller\'s summary, next steps, journal and check-ins for this session.
         * @summary Delete a session from my history
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilitatorSessionFromHistory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFacilitatorSessionFromHistory', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recurring, resolved and new themes once there are 3+ sessions with the same person (null before that).
         * @summary Relationship insights
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorInsights: async (relationshipId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationshipId' is not null or undefined
            assertParamExists('getFacilitatorInsights', 'relationshipId', relationshipId)
            const localVarPath = `/facilitator/insights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (relationshipId !== undefined) {
                localVarQueryParameter['relationshipId'] = relationshipId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shared summary, private reflection, next steps and journal entry. No transcript.
         * @summary Get the caller\'s session summary
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorSummary: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFacilitatorSummary', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Filters: role (created by me / invites), display statuses, name search, person, date range.
         * @summary List sessions (Upcoming / History)
         * @param {ListFacilitatorSessionsTab} [tab] 
         * @param {ListFacilitatorSessionsRole} [role] 
         * @param {Array<FacilitatorDisplayStatus>} [statuses] 
         * @param {string} [q] 
         * @param {number} [relationshipId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitatorSessions: async (tab?: ListFacilitatorSessionsTab, role?: ListFacilitatorSessionsRole, statuses?: Array<FacilitatorDisplayStatus>, q?: string, relationshipId?: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facilitator/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (relationshipId !== undefined) {
                localVarQueryParameter['relationshipId'] = relationshipId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Up to 5 pinned sessions.
         * @summary Pin or unpin a session
         * @param {string} id 
         * @param {FacilitatorPinBody} [facilitatorPinBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinFacilitatorSession: async (id: string, facilitatorPinBody?: FacilitatorPinBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pinFacilitatorSession', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/pin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorPinBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One entry per person per session, up to 2,000 characters. Never shared.
         * @summary Save the private session journal entry
         * @param {string} id 
         * @param {FacilitatorJournalBody} [facilitatorJournalBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFacilitatorJournal: async (id: string, facilitatorJournalBody?: FacilitatorJournalBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveFacilitatorJournal', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/journal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorJournalBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Push reminder to check in on the relationship (null clears it).
         * @summary Set or clear the follow-up reminder
         * @param {string} id 
         * @param {FacilitatorReminderBody} [facilitatorReminderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFacilitatorReminder: async (id: string, facilitatorReminderBody?: FacilitatorReminderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setFacilitatorReminder', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/reminder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorReminderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * not_started / in_progress / done.
         * @summary Update a next step status
         * @param {string} id 
         * @param {number} stepId 
         * @param {FacilitatorUpdateNextStepBody} [facilitatorUpdateNextStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilitatorNextStep: async (id: string, stepId: number, facilitatorUpdateNextStepBody?: FacilitatorUpdateNextStepBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFacilitatorNextStep', 'id', id)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('updateFacilitatorNextStep', 'stepId', stepId)
            const localVarPath = `/facilitator/sessions/{id}/next-steps/{stepId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorUpdateNextStepBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacilitatorHistoryApi - functional programming interface
 * @export
 */
export const FacilitatorHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacilitatorHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Up to 5 custom steps, 200 characters each.
         * @summary Add a custom next step
         * @param {string} id 
         * @param {FacilitatorAddNextStepBody} [facilitatorAddNextStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFacilitatorNextStep(id: string, facilitatorAddNextStepBody?: FacilitatorAddNextStepBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFacilitatorNextStep(id, facilitatorAddNextStepBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.addFacilitatorNextStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the private journal entry for this session.
         * @summary Delete the session journal entry
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFacilitatorJournal(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFacilitatorJournal(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.deleteFacilitatorJournal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only custom steps can be removed.
         * @summary Remove a custom next step
         * @param {string} id 
         * @param {number} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFacilitatorNextStep(id: string, stepId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFacilitatorNextStep(id, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.deleteFacilitatorNextStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently removes the caller\'s summary, next steps, journal and check-ins for this session.
         * @summary Delete a session from my history
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFacilitatorSessionFromHistory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFacilitatorSessionFromHistory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.deleteFacilitatorSessionFromHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Recurring, resolved and new themes once there are 3+ sessions with the same person (null before that).
         * @summary Relationship insights
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilitatorInsights(relationshipId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilitatorInsights(relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.getFacilitatorInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Shared summary, private reflection, next steps and journal entry. No transcript.
         * @summary Get the caller\'s session summary
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilitatorSummary(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilitatorSummary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.getFacilitatorSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Filters: role (created by me / invites), display statuses, name search, person, date range.
         * @summary List sessions (Upcoming / History)
         * @param {ListFacilitatorSessionsTab} [tab] 
         * @param {ListFacilitatorSessionsRole} [role] 
         * @param {Array<FacilitatorDisplayStatus>} [statuses] 
         * @param {string} [q] 
         * @param {number} [relationshipId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFacilitatorSessions(tab?: ListFacilitatorSessionsTab, role?: ListFacilitatorSessionsRole, statuses?: Array<FacilitatorDisplayStatus>, q?: string, relationshipId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSessionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFacilitatorSessions(tab, role, statuses, q, relationshipId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.listFacilitatorSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Up to 5 pinned sessions.
         * @summary Pin or unpin a session
         * @param {string} id 
         * @param {FacilitatorPinBody} [facilitatorPinBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pinFacilitatorSession(id: string, facilitatorPinBody?: FacilitatorPinBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pinFacilitatorSession(id, facilitatorPinBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.pinFacilitatorSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One entry per person per session, up to 2,000 characters. Never shared.
         * @summary Save the private session journal entry
         * @param {string} id 
         * @param {FacilitatorJournalBody} [facilitatorJournalBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFacilitatorJournal(id: string, facilitatorJournalBody?: FacilitatorJournalBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorJournalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFacilitatorJournal(id, facilitatorJournalBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.saveFacilitatorJournal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Push reminder to check in on the relationship (null clears it).
         * @summary Set or clear the follow-up reminder
         * @param {string} id 
         * @param {FacilitatorReminderBody} [facilitatorReminderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFacilitatorReminder(id: string, facilitatorReminderBody?: FacilitatorReminderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFacilitatorReminder(id, facilitatorReminderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.setFacilitatorReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * not_started / in_progress / done.
         * @summary Update a next step status
         * @param {string} id 
         * @param {number} stepId 
         * @param {FacilitatorUpdateNextStepBody} [facilitatorUpdateNextStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFacilitatorNextStep(id: string, stepId: number, facilitatorUpdateNextStepBody?: FacilitatorUpdateNextStepBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFacilitatorNextStep(id, stepId, facilitatorUpdateNextStepBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorHistoryApi.updateFacilitatorNextStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacilitatorHistoryApi - factory interface
 * @export
 */
export const FacilitatorHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacilitatorHistoryApiFp(configuration)
    return {
        /**
         * Up to 5 custom steps, 200 characters each.
         * @summary Add a custom next step
         * @param {string} id 
         * @param {FacilitatorAddNextStepBody} [facilitatorAddNextStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacilitatorNextStep(id: string, facilitatorAddNextStepBody?: FacilitatorAddNextStepBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSummaryResponse> {
            return localVarFp.addFacilitatorNextStep(id, facilitatorAddNextStepBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the private journal entry for this session.
         * @summary Delete the session journal entry
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilitatorJournal(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFacilitatorJournal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Only custom steps can be removed.
         * @summary Remove a custom next step
         * @param {string} id 
         * @param {number} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilitatorNextStep(id: string, stepId: number, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSummaryResponse> {
            return localVarFp.deleteFacilitatorNextStep(id, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently removes the caller\'s summary, next steps, journal and check-ins for this session.
         * @summary Delete a session from my history
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFacilitatorSessionFromHistory(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFacilitatorSessionFromHistory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Recurring, resolved and new themes once there are 3+ sessions with the same person (null before that).
         * @summary Relationship insights
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorInsights(relationshipId: number, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorInsightsResponse> {
            return localVarFp.getFacilitatorInsights(relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Shared summary, private reflection, next steps and journal entry. No transcript.
         * @summary Get the caller\'s session summary
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorSummary(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSummaryResponse> {
            return localVarFp.getFacilitatorSummary(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Filters: role (created by me / invites), display statuses, name search, person, date range.
         * @summary List sessions (Upcoming / History)
         * @param {ListFacilitatorSessionsTab} [tab] 
         * @param {ListFacilitatorSessionsRole} [role] 
         * @param {Array<FacilitatorDisplayStatus>} [statuses] 
         * @param {string} [q] 
         * @param {number} [relationshipId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitatorSessions(tab?: ListFacilitatorSessionsTab, role?: ListFacilitatorSessionsRole, statuses?: Array<FacilitatorDisplayStatus>, q?: string, relationshipId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSessionListResponse> {
            return localVarFp.listFacilitatorSessions(tab, role, statuses, q, relationshipId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Up to 5 pinned sessions.
         * @summary Pin or unpin a session
         * @param {string} id 
         * @param {FacilitatorPinBody} [facilitatorPinBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinFacilitatorSession(id: string, facilitatorPinBody?: FacilitatorPinBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pinFacilitatorSession(id, facilitatorPinBody, options).then((request) => request(axios, basePath));
        },
        /**
         * One entry per person per session, up to 2,000 characters. Never shared.
         * @summary Save the private session journal entry
         * @param {string} id 
         * @param {FacilitatorJournalBody} [facilitatorJournalBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFacilitatorJournal(id: string, facilitatorJournalBody?: FacilitatorJournalBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorJournalResponse> {
            return localVarFp.saveFacilitatorJournal(id, facilitatorJournalBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Push reminder to check in on the relationship (null clears it).
         * @summary Set or clear the follow-up reminder
         * @param {string} id 
         * @param {FacilitatorReminderBody} [facilitatorReminderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFacilitatorReminder(id: string, facilitatorReminderBody?: FacilitatorReminderBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSummaryResponse> {
            return localVarFp.setFacilitatorReminder(id, facilitatorReminderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * not_started / in_progress / done.
         * @summary Update a next step status
         * @param {string} id 
         * @param {number} stepId 
         * @param {FacilitatorUpdateNextStepBody} [facilitatorUpdateNextStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilitatorNextStep(id: string, stepId: number, facilitatorUpdateNextStepBody?: FacilitatorUpdateNextStepBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorSummaryResponse> {
            return localVarFp.updateFacilitatorNextStep(id, stepId, facilitatorUpdateNextStepBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FacilitatorHistoryApi - object-oriented interface
 * @export
 * @class FacilitatorHistoryApi
 * @extends {BaseAPI}
 */
export class FacilitatorHistoryApi extends BaseAPI {
    /**
     * Up to 5 custom steps, 200 characters each.
     * @summary Add a custom next step
     * @param {string} id 
     * @param {FacilitatorAddNextStepBody} [facilitatorAddNextStepBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public addFacilitatorNextStep(id: string, facilitatorAddNextStepBody?: FacilitatorAddNextStepBody, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).addFacilitatorNextStep(id, facilitatorAddNextStepBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the private journal entry for this session.
     * @summary Delete the session journal entry
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public deleteFacilitatorJournal(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).deleteFacilitatorJournal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only custom steps can be removed.
     * @summary Remove a custom next step
     * @param {string} id 
     * @param {number} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public deleteFacilitatorNextStep(id: string, stepId: number, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).deleteFacilitatorNextStep(id, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently removes the caller\'s summary, next steps, journal and check-ins for this session.
     * @summary Delete a session from my history
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public deleteFacilitatorSessionFromHistory(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).deleteFacilitatorSessionFromHistory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recurring, resolved and new themes once there are 3+ sessions with the same person (null before that).
     * @summary Relationship insights
     * @param {number} relationshipId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public getFacilitatorInsights(relationshipId: number, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).getFacilitatorInsights(relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shared summary, private reflection, next steps and journal entry. No transcript.
     * @summary Get the caller\'s session summary
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public getFacilitatorSummary(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).getFacilitatorSummary(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Filters: role (created by me / invites), display statuses, name search, person, date range.
     * @summary List sessions (Upcoming / History)
     * @param {ListFacilitatorSessionsTab} [tab] 
     * @param {ListFacilitatorSessionsRole} [role] 
     * @param {Array<FacilitatorDisplayStatus>} [statuses] 
     * @param {string} [q] 
     * @param {number} [relationshipId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public listFacilitatorSessions(tab?: ListFacilitatorSessionsTab, role?: ListFacilitatorSessionsRole, statuses?: Array<FacilitatorDisplayStatus>, q?: string, relationshipId?: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).listFacilitatorSessions(tab, role, statuses, q, relationshipId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Up to 5 pinned sessions.
     * @summary Pin or unpin a session
     * @param {string} id 
     * @param {FacilitatorPinBody} [facilitatorPinBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public pinFacilitatorSession(id: string, facilitatorPinBody?: FacilitatorPinBody, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).pinFacilitatorSession(id, facilitatorPinBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One entry per person per session, up to 2,000 characters. Never shared.
     * @summary Save the private session journal entry
     * @param {string} id 
     * @param {FacilitatorJournalBody} [facilitatorJournalBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public saveFacilitatorJournal(id: string, facilitatorJournalBody?: FacilitatorJournalBody, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).saveFacilitatorJournal(id, facilitatorJournalBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Push reminder to check in on the relationship (null clears it).
     * @summary Set or clear the follow-up reminder
     * @param {string} id 
     * @param {FacilitatorReminderBody} [facilitatorReminderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public setFacilitatorReminder(id: string, facilitatorReminderBody?: FacilitatorReminderBody, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).setFacilitatorReminder(id, facilitatorReminderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * not_started / in_progress / done.
     * @summary Update a next step status
     * @param {string} id 
     * @param {number} stepId 
     * @param {FacilitatorUpdateNextStepBody} [facilitatorUpdateNextStepBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorHistoryApi
     */
    public updateFacilitatorNextStep(id: string, stepId: number, facilitatorUpdateNextStepBody?: FacilitatorUpdateNextStepBody, options?: RawAxiosRequestConfig) {
        return FacilitatorHistoryApiFp(this.configuration).updateFacilitatorNextStep(id, stepId, facilitatorUpdateNextStepBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum ListFacilitatorSessionsTab {
    Upcoming = 'upcoming',
    History = 'history'
}
/**
  * @export
  * @enum {string}
  */
export enum ListFacilitatorSessionsRole {
    All = 'all',
    Created = 'created',
    Invited = 'invited'
}


/**
 * FacilitatorLiveApi - axios parameter creator
 * @export
 */
export const FacilitatorLiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Answer the inactivity prompt with Continue
         * @summary Answer the inactivity prompt with Continue
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeFacilitatorActivity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acknowledgeFacilitatorActivity', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/activity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * I\'m okay to continue
         * @summary I\'m okay to continue
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueFacilitatorAfterCrisis: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('continueFacilitatorAfterCrisis', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/crisis/continue`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * wrap_up ends with the final synthesis; keep_going / timeout continue the session.
         * @summary Answer the AI\'s wrap-up offer
         * @param {string} id 
         * @param {FacilitatorWrapUpBody} [facilitatorWrapUpBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decideFacilitatorWrapUp: async (id: string, facilitatorWrapUpBody?: FacilitatorWrapUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('decideFacilitatorWrapUp', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/wrap-up`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorWrapUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes the session. Cannot be recovered.
         * @summary Discard an interrupted session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardFacilitatorLive: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('discardFacilitatorLive', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Either person can end it. Generates summaries and sends the post-session check-in.
         * @summary End the session
         * @param {string} id 
         * @param {FacilitatorEndBody} [facilitatorEndBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endFacilitatorLive: async (id: string, facilitatorEndBody?: FacilitatorEndBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('endFacilitatorLive', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/end`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorEndBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds 15 or 30 minutes, up to 2 hours total.
         * @summary Extend the session (host, last 5 minutes)
         * @param {string} id 
         * @param {FacilitatorExtendBody} [facilitatorExtendBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendFacilitatorLive: async (id: string, facilitatorExtendBody?: FacilitatorExtendBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('extendFacilitatorLive', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/extend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorExtendBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Quiet for 10 minutes: prompt, then auto-end
         * @summary Quiet for 10 minutes: prompt, then auto-end
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitatorInactivityCheck: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('facilitatorInactivityCheck', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/inactivity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Timer reached zero: final synthesis, then grace period
         * @summary Timer reached zero: final synthesis, then grace period
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitatorTimeUp: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('facilitatorTimeUp', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/time-up`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Host: timer, turn, prompts and thread. Invitee: session only (it runs on the host\'s phone).
         * @summary Get the live session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorLive: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFacilitatorLive', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * MP3 of one facilitator message, generated on request and never stored. Available until the transcript is purged.
         * @summary A facilitator message read aloud (host)
         * @param {string} id 
         * @param {number} seq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorMessageSpeech: async (id: string, seq: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFacilitatorMessageSpeech', 'id', id)
            // verify required parameter 'seq' is not null or undefined
            assertParamExists('getFacilitatorMessageSpeech', 'seq', seq)
            const localVarPath = `/facilitator/sessions/{id}/live/messages/{seq}/speech`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seq"}}`, encodeURIComponent(String(seq)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For the \"Resume session?\" prompt on app open.
         * @summary Sessions left in progress (host)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterruptedFacilitatorSessions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facilitator/sessions/interrupted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Take a break
         * @summary Take a break
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseFacilitatorLive: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pauseFacilitatorLive', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/pause`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resume after a break (AI recap)
         * @summary Resume after a break (AI recap)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeFacilitatorLive: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resumeFacilitatorLive', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/resume`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry the facilitator reply
         * @summary Retry the facilitator reply
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFacilitatorReply: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryFacilitatorReply', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/retry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin the session (opening message)
         * @summary Begin the session (opening message)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFacilitatorLive: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startFacilitatorLive', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/start`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * multipart/form-data with an `audio` file (m4a/aac/wav/webm, max 10 MB). Transcribed, then the AI replies.
         * @summary Submit a spoken turn (audio)
         * @param {string} id 
         * @param {File} audio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorSpokenTurn: async (id: string, audio: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitFacilitatorSpokenTurn', 'id', id)
            // verify required parameter 'audio' is not null or undefined
            assertParamExists('submitFacilitatorSpokenTurn', 'audio', audio)
            const localVarPath = `/facilitator/sessions/{id}/live/turns`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (audio !== undefined) { 
                localVarFormParams.append('audio', audio as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fallback when the microphone is unavailable.
         * @summary Submit a typed turn
         * @param {string} id 
         * @param {FacilitatorTypedTurnBody} [facilitatorTypedTurnBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorTypedTurn: async (id: string, facilitatorTypedTurnBody?: FacilitatorTypedTurnBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitFacilitatorTypedTurn', 'id', id)
            const localVarPath = `/facilitator/sessions/{id}/live/turns/text`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitatorTypedTurnBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacilitatorLiveApi - functional programming interface
 * @export
 */
export const FacilitatorLiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacilitatorLiveApiAxiosParamCreator(configuration)
    return {
        /**
         * Answer the inactivity prompt with Continue
         * @summary Answer the inactivity prompt with Continue
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgeFacilitatorActivity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgeFacilitatorActivity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.acknowledgeFacilitatorActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * I\'m okay to continue
         * @summary I\'m okay to continue
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueFacilitatorAfterCrisis(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueFacilitatorAfterCrisis(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.continueFacilitatorAfterCrisis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * wrap_up ends with the final synthesis; keep_going / timeout continue the session.
         * @summary Answer the AI\'s wrap-up offer
         * @param {string} id 
         * @param {FacilitatorWrapUpBody} [facilitatorWrapUpBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decideFacilitatorWrapUp(id: string, facilitatorWrapUpBody?: FacilitatorWrapUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decideFacilitatorWrapUp(id, facilitatorWrapUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.decideFacilitatorWrapUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently deletes the session. Cannot be recovered.
         * @summary Discard an interrupted session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discardFacilitatorLive(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discardFacilitatorLive(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.discardFacilitatorLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Either person can end it. Generates summaries and sends the post-session check-in.
         * @summary End the session
         * @param {string} id 
         * @param {FacilitatorEndBody} [facilitatorEndBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endFacilitatorLive(id: string, facilitatorEndBody?: FacilitatorEndBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endFacilitatorLive(id, facilitatorEndBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.endFacilitatorLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds 15 or 30 minutes, up to 2 hours total.
         * @summary Extend the session (host, last 5 minutes)
         * @param {string} id 
         * @param {FacilitatorExtendBody} [facilitatorExtendBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendFacilitatorLive(id: string, facilitatorExtendBody?: FacilitatorExtendBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendFacilitatorLive(id, facilitatorExtendBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.extendFacilitatorLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Quiet for 10 minutes: prompt, then auto-end
         * @summary Quiet for 10 minutes: prompt, then auto-end
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitatorInactivityCheck(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitatorInactivityCheck(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.facilitatorInactivityCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Timer reached zero: final synthesis, then grace period
         * @summary Timer reached zero: final synthesis, then grace period
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitatorTimeUp(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitatorTimeUp(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.facilitatorTimeUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Host: timer, turn, prompts and thread. Invitee: session only (it runs on the host\'s phone).
         * @summary Get the live session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilitatorLive(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilitatorLive(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.getFacilitatorLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * MP3 of one facilitator message, generated on request and never stored. Available until the transcript is purged.
         * @summary A facilitator message read aloud (host)
         * @param {string} id 
         * @param {number} seq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFacilitatorMessageSpeech(id: string, seq: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFacilitatorMessageSpeech(id, seq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.getFacilitatorMessageSpeech']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For the \"Resume session?\" prompt on app open.
         * @summary Sessions left in progress (host)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInterruptedFacilitatorSessions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorInterruptedSessionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInterruptedFacilitatorSessions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.listInterruptedFacilitatorSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Take a break
         * @summary Take a break
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseFacilitatorLive(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseFacilitatorLive(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.pauseFacilitatorLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resume after a break (AI recap)
         * @summary Resume after a break (AI recap)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeFacilitatorLive(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeFacilitatorLive(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.resumeFacilitatorLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry the facilitator reply
         * @summary Retry the facilitator reply
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryFacilitatorReply(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryFacilitatorReply(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.retryFacilitatorReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin the session (opening message)
         * @summary Begin the session (opening message)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startFacilitatorLive(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startFacilitatorLive(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.startFacilitatorLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * multipart/form-data with an `audio` file (m4a/aac/wav/webm, max 10 MB). Transcribed, then the AI replies.
         * @summary Submit a spoken turn (audio)
         * @param {string} id 
         * @param {File} audio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFacilitatorSpokenTurn(id: string, audio: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFacilitatorSpokenTurn(id, audio, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.submitFacilitatorSpokenTurn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fallback when the microphone is unavailable.
         * @summary Submit a typed turn
         * @param {string} id 
         * @param {FacilitatorTypedTurnBody} [facilitatorTypedTurnBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFacilitatorTypedTurn(id: string, facilitatorTypedTurnBody?: FacilitatorTypedTurnBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitatorLiveResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFacilitatorTypedTurn(id, facilitatorTypedTurnBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacilitatorLiveApi.submitFacilitatorTypedTurn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacilitatorLiveApi - factory interface
 * @export
 */
export const FacilitatorLiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacilitatorLiveApiFp(configuration)
    return {
        /**
         * Answer the inactivity prompt with Continue
         * @summary Answer the inactivity prompt with Continue
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeFacilitatorActivity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.acknowledgeFacilitatorActivity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * I\'m okay to continue
         * @summary I\'m okay to continue
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueFacilitatorAfterCrisis(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.continueFacilitatorAfterCrisis(id, options).then((request) => request(axios, basePath));
        },
        /**
         * wrap_up ends with the final synthesis; keep_going / timeout continue the session.
         * @summary Answer the AI\'s wrap-up offer
         * @param {string} id 
         * @param {FacilitatorWrapUpBody} [facilitatorWrapUpBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decideFacilitatorWrapUp(id: string, facilitatorWrapUpBody?: FacilitatorWrapUpBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.decideFacilitatorWrapUp(id, facilitatorWrapUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes the session. Cannot be recovered.
         * @summary Discard an interrupted session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardFacilitatorLive(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.discardFacilitatorLive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Either person can end it. Generates summaries and sends the post-session check-in.
         * @summary End the session
         * @param {string} id 
         * @param {FacilitatorEndBody} [facilitatorEndBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endFacilitatorLive(id: string, facilitatorEndBody?: FacilitatorEndBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.endFacilitatorLive(id, facilitatorEndBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds 15 or 30 minutes, up to 2 hours total.
         * @summary Extend the session (host, last 5 minutes)
         * @param {string} id 
         * @param {FacilitatorExtendBody} [facilitatorExtendBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendFacilitatorLive(id: string, facilitatorExtendBody?: FacilitatorExtendBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.extendFacilitatorLive(id, facilitatorExtendBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Quiet for 10 minutes: prompt, then auto-end
         * @summary Quiet for 10 minutes: prompt, then auto-end
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitatorInactivityCheck(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.facilitatorInactivityCheck(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Timer reached zero: final synthesis, then grace period
         * @summary Timer reached zero: final synthesis, then grace period
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitatorTimeUp(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.facilitatorTimeUp(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Host: timer, turn, prompts and thread. Invitee: session only (it runs on the host\'s phone).
         * @summary Get the live session
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorLive(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.getFacilitatorLive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * MP3 of one facilitator message, generated on request and never stored. Available until the transcript is purged.
         * @summary A facilitator message read aloud (host)
         * @param {string} id 
         * @param {number} seq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitatorMessageSpeech(id: string, seq: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getFacilitatorMessageSpeech(id, seq, options).then((request) => request(axios, basePath));
        },
        /**
         * For the \"Resume session?\" prompt on app open.
         * @summary Sessions left in progress (host)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterruptedFacilitatorSessions(options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorInterruptedSessionsResponse> {
            return localVarFp.listInterruptedFacilitatorSessions(options).then((request) => request(axios, basePath));
        },
        /**
         * Take a break
         * @summary Take a break
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseFacilitatorLive(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.pauseFacilitatorLive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Resume after a break (AI recap)
         * @summary Resume after a break (AI recap)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeFacilitatorLive(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.resumeFacilitatorLive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry the facilitator reply
         * @summary Retry the facilitator reply
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFacilitatorReply(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.retryFacilitatorReply(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin the session (opening message)
         * @summary Begin the session (opening message)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startFacilitatorLive(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.startFacilitatorLive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * multipart/form-data with an `audio` file (m4a/aac/wav/webm, max 10 MB). Transcribed, then the AI replies.
         * @summary Submit a spoken turn (audio)
         * @param {string} id 
         * @param {File} audio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorSpokenTurn(id: string, audio: File, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.submitFacilitatorSpokenTurn(id, audio, options).then((request) => request(axios, basePath));
        },
        /**
         * Fallback when the microphone is unavailable.
         * @summary Submit a typed turn
         * @param {string} id 
         * @param {FacilitatorTypedTurnBody} [facilitatorTypedTurnBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFacilitatorTypedTurn(id: string, facilitatorTypedTurnBody?: FacilitatorTypedTurnBody, options?: RawAxiosRequestConfig): AxiosPromise<FacilitatorLiveResultResponse> {
            return localVarFp.submitFacilitatorTypedTurn(id, facilitatorTypedTurnBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FacilitatorLiveApi - object-oriented interface
 * @export
 * @class FacilitatorLiveApi
 * @extends {BaseAPI}
 */
export class FacilitatorLiveApi extends BaseAPI {
    /**
     * Answer the inactivity prompt with Continue
     * @summary Answer the inactivity prompt with Continue
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public acknowledgeFacilitatorActivity(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).acknowledgeFacilitatorActivity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * I\'m okay to continue
     * @summary I\'m okay to continue
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public continueFacilitatorAfterCrisis(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).continueFacilitatorAfterCrisis(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * wrap_up ends with the final synthesis; keep_going / timeout continue the session.
     * @summary Answer the AI\'s wrap-up offer
     * @param {string} id 
     * @param {FacilitatorWrapUpBody} [facilitatorWrapUpBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public decideFacilitatorWrapUp(id: string, facilitatorWrapUpBody?: FacilitatorWrapUpBody, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).decideFacilitatorWrapUp(id, facilitatorWrapUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently deletes the session. Cannot be recovered.
     * @summary Discard an interrupted session
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public discardFacilitatorLive(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).discardFacilitatorLive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Either person can end it. Generates summaries and sends the post-session check-in.
     * @summary End the session
     * @param {string} id 
     * @param {FacilitatorEndBody} [facilitatorEndBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public endFacilitatorLive(id: string, facilitatorEndBody?: FacilitatorEndBody, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).endFacilitatorLive(id, facilitatorEndBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds 15 or 30 minutes, up to 2 hours total.
     * @summary Extend the session (host, last 5 minutes)
     * @param {string} id 
     * @param {FacilitatorExtendBody} [facilitatorExtendBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public extendFacilitatorLive(id: string, facilitatorExtendBody?: FacilitatorExtendBody, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).extendFacilitatorLive(id, facilitatorExtendBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Quiet for 10 minutes: prompt, then auto-end
     * @summary Quiet for 10 minutes: prompt, then auto-end
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public facilitatorInactivityCheck(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).facilitatorInactivityCheck(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Timer reached zero: final synthesis, then grace period
     * @summary Timer reached zero: final synthesis, then grace period
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public facilitatorTimeUp(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).facilitatorTimeUp(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Host: timer, turn, prompts and thread. Invitee: session only (it runs on the host\'s phone).
     * @summary Get the live session
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public getFacilitatorLive(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).getFacilitatorLive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * MP3 of one facilitator message, generated on request and never stored. Available until the transcript is purged.
     * @summary A facilitator message read aloud (host)
     * @param {string} id 
     * @param {number} seq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public getFacilitatorMessageSpeech(id: string, seq: number, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).getFacilitatorMessageSpeech(id, seq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For the \"Resume session?\" prompt on app open.
     * @summary Sessions left in progress (host)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public listInterruptedFacilitatorSessions(options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).listInterruptedFacilitatorSessions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Take a break
     * @summary Take a break
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public pauseFacilitatorLive(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).pauseFacilitatorLive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resume after a break (AI recap)
     * @summary Resume after a break (AI recap)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public resumeFacilitatorLive(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).resumeFacilitatorLive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry the facilitator reply
     * @summary Retry the facilitator reply
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public retryFacilitatorReply(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).retryFacilitatorReply(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin the session (opening message)
     * @summary Begin the session (opening message)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public startFacilitatorLive(id: string, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).startFacilitatorLive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * multipart/form-data with an `audio` file (m4a/aac/wav/webm, max 10 MB). Transcribed, then the AI replies.
     * @summary Submit a spoken turn (audio)
     * @param {string} id 
     * @param {File} audio 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public submitFacilitatorSpokenTurn(id: string, audio: File, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).submitFacilitatorSpokenTurn(id, audio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fallback when the microphone is unavailable.
     * @summary Submit a typed turn
     * @param {string} id 
     * @param {FacilitatorTypedTurnBody} [facilitatorTypedTurnBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorLiveApi
     */
    public submitFacilitatorTypedTurn(id: string, facilitatorTypedTurnBody?: FacilitatorTypedTurnBody, options?: RawAxiosRequestConfig) {
        return FacilitatorLiveApiFp(this.configuration).submitFacilitatorTypedTurn(id, facilitatorTypedTurnBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JournalApi - axios parameter creator
 * @export
 */
export const JournalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new manual journal entry.
         * @summary Create journal entry
         * @param {JournalCreateBody} [journalCreateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJournalEntry: async (journalCreateBody?: JournalCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/journal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(journalCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a journal entry.
         * @summary Delete journal entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJournalEntry: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJournalEntry', 'id', id)
            const localVarPath = `/journal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a single journal entry by ID.
         * @summary Get journal entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntry: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJournalEntry', 'id', id)
            const localVarPath = `/journal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a paginated list of journal entries with optional filters for entry type, exercise type, depth level, and favorites.
         * @summary List journal entries
         * @param {EntryType} [entryType] 
         * @param {string} [exerciseType] 
         * @param {number} [depthLevel] 
         * @param {ListJournalEntriesIsFavorite} [isFavorite] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalEntries: async (entryType?: EntryType, exerciseType?: string, depthLevel?: number, isFavorite?: ListJournalEntriesIsFavorite, limit?: number, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/journal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entryType !== undefined) {
                localVarQueryParameter['entryType'] = entryType;
            }

            if (exerciseType !== undefined) {
                localVarQueryParameter['exerciseType'] = exerciseType;
            }

            if (depthLevel !== undefined) {
                localVarQueryParameter['depthLevel'] = depthLevel;
            }

            if (isFavorite !== undefined) {
                localVarQueryParameter['isFavorite'] = isFavorite;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing journal entry.
         * @summary Update journal entry
         * @param {number} id 
         * @param {JournalUpdateBody} [journalUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJournalEntry: async (id: number, journalUpdateBody?: JournalUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJournalEntry', 'id', id)
            const localVarPath = `/journal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(journalUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JournalApi - functional programming interface
 * @export
 */
export const JournalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JournalApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new manual journal entry.
         * @summary Create journal entry
         * @param {JournalCreateBody} [journalCreateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJournalEntry(journalCreateBody?: JournalCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJournalEntry(journalCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalApi.createJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a journal entry.
         * @summary Delete journal entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJournalEntry(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalApi.deleteJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a single journal entry by ID.
         * @summary Get journal entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJournalEntry(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJournalEntry(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalApi.getJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a paginated list of journal entries with optional filters for entry type, exercise type, depth level, and favorites.
         * @summary List journal entries
         * @param {EntryType} [entryType] 
         * @param {string} [exerciseType] 
         * @param {number} [depthLevel] 
         * @param {ListJournalEntriesIsFavorite} [isFavorite] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJournalEntries(entryType?: EntryType, exerciseType?: string, depthLevel?: number, isFavorite?: ListJournalEntriesIsFavorite, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJournalEntries(entryType, exerciseType, depthLevel, isFavorite, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalApi.listJournalEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing journal entry.
         * @summary Update journal entry
         * @param {number} id 
         * @param {JournalUpdateBody} [journalUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJournalEntry(id: number, journalUpdateBody?: JournalUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJournalEntry(id, journalUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JournalApi.updateJournalEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JournalApi - factory interface
 * @export
 */
export const JournalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JournalApiFp(configuration)
    return {
        /**
         * Creates a new manual journal entry.
         * @summary Create journal entry
         * @param {JournalCreateBody} [journalCreateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJournalEntry(journalCreateBody?: JournalCreateBody, options?: RawAxiosRequestConfig): AxiosPromise<JournalEntryResponse> {
            return localVarFp.createJournalEntry(journalCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a journal entry.
         * @summary Delete journal entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJournalEntry(id: number, options?: RawAxiosRequestConfig): AxiosPromise<JournalDeleteResponse> {
            return localVarFp.deleteJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a single journal entry by ID.
         * @summary Get journal entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntry(id: number, options?: RawAxiosRequestConfig): AxiosPromise<JournalEntryResponse> {
            return localVarFp.getJournalEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a paginated list of journal entries with optional filters for entry type, exercise type, depth level, and favorites.
         * @summary List journal entries
         * @param {EntryType} [entryType] 
         * @param {string} [exerciseType] 
         * @param {number} [depthLevel] 
         * @param {ListJournalEntriesIsFavorite} [isFavorite] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalEntries(entryType?: EntryType, exerciseType?: string, depthLevel?: number, isFavorite?: ListJournalEntriesIsFavorite, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<JournalListResponse> {
            return localVarFp.listJournalEntries(entryType, exerciseType, depthLevel, isFavorite, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing journal entry.
         * @summary Update journal entry
         * @param {number} id 
         * @param {JournalUpdateBody} [journalUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJournalEntry(id: number, journalUpdateBody?: JournalUpdateBody, options?: RawAxiosRequestConfig): AxiosPromise<JournalEntryResponse> {
            return localVarFp.updateJournalEntry(id, journalUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JournalApi - object-oriented interface
 * @export
 * @class JournalApi
 * @extends {BaseAPI}
 */
export class JournalApi extends BaseAPI {
    /**
     * Creates a new manual journal entry.
     * @summary Create journal entry
     * @param {JournalCreateBody} [journalCreateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    public createJournalEntry(journalCreateBody?: JournalCreateBody, options?: RawAxiosRequestConfig) {
        return JournalApiFp(this.configuration).createJournalEntry(journalCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a journal entry.
     * @summary Delete journal entry
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    public deleteJournalEntry(id: number, options?: RawAxiosRequestConfig) {
        return JournalApiFp(this.configuration).deleteJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a single journal entry by ID.
     * @summary Get journal entry
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    public getJournalEntry(id: number, options?: RawAxiosRequestConfig) {
        return JournalApiFp(this.configuration).getJournalEntry(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a paginated list of journal entries with optional filters for entry type, exercise type, depth level, and favorites.
     * @summary List journal entries
     * @param {EntryType} [entryType] 
     * @param {string} [exerciseType] 
     * @param {number} [depthLevel] 
     * @param {ListJournalEntriesIsFavorite} [isFavorite] 
     * @param {number} [limit] 
     * @param {number | null} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    public listJournalEntries(entryType?: EntryType, exerciseType?: string, depthLevel?: number, isFavorite?: ListJournalEntriesIsFavorite, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig) {
        return JournalApiFp(this.configuration).listJournalEntries(entryType, exerciseType, depthLevel, isFavorite, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing journal entry.
     * @summary Update journal entry
     * @param {number} id 
     * @param {JournalUpdateBody} [journalUpdateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    public updateJournalEntry(id: number, journalUpdateBody?: JournalUpdateBody, options?: RawAxiosRequestConfig) {
        return JournalApiFp(this.configuration).updateJournalEntry(id, journalUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum ListJournalEntriesIsFavorite {
    True = 'true',
    False = 'false'
}


/**
 * JourneyApi - axios parameter creator
 * @export
 */
export const JourneyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lightweight check and conditional review for a relationship\'s active journey. Called at trigger points like app state change or dashboard view.
         * @summary Check and review journey
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndReviewJourney: async (relationshipId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationshipId' is not null or undefined
            assertParamExists('checkAndReviewJourney', 'relationshipId', relationshipId)
            const localVarPath = `/journeys/relationship/{relationshipId}/check-review`
                .replace(`{${"relationshipId"}}`, encodeURIComponent(String(relationshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a new AI-powered journey for a relationship.
         * @summary Generate journey
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateJourney: async (relationshipId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationshipId' is not null or undefined
            assertParamExists('generateJourney', 'relationshipId', relationshipId)
            const localVarPath = `/journeys/relationship/{relationshipId}/generate`
                .replace(`{${"relationshipId"}}`, encodeURIComponent(String(relationshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific journey by ID.
         * @summary Get journey by ID
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyById: async (journeyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'journeyId' is not null or undefined
            assertParamExists('getJourneyById', 'journeyId', journeyId)
            const localVarPath = `/journeys/{journeyId}`
                .replace(`{${"journeyId"}}`, encodeURIComponent(String(journeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the active journey for a specific relationship.
         * @summary Get active journey for relationship
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyForRelationship: async (relationshipId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationshipId' is not null or undefined
            assertParamExists('getJourneyForRelationship', 'relationshipId', relationshipId)
            const localVarPath = `/journeys/relationship/{relationshipId}`
                .replace(`{${"relationshipId"}}`, encodeURIComponent(String(relationshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pauses an active journey.
         * @summary Pause journey
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseJourney: async (journeyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'journeyId' is not null or undefined
            assertParamExists('pauseJourney', 'journeyId', journeyId)
            const localVarPath = `/journeys/{journeyId}/pause`
                .replace(`{${"journeyId"}}`, encodeURIComponent(String(journeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resumes a paused journey.
         * @summary Resume journey
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeJourney: async (journeyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'journeyId' is not null or undefined
            assertParamExists('resumeJourney', 'journeyId', journeyId)
            const localVarPath = `/journeys/{journeyId}/resume`
                .replace(`{${"journeyId"}}`, encodeURIComponent(String(journeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Skips a step in a journey with a reason.
         * @summary Skip journey step
         * @param {number} journeyId 
         * @param {number} stepId 
         * @param {SkipStepBody} [skipStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipJourneyStep: async (journeyId: number, stepId: number, skipStepBody?: SkipStepBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'journeyId' is not null or undefined
            assertParamExists('skipJourneyStep', 'journeyId', journeyId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('skipJourneyStep', 'stepId', stepId)
            const localVarPath = `/journeys/{journeyId}/steps/{stepId}/skip`
                .replace(`{${"journeyId"}}`, encodeURIComponent(String(journeyId)))
                .replace(`{${"stepId"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skipStepBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JourneyApi - functional programming interface
 * @export
 */
export const JourneyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JourneyApiAxiosParamCreator(configuration)
    return {
        /**
         * Lightweight check and conditional review for a relationship\'s active journey. Called at trigger points like app state change or dashboard view.
         * @summary Check and review journey
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAndReviewJourney(relationshipId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAndReviewJourney(relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneyApi.checkAndReviewJourney']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a new AI-powered journey for a relationship.
         * @summary Generate journey
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateJourney(relationshipId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JourneyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateJourney(relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneyApi.generateJourney']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a specific journey by ID.
         * @summary Get journey by ID
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJourneyById(journeyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JourneyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJourneyById(journeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneyApi.getJourneyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the active journey for a specific relationship.
         * @summary Get active journey for relationship
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJourneyForRelationship(relationshipId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JourneyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJourneyForRelationship(relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneyApi.getJourneyForRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pauses an active journey.
         * @summary Pause journey
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseJourney(journeyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JourneyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseJourney(journeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneyApi.pauseJourney']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resumes a paused journey.
         * @summary Resume journey
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeJourney(journeyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JourneyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeJourney(journeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneyApi.resumeJourney']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Skips a step in a journey with a reason.
         * @summary Skip journey step
         * @param {number} journeyId 
         * @param {number} stepId 
         * @param {SkipStepBody} [skipStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipJourneyStep(journeyId: number, stepId: number, skipStepBody?: SkipStepBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkipStepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipJourneyStep(journeyId, stepId, skipStepBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JourneyApi.skipJourneyStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JourneyApi - factory interface
 * @export
 */
export const JourneyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JourneyApiFp(configuration)
    return {
        /**
         * Lightweight check and conditional review for a relationship\'s active journey. Called at trigger points like app state change or dashboard view.
         * @summary Check and review journey
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndReviewJourney(relationshipId: number, options?: RawAxiosRequestConfig): AxiosPromise<CheckReviewResponse> {
            return localVarFp.checkAndReviewJourney(relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a new AI-powered journey for a relationship.
         * @summary Generate journey
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateJourney(relationshipId: number, options?: RawAxiosRequestConfig): AxiosPromise<JourneyResponse> {
            return localVarFp.generateJourney(relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific journey by ID.
         * @summary Get journey by ID
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyById(journeyId: number, options?: RawAxiosRequestConfig): AxiosPromise<JourneyResponse> {
            return localVarFp.getJourneyById(journeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the active journey for a specific relationship.
         * @summary Get active journey for relationship
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyForRelationship(relationshipId: number, options?: RawAxiosRequestConfig): AxiosPromise<JourneyResponse> {
            return localVarFp.getJourneyForRelationship(relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Pauses an active journey.
         * @summary Pause journey
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseJourney(journeyId: number, options?: RawAxiosRequestConfig): AxiosPromise<JourneyResponse> {
            return localVarFp.pauseJourney(journeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Resumes a paused journey.
         * @summary Resume journey
         * @param {number} journeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeJourney(journeyId: number, options?: RawAxiosRequestConfig): AxiosPromise<JourneyResponse> {
            return localVarFp.resumeJourney(journeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Skips a step in a journey with a reason.
         * @summary Skip journey step
         * @param {number} journeyId 
         * @param {number} stepId 
         * @param {SkipStepBody} [skipStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipJourneyStep(journeyId: number, stepId: number, skipStepBody?: SkipStepBody, options?: RawAxiosRequestConfig): AxiosPromise<SkipStepResponse> {
            return localVarFp.skipJourneyStep(journeyId, stepId, skipStepBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JourneyApi - object-oriented interface
 * @export
 * @class JourneyApi
 * @extends {BaseAPI}
 */
export class JourneyApi extends BaseAPI {
    /**
     * Lightweight check and conditional review for a relationship\'s active journey. Called at trigger points like app state change or dashboard view.
     * @summary Check and review journey
     * @param {number} relationshipId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneyApi
     */
    public checkAndReviewJourney(relationshipId: number, options?: RawAxiosRequestConfig) {
        return JourneyApiFp(this.configuration).checkAndReviewJourney(relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a new AI-powered journey for a relationship.
     * @summary Generate journey
     * @param {number} relationshipId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneyApi
     */
    public generateJourney(relationshipId: number, options?: RawAxiosRequestConfig) {
        return JourneyApiFp(this.configuration).generateJourney(relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific journey by ID.
     * @summary Get journey by ID
     * @param {number} journeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneyApi
     */
    public getJourneyById(journeyId: number, options?: RawAxiosRequestConfig) {
        return JourneyApiFp(this.configuration).getJourneyById(journeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the active journey for a specific relationship.
     * @summary Get active journey for relationship
     * @param {number} relationshipId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneyApi
     */
    public getJourneyForRelationship(relationshipId: number, options?: RawAxiosRequestConfig) {
        return JourneyApiFp(this.configuration).getJourneyForRelationship(relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pauses an active journey.
     * @summary Pause journey
     * @param {number} journeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneyApi
     */
    public pauseJourney(journeyId: number, options?: RawAxiosRequestConfig) {
        return JourneyApiFp(this.configuration).pauseJourney(journeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resumes a paused journey.
     * @summary Resume journey
     * @param {number} journeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneyApi
     */
    public resumeJourney(journeyId: number, options?: RawAxiosRequestConfig) {
        return JourneyApiFp(this.configuration).resumeJourney(journeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Skips a step in a journey with a reason.
     * @summary Skip journey step
     * @param {number} journeyId 
     * @param {number} stepId 
     * @param {SkipStepBody} [skipStepBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneyApi
     */
    public skipJourneyStep(journeyId: number, stepId: number, skipStepBody?: SkipStepBody, options?: RawAxiosRequestConfig) {
        return JourneyApiFp(this.configuration).skipJourneyStep(journeyId, stepId, skipStepBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Newest first, cursor-paginated, with the unread count for the bell badge.
         * @summary List inbox notifications
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotifications: async (cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears the unread badge.
         * @summary Mark all notifications read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/read-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks a single notification as read.
         * @summary Mark a notification read
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationRead: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markNotificationRead', 'id', id)
            const localVarPath = `/notifications/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Binds an FCM registration token to the signed-in user (moves it if another user had it).
         * @summary Register a device push token
         * @param {RegisterPushTokenBody} [registerPushTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPushToken: async (registerPushTokenBody?: RegisterPushTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/push-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerPushTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called on sign-out so the device stops receiving this user\'s notifications.
         * @summary Unregister a device push token
         * @param {UnregisterPushTokenBody} [unregisterPushTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterPushToken: async (unregisterPushTokenBody?: UnregisterPushTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/push-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unregisterPushTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Newest first, cursor-paginated, with the unread count for the bell badge.
         * @summary List inbox notifications
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotifications(cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotifications(cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clears the unread badge.
         * @summary Mark all notifications read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllNotificationsRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkAllNotificationsReadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllNotificationsRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markAllNotificationsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks a single notification as read.
         * @summary Mark a notification read
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationRead(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationRead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markNotificationRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Binds an FCM registration token to the signed-in user (moves it if another user had it).
         * @summary Register a device push token
         * @param {RegisterPushTokenBody} [registerPushTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPushToken(registerPushTokenBody?: RegisterPushTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPushToken(registerPushTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.registerPushToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Called on sign-out so the device stops receiving this user\'s notifications.
         * @summary Unregister a device push token
         * @param {UnregisterPushTokenBody} [unregisterPushTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unregisterPushToken(unregisterPushTokenBody?: UnregisterPushTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unregisterPushToken(unregisterPushTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.unregisterPushToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Newest first, cursor-paginated, with the unread count for the bell badge.
         * @summary List inbox notifications
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotifications(cursor?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<NotificationPageResponse> {
            return localVarFp.listNotifications(cursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Clears the unread badge.
         * @summary Mark all notifications read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsRead(options?: RawAxiosRequestConfig): AxiosPromise<MarkAllNotificationsReadResponse> {
            return localVarFp.markAllNotificationsRead(options).then((request) => request(axios, basePath));
        },
        /**
         * Marks a single notification as read.
         * @summary Mark a notification read
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationRead(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markNotificationRead(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Binds an FCM registration token to the signed-in user (moves it if another user had it).
         * @summary Register a device push token
         * @param {RegisterPushTokenBody} [registerPushTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPushToken(registerPushTokenBody?: RegisterPushTokenBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerPushToken(registerPushTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Called on sign-out so the device stops receiving this user\'s notifications.
         * @summary Unregister a device push token
         * @param {UnregisterPushTokenBody} [unregisterPushTokenBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterPushToken(unregisterPushTokenBody?: UnregisterPushTokenBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unregisterPushToken(unregisterPushTokenBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Newest first, cursor-paginated, with the unread count for the bell badge.
     * @summary List inbox notifications
     * @param {string} [cursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listNotifications(cursor?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listNotifications(cursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clears the unread badge.
     * @summary Mark all notifications read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markAllNotificationsRead(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markAllNotificationsRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks a single notification as read.
     * @summary Mark a notification read
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markNotificationRead(id: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markNotificationRead(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Binds an FCM registration token to the signed-in user (moves it if another user had it).
     * @summary Register a device push token
     * @param {RegisterPushTokenBody} [registerPushTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public registerPushToken(registerPushTokenBody?: RegisterPushTokenBody, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).registerPushToken(registerPushTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called on sign-out so the device stops receiving this user\'s notifications.
     * @summary Unregister a device push token
     * @param {UnregisterPushTokenBody} [unregisterPushTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public unregisterPushToken(unregisterPushTokenBody?: UnregisterPushTokenBody, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).unregisterPushToken(unregisterPushTokenBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Completes onboarding by merging draft data into the user profile and generating personalized recommendations.
         * @summary Complete onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOnboarding: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a personalized AI question and subtitle for a specific onboarding step based on previous answers.
         * @summary Generate AI message for onboarding step
         * @param {AiMessageBody} [aiMessageBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOnboardingAiMessage: async (aiMessageBody?: AiMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/ai-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the current user\'s onboarding status including whether onboarding is needed, current step, draft data, and profile summary.
         * @summary Get onboarding status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves data for a specific onboarding step. Returns crisis resources if step 5 has urgency level \"crisis\".
         * @summary Save onboarding step
         * @param {number} step 
         * @param {SaveStepBody} [saveStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingStep: async (step: number, saveStepBody?: SaveStepBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'step' is not null or undefined
            assertParamExists('saveOnboardingStep', 'step', step)
            const localVarPath = `/onboarding/step/{step}`
                .replace(`{${"step"}}`, encodeURIComponent(String(step)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveStepBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks onboarding as skipped for the current user.
         * @summary Skip onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipOnboarding: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/skip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Completes onboarding by merging draft data into the user profile and generating personalized recommendations.
         * @summary Complete onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeOnboarding(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteOnboardingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeOnboarding(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.completeOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a personalized AI question and subtitle for a specific onboarding step based on previous answers.
         * @summary Generate AI message for onboarding step
         * @param {AiMessageBody} [aiMessageBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOnboardingAiMessage(aiMessageBody?: AiMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOnboardingAiMessage(aiMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.generateOnboardingAiMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the current user\'s onboarding status including whether onboarding is needed, current step, draft data, and profile summary.
         * @summary Get onboarding status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.getOnboardingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves data for a specific onboarding step. Returns crisis resources if step 5 has urgency level \"crisis\".
         * @summary Save onboarding step
         * @param {number} step 
         * @param {SaveStepBody} [saveStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOnboardingStep(step: number, saveStepBody?: SaveStepBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveStepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOnboardingStep(step, saveStepBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.saveOnboardingStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks onboarding as skipped for the current user.
         * @summary Skip onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipOnboarding(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkipOnboardingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipOnboarding(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.skipOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * Completes onboarding by merging draft data into the user profile and generating personalized recommendations.
         * @summary Complete onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOnboarding(options?: RawAxiosRequestConfig): AxiosPromise<CompleteOnboardingResponse> {
            return localVarFp.completeOnboarding(options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a personalized AI question and subtitle for a specific onboarding step based on previous answers.
         * @summary Generate AI message for onboarding step
         * @param {AiMessageBody} [aiMessageBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOnboardingAiMessage(aiMessageBody?: AiMessageBody, options?: RawAxiosRequestConfig): AxiosPromise<AiMessageResponse> {
            return localVarFp.generateOnboardingAiMessage(aiMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the current user\'s onboarding status including whether onboarding is needed, current step, draft data, and profile summary.
         * @summary Get onboarding status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingStatus(options?: RawAxiosRequestConfig): AxiosPromise<OnboardingStatusResponse> {
            return localVarFp.getOnboardingStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Saves data for a specific onboarding step. Returns crisis resources if step 5 has urgency level \"crisis\".
         * @summary Save onboarding step
         * @param {number} step 
         * @param {SaveStepBody} [saveStepBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingStep(step: number, saveStepBody?: SaveStepBody, options?: RawAxiosRequestConfig): AxiosPromise<SaveStepResponse> {
            return localVarFp.saveOnboardingStep(step, saveStepBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks onboarding as skipped for the current user.
         * @summary Skip onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipOnboarding(options?: RawAxiosRequestConfig): AxiosPromise<SkipOnboardingResponse> {
            return localVarFp.skipOnboarding(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * Completes onboarding by merging draft data into the user profile and generating personalized recommendations.
     * @summary Complete onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public completeOnboarding(options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).completeOnboarding(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a personalized AI question and subtitle for a specific onboarding step based on previous answers.
     * @summary Generate AI message for onboarding step
     * @param {AiMessageBody} [aiMessageBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public generateOnboardingAiMessage(aiMessageBody?: AiMessageBody, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).generateOnboardingAiMessage(aiMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the current user\'s onboarding status including whether onboarding is needed, current step, draft data, and profile summary.
     * @summary Get onboarding status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public getOnboardingStatus(options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).getOnboardingStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves data for a specific onboarding step. Returns crisis resources if step 5 has urgency level \"crisis\".
     * @summary Save onboarding step
     * @param {number} step 
     * @param {SaveStepBody} [saveStepBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public saveOnboardingStep(step: number, saveStepBody?: SaveStepBody, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).saveOnboardingStep(step, saveStepBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks onboarding as skipped for the current user.
     * @summary Skip onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public skipOnboarding(options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).skipOnboarding(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PhoneApi - axios parameter creator
 * @export
 */
export const PhoneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks the code; on success the number is saved to the profile as verified.
         * @summary Confirm a verification code
         * @param {ConfirmPhoneVerificationBody} [confirmPhoneVerificationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPhoneVerification: async (confirmPhoneVerificationBody?: ConfirmPhoneVerificationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/phone-verification/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmPhoneVerificationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the user\'s verified number (if any) and any pending verification.
         * @summary Get phone verification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/phone-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resends a code to the number of the current pending (or locked) verification.
         * @summary Resend the verification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendPhoneVerification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/phone-verification/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a 6-digit SMS code. Also used for Resend (3 resends per 10 minutes; 60 s cooldown after 3 wrong codes).
         * @summary Send a verification code
         * @param {StartPhoneVerificationBody} [startPhoneVerificationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPhoneVerification: async (startPhoneVerificationBody?: StartPhoneVerificationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/phone-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startPhoneVerificationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhoneApi - functional programming interface
 * @export
 */
export const PhoneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhoneApiAxiosParamCreator(configuration)
    return {
        /**
         * Checks the code; on success the number is saved to the profile as verified.
         * @summary Confirm a verification code
         * @param {ConfirmPhoneVerificationBody} [confirmPhoneVerificationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmPhoneVerification(confirmPhoneVerificationBody?: ConfirmPhoneVerificationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneVerifiedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPhoneVerification(confirmPhoneVerificationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneApi.confirmPhoneVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the user\'s verified number (if any) and any pending verification.
         * @summary Get phone verification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoneStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoneStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneApi.getPhoneStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resends a code to the number of the current pending (or locked) verification.
         * @summary Resend the verification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendPhoneVerification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneVerificationStartedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendPhoneVerification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneApi.resendPhoneVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a 6-digit SMS code. Also used for Resend (3 resends per 10 minutes; 60 s cooldown after 3 wrong codes).
         * @summary Send a verification code
         * @param {StartPhoneVerificationBody} [startPhoneVerificationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startPhoneVerification(startPhoneVerificationBody?: StartPhoneVerificationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneVerificationStartedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startPhoneVerification(startPhoneVerificationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PhoneApi.startPhoneVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PhoneApi - factory interface
 * @export
 */
export const PhoneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhoneApiFp(configuration)
    return {
        /**
         * Checks the code; on success the number is saved to the profile as verified.
         * @summary Confirm a verification code
         * @param {ConfirmPhoneVerificationBody} [confirmPhoneVerificationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPhoneVerification(confirmPhoneVerificationBody?: ConfirmPhoneVerificationBody, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerifiedResponse> {
            return localVarFp.confirmPhoneVerification(confirmPhoneVerificationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the user\'s verified number (if any) and any pending verification.
         * @summary Get phone verification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneStatus(options?: RawAxiosRequestConfig): AxiosPromise<PhoneStatusResponse> {
            return localVarFp.getPhoneStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Resends a code to the number of the current pending (or locked) verification.
         * @summary Resend the verification code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendPhoneVerification(options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationStartedResponse> {
            return localVarFp.resendPhoneVerification(options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a 6-digit SMS code. Also used for Resend (3 resends per 10 minutes; 60 s cooldown after 3 wrong codes).
         * @summary Send a verification code
         * @param {StartPhoneVerificationBody} [startPhoneVerificationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPhoneVerification(startPhoneVerificationBody?: StartPhoneVerificationBody, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationStartedResponse> {
            return localVarFp.startPhoneVerification(startPhoneVerificationBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhoneApi - object-oriented interface
 * @export
 * @class PhoneApi
 * @extends {BaseAPI}
 */
export class PhoneApi extends BaseAPI {
    /**
     * Checks the code; on success the number is saved to the profile as verified.
     * @summary Confirm a verification code
     * @param {ConfirmPhoneVerificationBody} [confirmPhoneVerificationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneApi
     */
    public confirmPhoneVerification(confirmPhoneVerificationBody?: ConfirmPhoneVerificationBody, options?: RawAxiosRequestConfig) {
        return PhoneApiFp(this.configuration).confirmPhoneVerification(confirmPhoneVerificationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the user\'s verified number (if any) and any pending verification.
     * @summary Get phone verification status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneApi
     */
    public getPhoneStatus(options?: RawAxiosRequestConfig) {
        return PhoneApiFp(this.configuration).getPhoneStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resends a code to the number of the current pending (or locked) verification.
     * @summary Resend the verification code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneApi
     */
    public resendPhoneVerification(options?: RawAxiosRequestConfig) {
        return PhoneApiFp(this.configuration).resendPhoneVerification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a 6-digit SMS code. Also used for Resend (3 resends per 10 minutes; 60 s cooldown after 3 wrong codes).
     * @summary Send a verification code
     * @param {StartPhoneVerificationBody} [startPhoneVerificationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhoneApi
     */
    public startPhoneVerification(startPhoneVerificationBody?: StartPhoneVerificationBody, options?: RawAxiosRequestConfig) {
        return PhoneApiFp(this.configuration).startPhoneVerification(startPhoneVerificationBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the current user\'s profile preferences including preferred name and AI response tone.
         * @summary Get user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the current user\'s profile preferences. At least one field must be provided.
         * @summary Update user profile
         * @param {UpdateProfileBody} [updateProfileBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (updateProfileBody?: UpdateProfileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the current user\'s profile preferences including preferred name and AI response tone.
         * @summary Get user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.getProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the current user\'s profile preferences. At least one field must be provided.
         * @summary Update user profile
         * @param {UpdateProfileBody} [updateProfileBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(updateProfileBody?: UpdateProfileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(updateProfileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * Retrieves the current user\'s profile preferences including preferred name and AI response tone.
         * @summary Get user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options?: RawAxiosRequestConfig): AxiosPromise<ProfileResponse> {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the current user\'s profile preferences. At least one field must be provided.
         * @summary Update user profile
         * @param {UpdateProfileBody} [updateProfileBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(updateProfileBody?: UpdateProfileBody, options?: RawAxiosRequestConfig): AxiosPromise<ProfileResponse> {
            return localVarFp.updateProfile(updateProfileBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * Retrieves the current user\'s profile preferences including preferred name and AI response tone.
     * @summary Get user profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public getProfile(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the current user\'s profile preferences. At least one field must be provided.
     * @summary Update user profile
     * @param {UpdateProfileBody} [updateProfileBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateProfile(updateProfileBody?: UpdateProfileBody, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateProfile(updateProfileBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuizApi - axios parameter creator
 * @export
 */
export const QuizApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Completes a quiz session: scores, persists result, writes journal entry and activity.
         * @summary Complete quiz session
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeQuizSession: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeQuizSession', 'id', id)
            const localVarPath = `/quiz/sessions/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the most recent completed quiz result for a specific exercise type.
         * @summary Get latest quiz result
         * @param {QuizExerciseType} exerciseType 
         * @param {number} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestQuizResult: async (exerciseType: QuizExerciseType, relationshipId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exerciseType' is not null or undefined
            assertParamExists('getLatestQuizResult', 'exerciseType', exerciseType)
            const localVarPath = `/quiz/sessions/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (exerciseType !== undefined) {
                localVarQueryParameter['exerciseType'] = exerciseType;
            }

            if (relationshipId !== undefined) {
                localVarQueryParameter['relationshipId'] = relationshipId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific quiz session with all responses.
         * @summary Get quiz session by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizSession: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuizSession', 'id', id)
            const localVarPath = `/quiz/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves quiz status summary for exercise list display.
         * @summary Get quiz status
         * @param {QuizExerciseType} [exerciseType] 
         * @param {number} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizStatus: async (exerciseType?: QuizExerciseType, relationshipId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quiz/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (exerciseType !== undefined) {
                localVarQueryParameter['exerciseType'] = exerciseType;
            }

            if (relationshipId !== undefined) {
                localVarQueryParameter['relationshipId'] = relationshipId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a paginated list of quiz sessions for the authenticated user.
         * @summary List quiz session history
         * @param {QuizExerciseType} [exerciseType] 
         * @param {number} [relationshipId] 
         * @param {SessionStatus} [status] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuizSessions: async (exerciseType?: QuizExerciseType, relationshipId?: number, status?: SessionStatus, limit?: number, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quiz/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (exerciseType !== undefined) {
                localVarQueryParameter['exerciseType'] = exerciseType;
            }

            if (relationshipId !== undefined) {
                localVarQueryParameter['relationshipId'] = relationshipId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves quiz answers for an active session (idempotent, debounced from frontend).
         * @summary Auto-save quiz answers
         * @param {number} id 
         * @param {SaveQuizAnswersBody} [saveQuizAnswersBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQuizAnswers: async (id: number, saveQuizAnswersBody?: SaveQuizAnswersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveQuizAnswers', 'id', id)
            const localVarPath = `/quiz/sessions/{id}/answers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveQuizAnswersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a new quiz session or resumes an existing active one for the authenticated user.
         * @summary Start or resume quiz session
         * @param {StartQuizSessionBody} [startQuizSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startQuizSession: async (startQuizSessionBody?: StartQuizSessionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/quiz/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startQuizSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuizApi - functional programming interface
 * @export
 */
export const QuizApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuizApiAxiosParamCreator(configuration)
    return {
        /**
         * Completes a quiz session: scores, persists result, writes journal entry and activity.
         * @summary Complete quiz session
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeQuizSession(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeQuizSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApi.completeQuizSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the most recent completed quiz result for a specific exercise type.
         * @summary Get latest quiz result
         * @param {QuizExerciseType} exerciseType 
         * @param {number} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestQuizResult(exerciseType: QuizExerciseType, relationshipId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizLatestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestQuizResult(exerciseType, relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApi.getLatestQuizResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a specific quiz session with all responses.
         * @summary Get quiz session by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuizSession(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuizSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApi.getQuizSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves quiz status summary for exercise list display.
         * @summary Get quiz status
         * @param {QuizExerciseType} [exerciseType] 
         * @param {number} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuizStatus(exerciseType?: QuizExerciseType, relationshipId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuizStatus(exerciseType, relationshipId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApi.getQuizStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a paginated list of quiz sessions for the authenticated user.
         * @summary List quiz session history
         * @param {QuizExerciseType} [exerciseType] 
         * @param {number} [relationshipId] 
         * @param {SessionStatus} [status] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQuizSessions(exerciseType?: QuizExerciseType, relationshipId?: number, status?: SessionStatus, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQuizSessions(exerciseType, relationshipId, status, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApi.listQuizSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves quiz answers for an active session (idempotent, debounced from frontend).
         * @summary Auto-save quiz answers
         * @param {number} id 
         * @param {SaveQuizAnswersBody} [saveQuizAnswersBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveQuizAnswers(id: number, saveQuizAnswersBody?: SaveQuizAnswersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveQuizAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveQuizAnswers(id, saveQuizAnswersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApi.saveQuizAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a new quiz session or resumes an existing active one for the authenticated user.
         * @summary Start or resume quiz session
         * @param {StartQuizSessionBody} [startQuizSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startQuizSession(startQuizSessionBody?: StartQuizSessionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartQuizSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startQuizSession(startQuizSessionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApi.startQuizSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuizApi - factory interface
 * @export
 */
export const QuizApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuizApiFp(configuration)
    return {
        /**
         * Completes a quiz session: scores, persists result, writes journal entry and activity.
         * @summary Complete quiz session
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeQuizSession(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CompleteQuizResponse> {
            return localVarFp.completeQuizSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the most recent completed quiz result for a specific exercise type.
         * @summary Get latest quiz result
         * @param {QuizExerciseType} exerciseType 
         * @param {number} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestQuizResult(exerciseType: QuizExerciseType, relationshipId?: number, options?: RawAxiosRequestConfig): AxiosPromise<QuizLatestResponse> {
            return localVarFp.getLatestQuizResult(exerciseType, relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific quiz session with all responses.
         * @summary Get quiz session by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizSession(id: number, options?: RawAxiosRequestConfig): AxiosPromise<QuizSessionResponse> {
            return localVarFp.getQuizSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves quiz status summary for exercise list display.
         * @summary Get quiz status
         * @param {QuizExerciseType} [exerciseType] 
         * @param {number} [relationshipId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizStatus(exerciseType?: QuizExerciseType, relationshipId?: number, options?: RawAxiosRequestConfig): AxiosPromise<QuizStatusResponse> {
            return localVarFp.getQuizStatus(exerciseType, relationshipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a paginated list of quiz sessions for the authenticated user.
         * @summary List quiz session history
         * @param {QuizExerciseType} [exerciseType] 
         * @param {number} [relationshipId] 
         * @param {SessionStatus} [status] 
         * @param {number} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuizSessions(exerciseType?: QuizExerciseType, relationshipId?: number, status?: SessionStatus, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<QuizHistoryResponse> {
            return localVarFp.listQuizSessions(exerciseType, relationshipId, status, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Saves quiz answers for an active session (idempotent, debounced from frontend).
         * @summary Auto-save quiz answers
         * @param {number} id 
         * @param {SaveQuizAnswersBody} [saveQuizAnswersBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQuizAnswers(id: number, saveQuizAnswersBody?: SaveQuizAnswersBody, options?: RawAxiosRequestConfig): AxiosPromise<SaveQuizAnswersResponse> {
            return localVarFp.saveQuizAnswers(id, saveQuizAnswersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a new quiz session or resumes an existing active one for the authenticated user.
         * @summary Start or resume quiz session
         * @param {StartQuizSessionBody} [startQuizSessionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startQuizSession(startQuizSessionBody?: StartQuizSessionBody, options?: RawAxiosRequestConfig): AxiosPromise<StartQuizSessionResponse> {
            return localVarFp.startQuizSession(startQuizSessionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuizApi - object-oriented interface
 * @export
 * @class QuizApi
 * @extends {BaseAPI}
 */
export class QuizApi extends BaseAPI {
    /**
     * Completes a quiz session: scores, persists result, writes journal entry and activity.
     * @summary Complete quiz session
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuizApi
     */
    public completeQuizSession(id: number, options?: RawAxiosRequestConfig) {
        return QuizApiFp(this.configuration).completeQuizSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the most recent completed quiz result for a specific exercise type.
     * @summary Get latest quiz result
     * @param {QuizExerciseType} exerciseType 
     * @param {number} [relationshipId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuizApi
     */
    public getLatestQuizResult(exerciseType: QuizExerciseType, relationshipId?: number, options?: RawAxiosRequestConfig) {
        return QuizApiFp(this.configuration).getLatestQuizResult(exerciseType, relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific quiz session with all responses.
     * @summary Get quiz session by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuizApi
     */
    public getQuizSession(id: number, options?: RawAxiosRequestConfig) {
        return QuizApiFp(this.configuration).getQuizSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves quiz status summary for exercise list display.
     * @summary Get quiz status
     * @param {QuizExerciseType} [exerciseType] 
     * @param {number} [relationshipId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuizApi
     */
    public getQuizStatus(exerciseType?: QuizExerciseType, relationshipId?: number, options?: RawAxiosRequestConfig) {
        return QuizApiFp(this.configuration).getQuizStatus(exerciseType, relationshipId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a paginated list of quiz sessions for the authenticated user.
     * @summary List quiz session history
     * @param {QuizExerciseType} [exerciseType] 
     * @param {number} [relationshipId] 
     * @param {SessionStatus} [status] 
     * @param {number} [limit] 
     * @param {number | null} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuizApi
     */
    public listQuizSessions(exerciseType?: QuizExerciseType, relationshipId?: number, status?: SessionStatus, limit?: number, offset?: number | null, options?: RawAxiosRequestConfig) {
        return QuizApiFp(this.configuration).listQuizSessions(exerciseType, relationshipId, status, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves quiz answers for an active session (idempotent, debounced from frontend).
     * @summary Auto-save quiz answers
     * @param {number} id 
     * @param {SaveQuizAnswersBody} [saveQuizAnswersBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuizApi
     */
    public saveQuizAnswers(id: number, saveQuizAnswersBody?: SaveQuizAnswersBody, options?: RawAxiosRequestConfig) {
        return QuizApiFp(this.configuration).saveQuizAnswers(id, saveQuizAnswersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a new quiz session or resumes an existing active one for the authenticated user.
     * @summary Start or resume quiz session
     * @param {StartQuizSessionBody} [startQuizSessionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuizApi
     */
    public startQuizSession(startQuizSessionBody?: StartQuizSessionBody, options?: RawAxiosRequestConfig) {
        return QuizApiFp(this.configuration).startQuizSession(startQuizSessionBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RelationshipApi - axios parameter creator
 * @export
 */
export const RelationshipApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archives (soft-deletes) a relationship.
         * @summary Archive relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRelationship: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveRelationship', 'id', id)
            const localVarPath = `/relationships/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new relationship with optional initial rating.
         * @summary Create relationship
         * @param {RelationshipCreateBody} [relationshipCreateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationship: async (relationshipCreateBody?: RelationshipCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(relationshipCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a single relationship by ID.
         * @summary Get relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationship: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelationship', 'id', id)
            const localVarPath = `/relationships/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves aggregated dashboard statistics for the user\'s relationships.
         * @summary Get dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipDashboard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/relationships/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves rating history for a relationship.
         * @summary Get rating history
         * @param {number} id 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipRatings: async (id: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelationshipRatings', 'id', id)
            const localVarPath = `/relationships/{id}/ratings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all active relationships for the authenticated user.
         * @summary List relationships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelationships: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submits a new health rating for a relationship. Generates an AI insight based on the rating.
         * @summary Rate relationship
         * @param {number} id 
         * @param {RateRelationshipBody} [rateRelationshipBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateRelationship: async (id: number, rateRelationshipBody?: RateRelationshipBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rateRelationship', 'id', id)
            const localVarPath = `/relationships/{id}/rate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rateRelationshipBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing relationship.
         * @summary Update relationship
         * @param {number} id 
         * @param {RelationshipUpdateBody} [relationshipUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationship: async (id: number, relationshipUpdateBody?: RelationshipUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRelationship', 'id', id)
            const localVarPath = `/relationships/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(relationshipUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelationshipApi - functional programming interface
 * @export
 */
export const RelationshipApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelationshipApiAxiosParamCreator(configuration)
    return {
        /**
         * Archives (soft-deletes) a relationship.
         * @summary Archive relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveRelationship(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveRelationship(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.archiveRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new relationship with optional initial rating.
         * @summary Create relationship
         * @param {RelationshipCreateBody} [relationshipCreateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelationship(relationshipCreateBody?: RelationshipCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRelationship(relationshipCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.createRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a single relationship by ID.
         * @summary Get relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationship(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationship(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.getRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves aggregated dashboard statistics for the user\'s relationships.
         * @summary Get dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipDashboard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipDashboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.getRelationshipDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves rating history for a relationship.
         * @summary Get rating history
         * @param {number} id 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipRatings(id: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RatingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipRatings(id, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.getRelationshipRatings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all active relationships for the authenticated user.
         * @summary List relationships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRelationships(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRelationships(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.listRelationships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submits a new health rating for a relationship. Generates an AI insight based on the rating.
         * @summary Rate relationship
         * @param {number} id 
         * @param {RateRelationshipBody} [rateRelationshipBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rateRelationship(id: number, rateRelationshipBody?: RateRelationshipBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RateRelationshipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rateRelationship(id, rateRelationshipBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.rateRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing relationship.
         * @summary Update relationship
         * @param {number} id 
         * @param {RelationshipUpdateBody} [relationshipUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelationship(id: number, relationshipUpdateBody?: RelationshipUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelationship(id, relationshipUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationshipApi.updateRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RelationshipApi - factory interface
 * @export
 */
export const RelationshipApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelationshipApiFp(configuration)
    return {
        /**
         * Archives (soft-deletes) a relationship.
         * @summary Archive relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRelationship(id: number, options?: RawAxiosRequestConfig): AxiosPromise<RelationshipDeleteResponse> {
            return localVarFp.archiveRelationship(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new relationship with optional initial rating.
         * @summary Create relationship
         * @param {RelationshipCreateBody} [relationshipCreateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationship(relationshipCreateBody?: RelationshipCreateBody, options?: RawAxiosRequestConfig): AxiosPromise<RelationshipDetailResponse> {
            return localVarFp.createRelationship(relationshipCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a single relationship by ID.
         * @summary Get relationship
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationship(id: number, options?: RawAxiosRequestConfig): AxiosPromise<RelationshipDetailResponse> {
            return localVarFp.getRelationship(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves aggregated dashboard statistics for the user\'s relationships.
         * @summary Get dashboard stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipDashboard(options?: RawAxiosRequestConfig): AxiosPromise<DashboardResponse> {
            return localVarFp.getRelationshipDashboard(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves rating history for a relationship.
         * @summary Get rating history
         * @param {number} id 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipRatings(id: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<RatingListResponse> {
            return localVarFp.getRelationshipRatings(id, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all active relationships for the authenticated user.
         * @summary List relationships
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelationships(options?: RawAxiosRequestConfig): AxiosPromise<RelationshipListResponse> {
            return localVarFp.listRelationships(options).then((request) => request(axios, basePath));
        },
        /**
         * Submits a new health rating for a relationship. Generates an AI insight based on the rating.
         * @summary Rate relationship
         * @param {number} id 
         * @param {RateRelationshipBody} [rateRelationshipBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateRelationship(id: number, rateRelationshipBody?: RateRelationshipBody, options?: RawAxiosRequestConfig): AxiosPromise<RateRelationshipResponse> {
            return localVarFp.rateRelationship(id, rateRelationshipBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing relationship.
         * @summary Update relationship
         * @param {number} id 
         * @param {RelationshipUpdateBody} [relationshipUpdateBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelationship(id: number, relationshipUpdateBody?: RelationshipUpdateBody, options?: RawAxiosRequestConfig): AxiosPromise<RelationshipDetailResponse> {
            return localVarFp.updateRelationship(id, relationshipUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelationshipApi - object-oriented interface
 * @export
 * @class RelationshipApi
 * @extends {BaseAPI}
 */
export class RelationshipApi extends BaseAPI {
    /**
     * Archives (soft-deletes) a relationship.
     * @summary Archive relationship
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public archiveRelationship(id: number, options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).archiveRelationship(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new relationship with optional initial rating.
     * @summary Create relationship
     * @param {RelationshipCreateBody} [relationshipCreateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public createRelationship(relationshipCreateBody?: RelationshipCreateBody, options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).createRelationship(relationshipCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a single relationship by ID.
     * @summary Get relationship
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public getRelationship(id: number, options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).getRelationship(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves aggregated dashboard statistics for the user\'s relationships.
     * @summary Get dashboard stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public getRelationshipDashboard(options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).getRelationshipDashboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves rating history for a relationship.
     * @summary Get rating history
     * @param {number} id 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public getRelationshipRatings(id: number, limit?: number, options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).getRelationshipRatings(id, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all active relationships for the authenticated user.
     * @summary List relationships
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public listRelationships(options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).listRelationships(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submits a new health rating for a relationship. Generates an AI insight based on the rating.
     * @summary Rate relationship
     * @param {number} id 
     * @param {RateRelationshipBody} [rateRelationshipBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public rateRelationship(id: number, rateRelationshipBody?: RateRelationshipBody, options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).rateRelationship(id, rateRelationshipBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing relationship.
     * @summary Update relationship
     * @param {number} id 
     * @param {RelationshipUpdateBody} [relationshipUpdateBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    public updateRelationship(id: number, relationshipUpdateBody?: RelationshipUpdateBody, options?: RawAxiosRequestConfig) {
        return RelationshipApiFp(this.configuration).updateRelationship(id, relationshipUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



